//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiClientConfig } from "./ebr-api-config";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClient {

    constructor(private config: ApiClientConfig) {}

    protected getBaseUrl(defaultUrl: string): string {
        return this.config.getBaseUrl();
    }

    protected async transformOptions(options: AxiosRequestConfig): Promise<AxiosRequestConfig> {
        options.headers = {
            ...options.headers,
            ...(await this.config.getHeaders())
        };

        // Exclude Referer header as the browser’s networking stack — specifically the Fetch API / XMLHttpRequest
        // implementation inside the browser engine (Chrome, Edge, Firefox, etc.). Browsers enforce a list of
        // forbidden / unsafe request headers that JavaScript is not allowed to set manually for security reasons.
        // Referer is one of those headers. 
        if (options.headers) {
            delete options.headers["Referer"];
        }

        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: AxiosResponse, processor: (response: AxiosResponse) => Promise<any>): Promise<any> {
        // TODO: Remove commented conditional logic below via the bug ticket # 597941 once it is confirmed it is no longer needed. The issue is fixes when tested locally.
        // If your API already returns a parsed JSON object, just return it
        if (response && typeof response.data === 'object') {
            // The generated code for the processor is still calling the JSON.parse method,
            // so we need to ensure that the data is a string before calling JSON.parse.
            // This is a workaround to ensure compatibility with the generated code.
            // response.data = JSON.stringify(response.data); // Ensure data is a string for JSON.parse
        }

        // Fallback to default processor
        return processor(response);
    }
}

export class BaseEbrApiClient extends ApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:44360");

    }

    /**
     * Endpoint to a conversion factor between two currencies.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getUnitOfMeasurementConversionRates(fromSystem: UnitOfMeasureTypes, toSystem: UnitOfMeasureTypes, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetConversionRatesResponse> {
        let url_ = this.baseUrl + "/api/v3/measurement/conversion-rates/{fromSystem}/to/{toSystem}";
        if (fromSystem === undefined || fromSystem === null)
            throw new globalThis.Error("The parameter 'fromSystem' must be defined.");
        url_ = url_.replace("{fromSystem}", encodeURIComponent("" + fromSystem));
        if (toSystem === undefined || toSystem === null)
            throw new globalThis.Error("The parameter 'toSystem' must be defined.");
        url_ = url_.replace("{toSystem}", encodeURIComponent("" + toSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnitOfMeasurementConversionRates(_response));
        });
    }

    protected processGetUnitOfMeasurementConversionRates(response: AxiosResponse): Promise<GetConversionRatesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConversionRatesResponse.fromJS(resultData200);
            return Promise.resolve<GetConversionRatesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConversionRatesResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDServiceMetricsByLocation(metricType: MetricType, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricsByLocationRequest: GetServiceMetricsByLocationRequest, signal?: AbortSignal): Promise<GetServiceMetricsByLocationResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/services/{metricType}/locations/data";
        if (metricType === undefined || metricType === null)
            throw new globalThis.Error("The parameter 'metricType' must be defined.");
        url_ = url_.replace("{metricType}", encodeURIComponent("" + metricType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricsByLocationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDServiceMetricsByLocation(_response));
        });
    }

    protected processGetTVDServiceMetricsByLocation(response: AxiosResponse): Promise<GetServiceMetricsByLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricsByLocationResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricsByLocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricsByLocationResponse>(null as any);
    }

    /**
     * Endpoint to retrieve metrics based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDMetrics(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getMetricsRequest: GetMetricsRequest, signal?: AbortSignal): Promise<GetMetricsResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getMetricsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDMetrics(_response));
        });
    }

    protected processGetTVDMetrics(response: AxiosResponse): Promise<GetMetricsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMetricsResponse.fromJS(resultData200);
            return Promise.resolve<GetMetricsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMetricsResponse>(null as any);
    }

    /**
     * Endpoint to retrieve TVD program metrics for all programs based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDAllProgramMetrics(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getAllProgramMetricsRequest: GetAllProgramMetricsRequest, signal?: AbortSignal): Promise<GetAllProgramMetricsResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/programs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getAllProgramMetricsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDAllProgramMetrics(_response));
        });
    }

    protected processGetTVDAllProgramMetrics(response: AxiosResponse): Promise<GetAllProgramMetricsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllProgramMetricsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllProgramMetricsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllProgramMetricsResponse>(null as any);
    }

    /**
     * Endpoint to retrieve TVD program metrics for a specific program name based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDMetricsByProgramName(programName: string, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getMetricsByProgramNameRequest: GetMetricsByProgramNameRequest, signal?: AbortSignal): Promise<GetMetricsByProgramNameResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/programs/{programName}";
        if (programName === undefined || programName === null)
            throw new globalThis.Error("The parameter 'programName' must be defined.");
        url_ = url_.replace("{programName}", encodeURIComponent("" + programName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getMetricsByProgramNameRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDMetricsByProgramName(_response));
        });
    }

    protected processGetTVDMetricsByProgramName(response: AxiosResponse): Promise<GetMetricsByProgramNameResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMetricsByProgramNameResponse.fromJS(resultData200);
            return Promise.resolve<GetMetricsByProgramNameResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMetricsByProgramNameResponse>(null as any);
    }

    /**
     * Endpoint to retrieve Products based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDMetricsByProduct(metricType: MetricType, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getMetricsByProductRequest: GetMetricsByProductRequest, signal?: AbortSignal): Promise<GetMetricsByProductResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/metrics/{metricType}/products/data";
        if (metricType === undefined || metricType === null)
            throw new globalThis.Error("The parameter 'metricType' must be defined.");
        url_ = url_.replace("{metricType}", encodeURIComponent("" + metricType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getMetricsByProductRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDMetricsByProduct(_response));
        });
    }

    protected processGetTVDMetricsByProduct(response: AxiosResponse): Promise<GetMetricsByProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMetricsByProductResponse.fromJS(resultData200);
            return Promise.resolve<GetMetricsByProductResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMetricsByProductResponse>(null as any);
    }

    /**
     * Endpoint to retrieve Location based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDMetricsByLocation(metricType: MetricType, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getMetricsByLocationRequest: GetMetricsByLocationRequest, signal?: AbortSignal): Promise<GetMetricsByLocationResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/metrics/{metricType}/locations/data";
        if (metricType === undefined || metricType === null)
            throw new globalThis.Error("The parameter 'metricType' must be defined.");
        url_ = url_.replace("{metricType}", encodeURIComponent("" + metricType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getMetricsByLocationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDMetricsByLocation(_response));
        });
    }

    protected processGetTVDMetricsByLocation(response: AxiosResponse): Promise<GetMetricsByLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMetricsByLocationResponse.fromJS(resultData200);
            return Promise.resolve<GetMetricsByLocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMetricsByLocationResponse>(null as any);
    }

    /**
     * Endpoint to retrieve Default TVD based on the specified filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getTVDDefaultRatesEndPoint(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getDefaultRatesRequest: GetDefaultRatesRequest, signal?: AbortSignal): Promise<GetDefaultRatesResponse> {
        let url_ = this.baseUrl + "/api/v3/tvd/defaultrates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getDefaultRatesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTVDDefaultRatesEndPoint(_response));
        });
    }

    protected processGetTVDDefaultRatesEndPoint(response: AxiosResponse): Promise<GetDefaultRatesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDefaultRatesResponse.fromJS(resultData200);
            return Promise.resolve<GetDefaultRatesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDefaultRatesResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationTotalSolutionGroupsExpandedData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getTotalSolutionGroupsExpandedDataRequest: GetTotalSolutionGroupsExpandedDataRequest, signal?: AbortSignal): Promise<GetTotalSolutionGroupsExpandedDataResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/total-solution-groups-expanded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getTotalSolutionGroupsExpandedDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationTotalSolutionGroupsExpandedData(_response));
        });
    }

    protected processGetSolutionParticipationTotalSolutionGroupsExpandedData(response: AxiosResponse): Promise<GetTotalSolutionGroupsExpandedDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTotalSolutionGroupsExpandedDataResponse.fromJS(resultData200);
            return Promise.resolve<GetTotalSolutionGroupsExpandedDataResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTotalSolutionGroupsExpandedDataResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSummaryFilters(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSummaryFiltersRequest: GetSummaryFiltersRequest, signal?: AbortSignal): Promise<GetSummaryFiltersResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/summary-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSummaryFiltersRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSummaryFilters(_response));
        });
    }

    protected processGetSolutionParticipationSummaryFilters(response: AxiosResponse): Promise<GetSummaryFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSummaryFiltersResponse.fromJS(resultData200);
            return Promise.resolve<GetSummaryFiltersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSummaryFiltersResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSummaryDetailsFilters(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSummaryDetailsFiltersRequest: GetSummaryDetailsFiltersRequest, signal?: AbortSignal): Promise<GetSummaryDetailsFiltersResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/summary-details-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSummaryDetailsFiltersRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSummaryDetailsFilters(_response));
        });
    }

    protected processGetSolutionParticipationSummaryDetailsFilters(response: AxiosResponse): Promise<GetSummaryDetailsFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSummaryDetailsFiltersResponse.fromJS(resultData200);
            return Promise.resolve<GetSummaryDetailsFiltersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSummaryDetailsFiltersResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSolutionSummary(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSolutionSummaryRequest: GetSolutionSummaryRequest, signal?: AbortSignal): Promise<GetSolutionSummaryResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/solution-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSolutionSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSolutionSummary(_response));
        });
    }

    protected processGetSolutionParticipationSolutionSummary(response: AxiosResponse): Promise<GetSolutionSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSolutionSummaryResponse.fromJS(resultData200);
            return Promise.resolve<GetSolutionSummaryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSolutionSummaryResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSolutionParticipationSales(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSolutionParticipationSalesRequest: GetSolutionParticipationSalesRequest, signal?: AbortSignal): Promise<GetSolutionParticipationSalesResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/sales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSolutionParticipationSalesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSolutionParticipationSales(_response));
        });
    }

    protected processGetSolutionParticipationSolutionParticipationSales(response: AxiosResponse): Promise<GetSolutionParticipationSalesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSolutionParticipationSalesResponse.fromJS(resultData200);
            return Promise.resolve<GetSolutionParticipationSalesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSolutionParticipationSalesResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSolutionParticipationCases(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSolutionParticipationCasesRequest: GetSolutionParticipationCasesRequest, signal?: AbortSignal): Promise<GetSolutionParticipationCasesResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/cases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSolutionParticipationCasesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSolutionParticipationCases(_response));
        });
    }

    protected processGetSolutionParticipationSolutionParticipationCases(response: AxiosResponse): Promise<GetSolutionParticipationCasesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSolutionParticipationCasesResponse.fromJS(resultData200);
            return Promise.resolve<GetSolutionParticipationCasesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSolutionParticipationCasesResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationSolutionGroupsByLocation(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getSolutionGroupsByLocationRequest: GetSolutionGroupsByLocationRequest, signal?: AbortSignal): Promise<GetSolutionGroupsByLocationResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/solution-groups-by-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSolutionGroupsByLocationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationSolutionGroupsByLocation(_response));
        });
    }

    protected processGetSolutionParticipationSolutionGroupsByLocation(response: AxiosResponse): Promise<GetSolutionGroupsByLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSolutionGroupsByLocationResponse.fromJS(resultData200);
            return Promise.resolve<GetSolutionGroupsByLocationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSolutionGroupsByLocationResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationProductView(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getProductViewRequest: GetProductViewRequest, signal?: AbortSignal): Promise<GetProductViewResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getProductViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationProductView(_response));
        });
    }

    protected processGetSolutionParticipationProductView(response: AxiosResponse): Promise<GetProductViewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductViewResponse.fromJS(resultData200);
            return Promise.resolve<GetProductViewResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductViewResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationLocationView(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getLocationViewRequest: GetLocationViewRequest, signal?: AbortSignal): Promise<GetLocationViewResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getLocationViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationLocationView(_response));
        });
    }

    protected processGetSolutionParticipationLocationView(response: AxiosResponse): Promise<GetLocationViewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationViewResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationViewResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationViewResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationLocationRebateWidgetData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getLocationRebateWidgetDataRequest: GetLocationRebateWidgetDataRequest, signal?: AbortSignal): Promise<GetLocationRebateWidgetDataResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/widget-data/location-rebate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getLocationRebateWidgetDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationLocationRebateWidgetData(_response));
        });
    }

    protected processGetSolutionParticipationLocationRebateWidgetData(response: AxiosResponse): Promise<GetLocationRebateWidgetDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationRebateWidgetDataResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationRebateWidgetDataResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationRebateWidgetDataResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getSolutionParticipationLocationProductListWidgetData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getLocationProductListWidgetDataRequest: GetLocationProductListWidgetDataRequest, signal?: AbortSignal): Promise<GetLocationProductListWidgetDataResponse> {
        let url_ = this.baseUrl + "/api/v3/participation/widget-data/location-product-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getLocationProductListWidgetDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSolutionParticipationLocationProductListWidgetData(_response));
        });
    }

    protected processGetSolutionParticipationLocationProductListWidgetData(response: AxiosResponse): Promise<GetLocationProductListWidgetDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationProductListWidgetDataResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationProductListWidgetDataResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationProductListWidgetDataResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    exportSolutionParticipationSolutionGroupsData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, exportSolutionGroupsDataRequest: ExportSolutionGroupsDataRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/participation/export/solution-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSolutionGroupsDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportSolutionParticipationSolutionGroupsData(_response));
        });
    }

    protected processExportSolutionParticipationSolutionGroupsData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    exportSolutionParticipationProductData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, exportProductDataRequest: ExportProductDataRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/participation/export/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportProductDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportSolutionParticipationProductData(_response));
        });
    }

    protected processExportSolutionParticipationProductData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    exportSolutionParticipationLocationUsageData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, exportLocationUsageDataRequest: ExportLocationUsageDataRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/participation/export/location-usage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportLocationUsageDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportSolutionParticipationLocationUsageData(_response));
        });
    }

    protected processExportSolutionParticipationLocationUsageData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    exportSolutionParticipationLocationNonUsageData(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, exportLocationNonUsageDataRequest: ExportLocationNonUsageDataRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/participation/export/location-non-usage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportLocationNonUsageDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportSolutionParticipationLocationNonUsageData(_response));
        });
    }

    protected processExportSolutionParticipationLocationNonUsageData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getPolicy(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetPolicyResponse> {
        let url_ = this.baseUrl + "/api/v3/policy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPolicy(_response));
        });
    }

    protected processGetPolicy(response: AxiosResponse): Promise<GetPolicyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPolicyResponse.fromJS(resultData200);
            return Promise.resolve<GetPolicyResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPolicyResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getFilterFilterHierarchy(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, filterSet: FilterSet, signal?: AbortSignal): Promise<GetFilterHierarchyResponse> {
        let url_ = this.baseUrl + "/api/v3/filters/hierarchy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSet);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFilterFilterHierarchy(_response));
        });
    }

    protected processGetFilterFilterHierarchy(response: AxiosResponse): Promise<GetFilterHierarchyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilterHierarchyResponse.fromJS(resultData200);
            return Promise.resolve<GetFilterHierarchyResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilterHierarchyResponse>(null as any);
    }

    /**
     * Endpoint to retrieve a list of users for a specific customer.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getCustomerUsers(customerName: string, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetUsersResponse> {
        let url_ = this.baseUrl + "/api/v3/customers/{customerName}/users";
        if (customerName === undefined || customerName === null)
            throw new globalThis.Error("The parameter 'customerName' must be defined.");
        url_ = url_.replace("{customerName}", encodeURIComponent("" + customerName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomerUsers(_response));
        });
    }

    protected processGetCustomerUsers(response: AxiosResponse): Promise<GetUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersResponse>(null as any);
    }

    /**
     * Endpoint to retrieve a list of customers.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getCustomers(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetCustomersResponse> {
        let url_ = this.baseUrl + "/api/v3/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCustomers(_response));
        });
    }

    protected processGetCustomers(response: AxiosResponse): Promise<GetCustomersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomersResponse.fromJS(resultData200);
            return Promise.resolve<GetCustomersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomersResponse>(null as any);
    }

    /**
     * Endpoint to retrieve the list of available currencies.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getCurrencyCurrencies(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetCurrenciesResponse> {
        let url_ = this.baseUrl + "/api/v3/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrencyCurrencies(_response));
        });
    }

    protected processGetCurrencyCurrencies(response: AxiosResponse): Promise<GetCurrenciesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrenciesResponse.fromJS(resultData200);
            return Promise.resolve<GetCurrenciesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrenciesResponse>(null as any);
    }

    /**
     * Endpoint to a conversion factor between two currencies.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getCurrencyConversionRate(fromCurrency: RecognizedCurrencyCode, toCurrency: RecognizedCurrencyCode, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetConversionRateResponse> {
        let url_ = this.baseUrl + "/api/v3/currencies/conversion-rate/{fromCurrency}/to/{toCurrency}";
        if (fromCurrency === undefined || fromCurrency === null)
            throw new globalThis.Error("The parameter 'fromCurrency' must be defined.");
        url_ = url_.replace("{fromCurrency}", encodeURIComponent("" + fromCurrency));
        if (toCurrency === undefined || toCurrency === null)
            throw new globalThis.Error("The parameter 'toCurrency' must be defined.");
        url_ = url_.replace("{toCurrency}", encodeURIComponent("" + toCurrency));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrencyConversionRate(_response));
        });
    }

    protected processGetCurrencyConversionRate(response: AxiosResponse): Promise<GetConversionRateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConversionRateResponse.fromJS(resultData200);
            return Promise.resolve<GetConversionRateResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConversionRateResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getConfiguration(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<GetConfigurationResponse> {
        let url_ = this.baseUrl + "/api/v3/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetConfiguration(_response));
        });
    }

    protected processGetConfiguration(response: AxiosResponse): Promise<GetConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConfigurationResponse.fromJS(resultData200);
            return Promise.resolve<GetConfigurationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConfigurationResponse>(null as any);
    }

    /**
     * Stores the user's Service Insights Findings, Implications, and Next Steps in Azure Cosmos DB.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return No Content
     */
    saveServiceInsightUserServiceInsight(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, saveUserServiceInsightRequest: SaveUserServiceInsightRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v3/service-insights/save-insight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveUserServiceInsightRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveServiceInsightUserServiceInsight(_response));
        });
    }

    protected processSaveServiceInsightUserServiceInsight(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the total number of unique locations serviced for the given filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightTotalLocationsServiced(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getTotalLocationsServicedRequest: GetTotalLocationsServicedRequest, signal?: AbortSignal): Promise<GetTotalLocationsServicedResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/total-locations-serviced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getTotalLocationsServicedRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightTotalLocationsServiced(_response));
        });
    }

    protected processGetServiceInsightTotalLocationsServiced(response: AxiosResponse): Promise<GetTotalLocationsServicedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTotalLocationsServicedResponse.fromJS(resultData200);
            return Promise.resolve<GetTotalLocationsServicedResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTotalLocationsServicedResponse>(null as any);
    }

    /**
     * Retrieves the total number calls completed for the given filters.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightTotalCallsClosed(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getTotalCallsClosedRequest: GetTotalCallsClosedRequest, signal?: AbortSignal): Promise<GetTotalCallsClosedResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/total-calls-closed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getTotalCallsClosedRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightTotalCallsClosed(_response));
        });
    }

    protected processGetServiceInsightTotalCallsClosed(response: AxiosResponse): Promise<GetTotalCallsClosedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTotalCallsClosedResponse.fromJS(resultData200);
            return Promise.resolve<GetTotalCallsClosedResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTotalCallsClosedResponse>(null as any);
    }

    /**
     * Retrieves the count of each call type for a given service metric type.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightTotalCallsByType(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getTotalCallsByTypeRequest: GetTotalCallsByTypeRequest, signal?: AbortSignal): Promise<GetTotalCallsByTypeResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/total-calls-by-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getTotalCallsByTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightTotalCallsByType(_response));
        });
    }

    protected processGetServiceInsightTotalCallsByType(response: AxiosResponse): Promise<GetTotalCallsByTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTotalCallsByTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetTotalCallsByTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTotalCallsByTypeResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceMetricDetailsKpis(serviceMetricType: SICallTypes, on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricDetailsKpisRequest: GetServiceMetricDetailsKpisRequest, signal?: AbortSignal): Promise<GetServiceMetricDetailsKpisResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/details/kpi-cards/{serviceMetricType}";
        if (serviceMetricType === undefined || serviceMetricType === null)
            throw new globalThis.Error("The parameter 'serviceMetricType' must be defined.");
        url_ = url_.replace("{serviceMetricType}", encodeURIComponent("" + serviceMetricType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricDetailsKpisRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceMetricDetailsKpis(_response));
        });
    }

    protected processGetServiceInsightServiceMetricDetailsKpis(response: AxiosResponse): Promise<GetServiceMetricDetailsKpisResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricDetailsKpisResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricDetailsKpisResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricDetailsKpisResponse>(null as any);
    }

    /**
     * Retrieves the count of services per day of the specified workorder callType over the specified period of time.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceMetricByTypeByPeriod(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricByTypeByPeriodRequest: GetServiceMetricByTypeByPeriodRequest, signal?: AbortSignal): Promise<GetServiceMetricByTypeByPeriodResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/by-workorder-type/by-period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricByTypeByPeriodRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceMetricByTypeByPeriod(_response));
        });
    }

    protected processGetServiceInsightServiceMetricByTypeByPeriod(response: AxiosResponse): Promise<GetServiceMetricByTypeByPeriodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricByTypeByPeriodResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricByTypeByPeriodResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricByTypeByPeriodResponse>(null as any);
    }

    /**
     * Retrieves the count of service calls per location of the specified workorder callType.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceMetricByTypeByLocation(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricByTypeByLocationRequest: GetServiceMetricByTypeByLocationRequest, signal?: AbortSignal): Promise<GetServiceMetricByTypeByLocationResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/by-workorder-type/by-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricByTypeByLocationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceMetricByTypeByLocation(_response));
        });
    }

    protected processGetServiceInsightServiceMetricByTypeByLocation(response: AxiosResponse): Promise<GetServiceMetricByTypeByLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricByTypeByLocationResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricByTypeByLocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricByTypeByLocationResponse>(null as any);
    }

    /**
     * Retrieves the count of issues recorded across all locations for the specified set of filters and workorder callType.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceMetricByTypeByIssue(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricByTypeByIssueRequest: GetServiceMetricByTypeByIssueRequest, signal?: AbortSignal): Promise<GetServiceMetricByTypeByIssueResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/by-workorder-type/by-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricByTypeByIssueRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceMetricByTypeByIssue(_response));
        });
    }

    protected processGetServiceInsightServiceMetricByTypeByIssue(response: AxiosResponse): Promise<GetServiceMetricByTypeByIssueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricByTypeByIssueResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricByTypeByIssueResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricByTypeByIssueResponse>(null as any);
    }

    /**
     * Retrieves the top 5 observations/issues recorded, along with a list of locations per observation/issue.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceInsightsByIssueType(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceInsightsByIssueTypeRequest: GetServiceInsightsByIssueTypeRequest, signal?: AbortSignal): Promise<GetServiceInsightsByIssueTypeResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/by-issue-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceInsightsByIssueTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceInsightsByIssueType(_response));
        });
    }

    protected processGetServiceInsightServiceInsightsByIssueType(response: AxiosResponse): Promise<GetServiceInsightsByIssueTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceInsightsByIssueTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceInsightsByIssueTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceInsightsByIssueTypeResponse>(null as any);
    }

    /**
     * Retrieves Geographical and Account information for the Advanced Filters component.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceDetailFilters(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceDetailFiltersRequest: GetServiceDetailFiltersRequest, signal?: AbortSignal): Promise<GetServiceDetailFiltersResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/service-details-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceDetailFiltersRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceDetailFilters(_response));
        });
    }

    protected processGetServiceInsightServiceDetailFilters(response: AxiosResponse): Promise<GetServiceDetailFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceDetailFiltersResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceDetailFiltersResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceDetailFiltersResponse>(null as any);
    }

    /**
     * Retrieves photos for the specified filters and callType, grouped by endDate, location, or issue.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceCallPhotosByType(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceCallPhotosByTypeRequest: GetServiceCallPhotosByTypeRequest, signal?: AbortSignal): Promise<GetServiceCallPhotosByTypeResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/expanded/photos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceCallPhotosByTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceCallPhotosByType(_response));
        });
    }

    protected processGetServiceInsightServiceCallPhotosByType(response: AxiosResponse): Promise<GetServiceCallPhotosByTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceCallPhotosByTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceCallPhotosByTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceCallPhotosByTypeResponse>(null as any);
    }

    /**
     * Retrieves service call workorder details for the specified call type, grouped by endDate, location, or issue.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceCallDetailsByType(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceCallDetailsByTypeRequest: GetServiceCallDetailsByTypeRequest, signal?: AbortSignal): Promise<GetServiceCallDetailsByTypeResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/expanded/call-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceCallDetailsByTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceCallDetailsByType(_response));
        });
    }

    protected processGetServiceInsightServiceCallDetailsByType(response: AxiosResponse): Promise<GetServiceCallDetailsByTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceCallDetailsByTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceCallDetailsByTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceCallDetailsByTypeResponse>(null as any);
    }

    /**
     * Retrieves a list of all locations and their performance ratings using service metrics.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightLocationInsights(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getLocationInsightsRequest: GetLocationInsightsRequest, signal?: AbortSignal): Promise<GetLocationInsightsResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/location-insights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getLocationInsightsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightLocationInsights(_response));
        });
    }

    protected processGetServiceInsightLocationInsights(response: AxiosResponse): Promise<GetLocationInsightsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLocationInsightsResponse.fromJS(resultData200);
            return Promise.resolve<GetLocationInsightsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLocationInsightsResponse>(null as any);
    }

    /**
     * Retrieves the count, percentage change, and average per location for every tracked Service Insights
    call type, along with the Training Sessions "Details" breakdown, for the currently selected filters
    and reporting period. Intended to replace the by-period and by-type endpoints for driving the
    landing page metric cards, bar chart, and Training Breakdown details panel.
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     * @return Success
     */
    getServiceInsightServiceMetricCountsSummary(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, getServiceMetricCountsSummaryRequest: GetServiceMetricCountsSummaryRequest, signal?: AbortSignal): Promise<GetServiceMetricCountsSummaryResponse> {
        let url_ = this.baseUrl + "/api/v3/service-insights/metric-counts-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getServiceMetricCountsSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetServiceInsightServiceMetricCountsSummary(_response));
        });
    }

    protected processGetServiceInsightServiceMetricCountsSummary(response: AxiosResponse): Promise<GetServiceMetricCountsSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetServiceMetricCountsSummaryResponse.fromJS(resultData200);
            return Promise.resolve<GetServiceMetricCountsSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetServiceMetricCountsSummaryResponse>(null as any);
    }

    /**
     * @param on_Behalf_Of (optional) A header for sending the user ID (email address) of the user being impersonated.
     * @param referer (optional) A header for sending the URL of the application consumer the API.
     * @param x_Configuration_Key_Label (optional) A header for sending the configuration key label.
     */
    healthCheck_GetHealthCheck(on_Behalf_Of: string | undefined, referer: string | undefined, x_Configuration_Key_Label: string | undefined, signal?: AbortSignal): Promise<HealthCheckResult> {
        let url_ = this.baseUrl + "/api/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "On-Behalf-Of": on_Behalf_Of !== undefined && on_Behalf_Of !== null ? "" + on_Behalf_Of : "",
                "Referer": referer !== undefined && referer !== null ? "" + referer : "",
                "X-Configuration-Key-Label": x_Configuration_Key_Label !== undefined && x_Configuration_Key_Label !== null ? "" + x_Configuration_Key_Label : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHealthCheck_GetHealthCheck(_response));
        });
    }

    protected processHealthCheck_GetHealthCheck(response: AxiosResponse): Promise<HealthCheckResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HealthCheckResult.fromJS(resultData200);
            return Promise.resolve<HealthCheckResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HealthCheckResult>(null as any);
    }
}

/** Response model for the GetConversionRates endpoint. */
export class GetConversionRatesResponse implements IGetConversionRatesResponse {
    data?: MeasurementSystemConversionRates | undefined;

    constructor(data?: IGetConversionRatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MeasurementSystemConversionRates.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConversionRatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversionRatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

/** Response model for the GetConversionRates endpoint. */
export interface IGetConversionRatesResponse {
    data?: MeasurementSystemConversionRates | undefined;
}

export class MeasurementSystemConversionRates implements IMeasurementSystemConversionRates {
    fromMeasurementSystem!: UnitOfMeasureTypes;
    toMeasurementSystem!: UnitOfMeasureTypes;
    conversionRates?: UoMConversionRate[] | undefined;

    constructor(data?: IMeasurementSystemConversionRates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromMeasurementSystem = _data["fromMeasurementSystem"];
            this.toMeasurementSystem = _data["toMeasurementSystem"];
            if (Array.isArray(_data["conversionRates"])) {
                this.conversionRates = [] as any;
                for (let item of _data["conversionRates"])
                    this.conversionRates!.push(UoMConversionRate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementSystemConversionRates {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSystemConversionRates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromMeasurementSystem"] = this.fromMeasurementSystem;
        data["toMeasurementSystem"] = this.toMeasurementSystem;
        if (Array.isArray(this.conversionRates)) {
            data["conversionRates"] = [];
            for (let item of this.conversionRates)
                data["conversionRates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeasurementSystemConversionRates {
    fromMeasurementSystem: UnitOfMeasureTypes;
    toMeasurementSystem: UnitOfMeasureTypes;
    conversionRates?: UoMConversionRate[] | undefined;
}

export enum UnitOfMeasureTypes {
    Imperial = "Imperial",
    Metric = "Metric",
}

export class UoMConversionRate implements IUoMConversionRate {
    id?: string | undefined;
    fromUomDescription?: string | undefined;
    toUomDescription?: string | undefined;
    conversionFactor!: number;

    constructor(data?: IUoMConversionRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromUomDescription = _data["fromUomDescription"];
            this.toUomDescription = _data["toUomDescription"];
            this.conversionFactor = _data["conversionFactor"];
        }
    }

    static fromJS(data: any): UoMConversionRate {
        data = typeof data === 'object' ? data : {};
        let result = new UoMConversionRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromUomDescription"] = this.fromUomDescription;
        data["toUomDescription"] = this.toUomDescription;
        data["conversionFactor"] = this.conversionFactor;
        return data;
    }
}

export interface IUoMConversionRate {
    id?: string | undefined;
    fromUomDescription?: string | undefined;
    toUomDescription?: string | undefined;
    conversionFactor: number;
}

/** Request model for the GetConversionRates endpoint. */
export class GetConversionRatesRequest implements IGetConversionRatesRequest {

    constructor(data?: IGetConversionRatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetConversionRatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversionRatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for the GetConversionRates endpoint. */
export interface IGetConversionRatesRequest {
}

export class GetServiceMetricsByLocationResponse implements IGetServiceMetricsByLocationResponse {
    data?: TVDServicesByLocationModel | undefined;

    constructor(data?: IGetServiceMetricsByLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TVDServicesByLocationModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceMetricsByLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricsByLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricsByLocationResponse {
    data?: TVDServicesByLocationModel | undefined;
}

export class TVDServicesByLocationModel implements ITVDServicesByLocationModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of services provided based on the applied filter */
    totalServices?: string | undefined;
    /** The average cost per service, differs based on the metric type */
    avgPerServiceCost?: string | undefined;
    /** Optional summation for services that have 3 factors. 
i.e. "Total Number of Rodent No Charge Services" for the "No Charge Additional Services" metric", and
"$ Value invoiced" for the "Set-up Services" metric */
    secondaryMetricSum?: string | undefined;
    /** The locations with info based on the TVD metric */
    locationRows?: TVDServiceByLocationDataRow[] | undefined;

    constructor(data?: ITVDServicesByLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricType = _data["metricType"];
            this.metricUnit = _data["metricUnit"];
            this.totalLocations = _data["totalLocations"];
            this.totalServices = _data["totalServices"];
            this.avgPerServiceCost = _data["avgPerServiceCost"];
            this.secondaryMetricSum = _data["secondaryMetricSum"];
            if (Array.isArray(_data["locationRows"])) {
                this.locationRows = [] as any;
                for (let item of _data["locationRows"])
                    this.locationRows!.push(TVDServiceByLocationDataRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDServicesByLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TVDServicesByLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricType"] = this.metricType;
        data["metricUnit"] = this.metricUnit;
        data["totalLocations"] = this.totalLocations;
        data["totalServices"] = this.totalServices;
        data["avgPerServiceCost"] = this.avgPerServiceCost;
        data["secondaryMetricSum"] = this.secondaryMetricSum;
        if (Array.isArray(this.locationRows)) {
            data["locationRows"] = [];
            for (let item of this.locationRows)
                data["locationRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDServicesByLocationModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of services provided based on the applied filter */
    totalServices?: string | undefined;
    /** The average cost per service, differs based on the metric type */
    avgPerServiceCost?: string | undefined;
    /** Optional summation for services that have 3 factors. 
i.e. "Total Number of Rodent No Charge Services" for the "No Charge Additional Services" metric", and
"$ Value invoiced" for the "Set-up Services" metric */
    secondaryMetricSum?: string | undefined;
    /** The locations with info based on the TVD metric */
    locationRows?: TVDServiceByLocationDataRow[] | undefined;
}

/** Contains the common properties for the TVD detail page rows */
export class TVDDetailRow implements ITVDDetailRow {
    /** Total estimate (dollars) for a TVD metric for the table row represented */
    estimatedMetricDollars!: number;
    /** Total estimate (quantity) for a TVD metric for the table row represented */
    estimatedMetricQuantity!: number;
    modifiedEstimatedMetricDollars!: number;
    /** Represents the percent contribution of this table row to the total metric value */
    percentOfTotal!: number;

    constructor(data?: ITVDDetailRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedMetricDollars = _data["estimatedMetricDollars"];
            this.estimatedMetricQuantity = _data["estimatedMetricQuantity"];
            this.modifiedEstimatedMetricDollars = _data["modifiedEstimatedMetricDollars"];
            this.percentOfTotal = _data["percentOfTotal"];
        }
    }

    static fromJS(data: any): TVDDetailRow {
        data = typeof data === 'object' ? data : {};
        let result = new TVDDetailRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedMetricDollars"] = this.estimatedMetricDollars;
        data["estimatedMetricQuantity"] = this.estimatedMetricQuantity;
        data["modifiedEstimatedMetricDollars"] = this.modifiedEstimatedMetricDollars;
        data["percentOfTotal"] = this.percentOfTotal;
        return data;
    }
}

/** Contains the common properties for the TVD detail page rows */
export interface ITVDDetailRow {
    /** Total estimate (dollars) for a TVD metric for the table row represented */
    estimatedMetricDollars: number;
    /** Total estimate (quantity) for a TVD metric for the table row represented */
    estimatedMetricQuantity: number;
    modifiedEstimatedMetricDollars: number;
    /** Represents the percent contribution of this table row to the total metric value */
    percentOfTotal: number;
}

export class TVDServiceByLocationDataRow extends TVDDetailRow implements ITVDServiceByLocationDataRow {
    /** Service Account Id of the location represented */
    serviceAccountId?: string | undefined;
    /** Service Account Name of the location represented
  */
    serviceAccountName?: string | undefined;
    /** Street Address of the location represented */
    streetAddress?: string | undefined;
    /** City of the location represented */
    city?: string | undefined;
    /** State of the location represented */
    state?: string | undefined;
    /** Zip code of the location represented */
    zipCode?: string | undefined;
    /** Country code of the location represented */
    countryCode?: string | undefined;
    /** Optional Secondary metric. 
 i.e. "Number of Rodent No Charge Services" for the "No Charge Additional Services" metric",
 and "$ Value invoiced" for the "Set-up Services" metric */
    estimatedSecondaryMetricQuantity?: number | undefined;

    constructor(data?: ITVDServiceByLocationDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceAccountId = _data["serviceAccountId"];
            this.serviceAccountName = _data["serviceAccountName"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryCode = _data["countryCode"];
            this.estimatedSecondaryMetricQuantity = _data["estimatedSecondaryMetricQuantity"];
        }
    }

    static override fromJS(data: any): TVDServiceByLocationDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new TVDServiceByLocationDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceAccountId"] = this.serviceAccountId;
        data["serviceAccountName"] = this.serviceAccountName;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryCode"] = this.countryCode;
        data["estimatedSecondaryMetricQuantity"] = this.estimatedSecondaryMetricQuantity;
        super.toJSON(data);
        return data;
    }
}

export interface ITVDServiceByLocationDataRow extends ITVDDetailRow {
    /** Service Account Id of the location represented */
    serviceAccountId?: string | undefined;
    /** Service Account Name of the location represented
  */
    serviceAccountName?: string | undefined;
    /** Street Address of the location represented */
    streetAddress?: string | undefined;
    /** City of the location represented */
    city?: string | undefined;
    /** State of the location represented */
    state?: string | undefined;
    /** Zip code of the location represented */
    zipCode?: string | undefined;
    /** Country code of the location represented */
    countryCode?: string | undefined;
    /** Optional Secondary metric. 
 i.e. "Number of Rodent No Charge Services" for the "No Charge Additional Services" metric",
 and "$ Value invoiced" for the "Set-up Services" metric */
    estimatedSecondaryMetricQuantity?: number | undefined;
}

export class GetServiceMetricsByLocationRequest implements IGetServiceMetricsByLocationRequest {
    filters!: FilterSet;
    metricCostAssumptions?: MetricCostAssumptions | undefined;

    constructor(data?: IGetServiceMetricsByLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.metricCostAssumptions = _data["metricCostAssumptions"] ? MetricCostAssumptions.fromJS(_data["metricCostAssumptions"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceMetricsByLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricsByLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["metricCostAssumptions"] = this.metricCostAssumptions ? this.metricCostAssumptions.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricsByLocationRequest {
    filters: FilterSet;
    metricCostAssumptions?: MetricCostAssumptions | undefined;
}

export enum MetricType {
    Assets = "Assets",
    Water = "Water",
    Energy = "Energy",
    Productivity = "Productivity",
    Waste = "Waste",
    PlasticWaste = "PlasticWaste",
    CardboardWaste = "CardboardWaste",
    SolidWaste = "SolidWaste",
    CostAvoidance = "CostAvoidance",
    EmployeeSafety = "EmployeeSafety",
    GreenhouseGases = "GreenhouseGases",
    Co2eFromEnergyUse = "Co2eFromEnergyUse",
    Co2eFromTransportation = "Co2eFromTransportation",
    Co2eFromPackagingManufacture = "Co2eFromPackagingManufacture",
    PortfolioReduction = "PortfolioReduction",
    NoChargeAdditionalServices = "NoChargeAdditionalServices",
    SetupServices = "SetupServices",
    GeneralContractorCostAvoidance = "GeneralContractorCostAvoidance",
    PestPreventionFindings = "PestPreventionFindings",
    RoomNightsSaved = "RoomNightsSaved",
    FurniturePreservationAssets = "FurniturePreservationAssets",
    FurniturePreservationEnergy = "FurniturePreservationEnergy",
}

export class FilterSet implements IFilterSet {
    period!: TimePeriod;
    division!: Division;

    protected _discriminator: string;

    constructor(data?: IFilterSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "FilterSet";
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? TimePeriod.fromJS(_data["period"]) : undefined as any;
            this.division = _data["division"];
        }
    }

    static fromJS(data: any): FilterSet {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "InstitutionalFilterSet") {
            let result = new InstitutionalFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "CustomerFilterSet") {
            let result = new CustomerFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QsrFilterSet") {
            let result = new QsrFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DistributorFilterSet") {
            let result = new DistributorFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PestFilterSet") {
            let result = new PestFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "FrsFilterSet") {
            let result = new FrsFilterSet();
            result.init(data);
            return result;
        }
        if (data["$type"] === "OneCustomerFilterSet") {
            let result = new OneCustomerFilterSet();
            result.init(data);
            return result;
        }
        let result = new FilterSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["period"] = this.period ? this.period.toJSON() : undefined as any;
        data["division"] = this.division;
        return data;
    }
}

export interface IFilterSet {
    period: TimePeriod;
    division: Division;
}

export abstract class TimePeriod implements ITimePeriod {

    protected _discriminator: string;

    constructor(data?: ITimePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "TimePeriod";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TimePeriod {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "RollingTimePeriod") {
            let result = new RollingTimePeriod();
            result.init(data);
            return result;
        }
        if (data["$type"] === "FixedTimePeriod") {
            let result = new FixedTimePeriod();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'TimePeriod' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface ITimePeriod {
}

export class RollingTimePeriod extends TimePeriod implements IRollingTimePeriod {
    kind!: RollingTimePeriodKind;

    constructor(data?: IRollingTimePeriod) {
        super(data);
        this._discriminator = "RollingTimePeriod";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kind = _data["kind"];
        }
    }

    static override fromJS(data: any): RollingTimePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new RollingTimePeriod();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        super.toJSON(data);
        return data;
    }
}

export interface IRollingTimePeriod extends ITimePeriod {
    kind: RollingTimePeriodKind;
}

export enum RollingTimePeriodKind {
    PriorMonth = "PriorMonth",
    R3 = "R3",
    R6 = "R6",
    R12 = "R12",
    R24 = "R24",
    YTD = "YTD",
}

export class FixedTimePeriod extends TimePeriod implements IFixedTimePeriod {
    dateRange!: MonthYearOnlyRange;

    constructor(data?: IFixedTimePeriod) {
        super(data);
        if (!data) {
            this.dateRange = new MonthYearOnlyRange();
        }
        this._discriminator = "FixedTimePeriod";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateRange = _data["dateRange"] ? MonthYearOnlyRange.fromJS(_data["dateRange"]) : new MonthYearOnlyRange();
        }
    }

    static override fromJS(data: any): FixedTimePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new FixedTimePeriod();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFixedTimePeriod extends ITimePeriod {
    dateRange: MonthYearOnlyRange;
}

export class MonthYearOnlyRange implements IMonthYearOnlyRange {
    start!: MonthYearOnly;
    end!: MonthYearOnly;

    constructor(data?: IMonthYearOnlyRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.start = new MonthYearOnly();
            this.end = new MonthYearOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? MonthYearOnly.fromJS(_data["start"]) : new MonthYearOnly();
            this.end = _data["end"] ? MonthYearOnly.fromJS(_data["end"]) : new MonthYearOnly();
        }
    }

    static fromJS(data: any): MonthYearOnlyRange {
        data = typeof data === 'object' ? data : {};
        let result = new MonthYearOnlyRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : undefined as any;
        data["end"] = this.end ? this.end.toJSON() : undefined as any;
        return data;
    }
}

export interface IMonthYearOnlyRange {
    start: MonthYearOnly;
    end: MonthYearOnly;
}

export class MonthYearOnly implements IMonthYearOnly {
    year!: number;
    month!: number;

    constructor(data?: IMonthYearOnly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): MonthYearOnly {
        data = typeof data === 'object' ? data : {};
        let result = new MonthYearOnly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IMonthYearOnly {
    year: number;
    month: number;
}

export enum Division {
    Institutional = "Institutional",
    QSR = "QSR",
    Distributor = "Distributor",
    Pest = "Pest",
    FRS = "FRS",
}

export class InstitutionalFilterSet extends FilterSet implements IInstitutionalFilterSet {
    division!: Division;
    regions!: Region[];
    countries!: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IInstitutionalFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
            this.countries = [];
        }
        this._discriminator = "InstitutionalFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["topLevelContractGroups"])) {
                this.topLevelContractGroups = [] as any;
                for (let item of _data["topLevelContractGroups"])
                    this.topLevelContractGroups!.push(item);
            }
            if (Array.isArray(_data["secondLevelContracts"])) {
                this.secondLevelContracts = [] as any;
                for (let item of _data["secondLevelContracts"])
                    this.secondLevelContracts!.push(item);
            }
            if (Array.isArray(_data["accountNumbers"])) {
                this.accountNumbers = [] as any;
                for (let item of _data["accountNumbers"])
                    this.accountNumbers!.push(item);
            }
            this.excludeDeletedAccounts = _data["excludeDeletedAccounts"];
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): InstitutionalFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new InstitutionalFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.topLevelContractGroups)) {
            data["topLevelContractGroups"] = [];
            for (let item of this.topLevelContractGroups)
                data["topLevelContractGroups"].push(item);
        }
        if (Array.isArray(this.secondLevelContracts)) {
            data["secondLevelContracts"] = [];
            for (let item of this.secondLevelContracts)
                data["secondLevelContracts"].push(item);
        }
        if (Array.isArray(this.accountNumbers)) {
            data["accountNumbers"] = [];
            for (let item of this.accountNumbers)
                data["accountNumbers"].push(item);
        }
        data["excludeDeletedAccounts"] = this.excludeDeletedAccounts;
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IInstitutionalFilterSet extends IFilterSet {
    division: Division;
    regions: Region[];
    countries: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export enum Region {
    NA = "NA",
    EU = "EU",
    LA = "LA",
    AP = "AP",
    IMEA = "IMEA",
}

export class CustomerFilterSet extends FilterSet implements ICustomerFilterSet {
    division!: Division;
    regions!: Region[];
    countries!: string[];
    topLevelCustomerNames?: string[] | undefined;
    subBrands?: string[] | undefined;
    customerNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: ICustomerFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
            this.countries = [];
        }
        this._discriminator = "CustomerFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["topLevelCustomerNames"])) {
                this.topLevelCustomerNames = [] as any;
                for (let item of _data["topLevelCustomerNames"])
                    this.topLevelCustomerNames!.push(item);
            }
            if (Array.isArray(_data["subBrands"])) {
                this.subBrands = [] as any;
                for (let item of _data["subBrands"])
                    this.subBrands!.push(item);
            }
            if (Array.isArray(_data["customerNumbers"])) {
                this.customerNumbers = [] as any;
                for (let item of _data["customerNumbers"])
                    this.customerNumbers!.push(item);
            }
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): CustomerFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.topLevelCustomerNames)) {
            data["topLevelCustomerNames"] = [];
            for (let item of this.topLevelCustomerNames)
                data["topLevelCustomerNames"].push(item);
        }
        if (Array.isArray(this.subBrands)) {
            data["subBrands"] = [];
            for (let item of this.subBrands)
                data["subBrands"].push(item);
        }
        if (Array.isArray(this.customerNumbers)) {
            data["customerNumbers"] = [];
            for (let item of this.customerNumbers)
                data["customerNumbers"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerFilterSet extends IFilterSet {
    division: Division;
    regions: Region[];
    countries: string[];
    topLevelCustomerNames?: string[] | undefined;
    subBrands?: string[] | undefined;
    customerNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class QsrFilterSet extends FilterSet implements IQsrFilterSet {
    division!: Division;
    regions!: Region[];
    countries!: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IQsrFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
            this.countries = [];
        }
        this._discriminator = "QsrFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["topLevelContractGroups"])) {
                this.topLevelContractGroups = [] as any;
                for (let item of _data["topLevelContractGroups"])
                    this.topLevelContractGroups!.push(item);
            }
            if (Array.isArray(_data["secondLevelContracts"])) {
                this.secondLevelContracts = [] as any;
                for (let item of _data["secondLevelContracts"])
                    this.secondLevelContracts!.push(item);
            }
            if (Array.isArray(_data["accountNumbers"])) {
                this.accountNumbers = [] as any;
                for (let item of _data["accountNumbers"])
                    this.accountNumbers!.push(item);
            }
            this.excludeDeletedAccounts = _data["excludeDeletedAccounts"];
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): QsrFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new QsrFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.topLevelContractGroups)) {
            data["topLevelContractGroups"] = [];
            for (let item of this.topLevelContractGroups)
                data["topLevelContractGroups"].push(item);
        }
        if (Array.isArray(this.secondLevelContracts)) {
            data["secondLevelContracts"] = [];
            for (let item of this.secondLevelContracts)
                data["secondLevelContracts"].push(item);
        }
        if (Array.isArray(this.accountNumbers)) {
            data["accountNumbers"] = [];
            for (let item of this.accountNumbers)
                data["accountNumbers"].push(item);
        }
        data["excludeDeletedAccounts"] = this.excludeDeletedAccounts;
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IQsrFilterSet extends IFilterSet {
    division: Division;
    regions: Region[];
    countries: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class DistributorFilterSet extends FilterSet implements IDistributorFilterSet {
    division!: Division;
    partnerGroups?: string[] | undefined;
    distributorGroups?: string[] | undefined;
    distributorNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IDistributorFilterSet) {
        super(data);
        this._discriminator = "DistributorFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["partnerGroups"])) {
                this.partnerGroups = [] as any;
                for (let item of _data["partnerGroups"])
                    this.partnerGroups!.push(item);
            }
            if (Array.isArray(_data["distributorGroups"])) {
                this.distributorGroups = [] as any;
                for (let item of _data["distributorGroups"])
                    this.distributorGroups!.push(item);
            }
            if (Array.isArray(_data["distributorNumbers"])) {
                this.distributorNumbers = [] as any;
                for (let item of _data["distributorNumbers"])
                    this.distributorNumbers!.push(item);
            }
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): DistributorFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new DistributorFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.partnerGroups)) {
            data["partnerGroups"] = [];
            for (let item of this.partnerGroups)
                data["partnerGroups"].push(item);
        }
        if (Array.isArray(this.distributorGroups)) {
            data["distributorGroups"] = [];
            for (let item of this.distributorGroups)
                data["distributorGroups"].push(item);
        }
        if (Array.isArray(this.distributorNumbers)) {
            data["distributorNumbers"] = [];
            for (let item of this.distributorNumbers)
                data["distributorNumbers"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IDistributorFilterSet extends IFilterSet {
    division: Division;
    partnerGroups?: string[] | undefined;
    distributorGroups?: string[] | undefined;
    distributorNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class PestFilterSet extends FilterSet implements IPestFilterSet {
    division!: Division;
    regions!: Region[];
    countries!: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IPestFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
            this.countries = [];
        }
        this._discriminator = "PestFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["topLevelContractGroups"])) {
                this.topLevelContractGroups = [] as any;
                for (let item of _data["topLevelContractGroups"])
                    this.topLevelContractGroups!.push(item);
            }
            if (Array.isArray(_data["secondLevelContracts"])) {
                this.secondLevelContracts = [] as any;
                for (let item of _data["secondLevelContracts"])
                    this.secondLevelContracts!.push(item);
            }
            if (Array.isArray(_data["accountNumbers"])) {
                this.accountNumbers = [] as any;
                for (let item of _data["accountNumbers"])
                    this.accountNumbers!.push(item);
            }
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): PestFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new PestFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.topLevelContractGroups)) {
            data["topLevelContractGroups"] = [];
            for (let item of this.topLevelContractGroups)
                data["topLevelContractGroups"].push(item);
        }
        if (Array.isArray(this.secondLevelContracts)) {
            data["secondLevelContracts"] = [];
            for (let item of this.secondLevelContracts)
                data["secondLevelContracts"].push(item);
        }
        if (Array.isArray(this.accountNumbers)) {
            data["accountNumbers"] = [];
            for (let item of this.accountNumbers)
                data["accountNumbers"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IPestFilterSet extends IFilterSet {
    division: Division;
    regions: Region[];
    countries: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class FrsFilterSet extends FilterSet implements IFrsFilterSet {
    division!: Division;
    regions!: Region[];
    countries!: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IFrsFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
            this.countries = [];
        }
        this._discriminator = "FrsFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["topLevelContractGroups"])) {
                this.topLevelContractGroups = [] as any;
                for (let item of _data["topLevelContractGroups"])
                    this.topLevelContractGroups!.push(item);
            }
            if (Array.isArray(_data["secondLevelContracts"])) {
                this.secondLevelContracts = [] as any;
                for (let item of _data["secondLevelContracts"])
                    this.secondLevelContracts!.push(item);
            }
            if (Array.isArray(_data["accountNumbers"])) {
                this.accountNumbers = [] as any;
                for (let item of _data["accountNumbers"])
                    this.accountNumbers!.push(item);
            }
            this.excludeDeletedAccounts = _data["excludeDeletedAccounts"];
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): FrsFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new FrsFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.topLevelContractGroups)) {
            data["topLevelContractGroups"] = [];
            for (let item of this.topLevelContractGroups)
                data["topLevelContractGroups"].push(item);
        }
        if (Array.isArray(this.secondLevelContracts)) {
            data["secondLevelContracts"] = [];
            for (let item of this.secondLevelContracts)
                data["secondLevelContracts"].push(item);
        }
        if (Array.isArray(this.accountNumbers)) {
            data["accountNumbers"] = [];
            for (let item of this.accountNumbers)
                data["accountNumbers"].push(item);
        }
        data["excludeDeletedAccounts"] = this.excludeDeletedAccounts;
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IFrsFilterSet extends IFilterSet {
    division: Division;
    regions: Region[];
    countries: string[];
    topLevelContractGroups?: string[] | undefined;
    secondLevelContracts?: string[] | undefined;
    accountNumbers?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class OneCustomerFilterSet extends FilterSet implements IOneCustomerFilterSet {
    regions!: Region[];
    division!: Division;
    customerName!: string;
    operatingType?: string | undefined;
    operatingSubType?: string[] | undefined;
    customerGroup?: CustomerGroup | undefined;
    ecolabGroup?: EcolabGroup | undefined;
    customerIndustry?: CustomerIndustry | undefined;
    campuses?: string[] | undefined;
    sites?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;

    constructor(data?: IOneCustomerFilterSet) {
        super(data);
        if (!data) {
            this.regions = [];
        }
        this._discriminator = "OneCustomerFilterSet";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            this.division = _data["division"];
            this.customerName = _data["customerName"];
            this.operatingType = _data["operatingType"];
            if (Array.isArray(_data["operatingSubType"])) {
                this.operatingSubType = [] as any;
                for (let item of _data["operatingSubType"])
                    this.operatingSubType!.push(item);
            }
            this.customerGroup = _data["customerGroup"] ? CustomerGroup.fromJS(_data["customerGroup"]) : undefined as any;
            this.ecolabGroup = _data["ecolabGroup"] ? EcolabGroup.fromJS(_data["ecolabGroup"]) : undefined as any;
            this.customerIndustry = _data["customerIndustry"] ? CustomerIndustry.fromJS(_data["customerIndustry"]) : undefined as any;
            if (Array.isArray(_data["campuses"])) {
                this.campuses = [] as any;
                for (let item of _data["campuses"])
                    this.campuses!.push(item);
            }
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(item);
            }
            this.excludeDeletedAccounts = _data["excludeDeletedAccounts"];
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static override fromJS(data: any): OneCustomerFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new OneCustomerFilterSet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        data["division"] = this.division;
        data["customerName"] = this.customerName;
        data["operatingType"] = this.operatingType;
        if (Array.isArray(this.operatingSubType)) {
            data["operatingSubType"] = [];
            for (let item of this.operatingSubType)
                data["operatingSubType"].push(item);
        }
        data["customerGroup"] = this.customerGroup ? this.customerGroup.toJSON() : undefined as any;
        data["ecolabGroup"] = this.ecolabGroup ? this.ecolabGroup.toJSON() : undefined as any;
        data["customerIndustry"] = this.customerIndustry ? this.customerIndustry.toJSON() : undefined as any;
        if (Array.isArray(this.campuses)) {
            data["campuses"] = [];
            for (let item of this.campuses)
                data["campuses"].push(item);
        }
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item);
        }
        data["excludeDeletedAccounts"] = this.excludeDeletedAccounts;
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        super.toJSON(data);
        return data;
    }
}

export interface IOneCustomerFilterSet extends IFilterSet {
    regions: Region[];
    division: Division;
    customerName: string;
    operatingType?: string | undefined;
    operatingSubType?: string[] | undefined;
    customerGroup?: CustomerGroup | undefined;
    ecolabGroup?: EcolabGroup | undefined;
    customerIndustry?: CustomerIndustry | undefined;
    campuses?: string[] | undefined;
    sites?: string[] | undefined;
    excludeDeletedAccounts?: boolean | undefined;
    currencyCode?: string | undefined;
    unitOfMeasure?: string | undefined;
}

export class CustomerGroup implements ICustomerGroup {
    levelOne?: string | undefined;
    levelTwo?: string | undefined;
    levelThree?: string | undefined;
    levelFour?: string | undefined;
    levelFive?: string | undefined;

    constructor(data?: ICustomerGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelOne = _data["levelOne"];
            this.levelTwo = _data["levelTwo"];
            this.levelThree = _data["levelThree"];
            this.levelFour = _data["levelFour"];
            this.levelFive = _data["levelFive"];
        }
    }

    static fromJS(data: any): CustomerGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelOne"] = this.levelOne;
        data["levelTwo"] = this.levelTwo;
        data["levelThree"] = this.levelThree;
        data["levelFour"] = this.levelFour;
        data["levelFive"] = this.levelFive;
        return data;
    }
}

export interface ICustomerGroup {
    levelOne?: string | undefined;
    levelTwo?: string | undefined;
    levelThree?: string | undefined;
    levelFour?: string | undefined;
    levelFive?: string | undefined;
}

export class EcolabGroup implements IEcolabGroup {
    region?: string | undefined;
    market?: string | undefined;
    allocationMarket?: string | undefined;
    country?: string | undefined;

    constructor(data?: IEcolabGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.market = _data["market"];
            this.allocationMarket = _data["allocationMarket"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): EcolabGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EcolabGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["market"] = this.market;
        data["allocationMarket"] = this.allocationMarket;
        data["country"] = this.country;
        return data;
    }
}

export interface IEcolabGroup {
    region?: string | undefined;
    market?: string | undefined;
    allocationMarket?: string | undefined;
    country?: string | undefined;
}

export class CustomerIndustry implements ICustomerIndustry {
    segmentationIndustryId?: string[] | undefined;
    segmentationMarketId?: string[] | undefined;
    segmentationSubMarketId?: string[] | undefined;

    constructor(data?: ICustomerIndustry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["segmentationIndustryId"])) {
                this.segmentationIndustryId = [] as any;
                for (let item of _data["segmentationIndustryId"])
                    this.segmentationIndustryId!.push(item);
            }
            if (Array.isArray(_data["segmentationMarketId"])) {
                this.segmentationMarketId = [] as any;
                for (let item of _data["segmentationMarketId"])
                    this.segmentationMarketId!.push(item);
            }
            if (Array.isArray(_data["segmentationSubMarketId"])) {
                this.segmentationSubMarketId = [] as any;
                for (let item of _data["segmentationSubMarketId"])
                    this.segmentationSubMarketId!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerIndustry {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerIndustry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segmentationIndustryId)) {
            data["segmentationIndustryId"] = [];
            for (let item of this.segmentationIndustryId)
                data["segmentationIndustryId"].push(item);
        }
        if (Array.isArray(this.segmentationMarketId)) {
            data["segmentationMarketId"] = [];
            for (let item of this.segmentationMarketId)
                data["segmentationMarketId"].push(item);
        }
        if (Array.isArray(this.segmentationSubMarketId)) {
            data["segmentationSubMarketId"] = [];
            for (let item of this.segmentationSubMarketId)
                data["segmentationSubMarketId"].push(item);
        }
        return data;
    }
}

export interface ICustomerIndustry {
    segmentationIndustryId?: string[] | undefined;
    segmentationMarketId?: string[] | undefined;
    segmentationSubMarketId?: string[] | undefined;
}

export abstract class MetricCostAssumptions implements IMetricCostAssumptions {

    protected _discriminator: string;

    constructor(data?: IMetricCostAssumptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "MetricCostAssumptions";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MetricCostAssumptions {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "FlatMetricCostAssumptions") {
            let result = new FlatMetricCostAssumptions();
            result.init(data);
            return result;
        }
        if (data["$type"] === "CountryScopedMetricCostAssumptions") {
            let result = new CountryScopedMetricCostAssumptions();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'MetricCostAssumptions' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IMetricCostAssumptions {
}

export class FlatMetricCostAssumptions extends MetricCostAssumptions implements IFlatMetricCostAssumptions {
    $type?: string;
    rates?: { [key: string]: number; } | undefined;
    isEmpty!: boolean;

    constructor(data?: IFlatMetricCostAssumptions) {
        super(data);
        if (!data) {
            this.$type = "FlatMetricCostAssumptions";
        }
        this._discriminator = "FlatMetricCostAssumptions";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.$type = _data["$type"] !== undefined ? _data["$type"] : "FlatMetricCostAssumptions";
            if (_data["rates"]) {
                this.rates = {} as any;
                for (let key in _data["rates"]) {
                    if (_data["rates"].hasOwnProperty(key))
                        (this.rates as any)![key] = _data["rates"][key];
                }
            }
            this.isEmpty = _data["isEmpty"];
        }
    }

    static override fromJS(data: any): FlatMetricCostAssumptions {
        data = typeof data === 'object' ? data : {};
        let result = new FlatMetricCostAssumptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this.$type;
        if (this.rates) {
            data["rates"] = {};
            for (let key in this.rates) {
                if (this.rates.hasOwnProperty(key))
                    (data["rates"] as any)[key] = (this.rates as any)[key];
            }
        }
        data["isEmpty"] = this.isEmpty;
        super.toJSON(data);
        return data;
    }
}

export interface IFlatMetricCostAssumptions extends IMetricCostAssumptions {
    $type?: string;
    rates?: { [key: string]: number; } | undefined;
    isEmpty: boolean;
}

export class CountryScopedMetricCostAssumptions extends MetricCostAssumptions implements ICountryScopedMetricCostAssumptions {
    $type?: string;
    countryRates?: { [key: string]: { [key: string]: number; }; } | undefined;
    isEmpty!: boolean;

    constructor(data?: ICountryScopedMetricCostAssumptions) {
        super(data);
        if (!data) {
            this.$type = "CountryScopedMetricCostAssumptions";
        }
        this._discriminator = "CountryScopedMetricCostAssumptions";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.$type = _data["$type"] !== undefined ? _data["$type"] : "CountryScopedMetricCostAssumptions";
            if (_data["countryRates"]) {
                this.countryRates = {} as any;
                for (let key in _data["countryRates"]) {
                    if (_data["countryRates"].hasOwnProperty(key))
                        (this.countryRates as any)![key] = _data["countryRates"][key] !== undefined ? _data["countryRates"][key] : {};
                }
            }
            this.isEmpty = _data["isEmpty"];
        }
    }

    static override fromJS(data: any): CountryScopedMetricCostAssumptions {
        data = typeof data === 'object' ? data : {};
        let result = new CountryScopedMetricCostAssumptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this.$type;
        if (this.countryRates) {
            data["countryRates"] = {};
            for (let key in this.countryRates) {
                if (this.countryRates.hasOwnProperty(key))
                    (data["countryRates"] as any)[key] = (this.countryRates as any)[key];
            }
        }
        data["isEmpty"] = this.isEmpty;
        super.toJSON(data);
        return data;
    }
}

export interface ICountryScopedMetricCostAssumptions extends IMetricCostAssumptions {
    $type?: string;
    countryRates?: { [key: string]: { [key: string]: number; }; } | undefined;
    isEmpty: boolean;
}

/** the dto used to send an error response to the client */
export class ErrorResponse implements IErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode!: number;
    /** the message for the error response */
    message!: string;
    /** the collection of errors for the current context */
    errors!: { [key: string]: string[]; };

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
            this.errors = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode: number;
    /** the message for the error response */
    message: string;
    /** the collection of errors for the current context */
    errors: { [key: string]: string[]; };
}

/** Response model for the GetMetrics endpoint. */
export class GetMetricsResponse implements IGetMetricsResponse {
    data?: TVDMetricGroup[] | undefined;

    constructor(data?: IGetMetricsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TVDMetricGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMetricsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response model for the GetMetrics endpoint. */
export interface IGetMetricsResponse {
    data?: TVDMetricGroup[] | undefined;
}

export class TVDMetricGroup implements ITVDMetricGroup {
    id!: TVDMetricGroupID;
    brandGroup!: BrandGroup;
    indvMetrics!: TVDMetric[];
    summMetrics!: TVDMetric[];

    constructor(data?: ITVDMetricGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.indvMetrics = [];
            this.summMetrics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brandGroup = _data["brandGroup"];
            if (Array.isArray(_data["indvMetrics"])) {
                this.indvMetrics = [] as any;
                for (let item of _data["indvMetrics"])
                    this.indvMetrics!.push(TVDMetric.fromJS(item));
            }
            if (Array.isArray(_data["summMetrics"])) {
                this.summMetrics = [] as any;
                for (let item of _data["summMetrics"])
                    this.summMetrics!.push(TVDMetric.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDMetricGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TVDMetricGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brandGroup"] = this.brandGroup;
        if (Array.isArray(this.indvMetrics)) {
            data["indvMetrics"] = [];
            for (let item of this.indvMetrics)
                data["indvMetrics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.summMetrics)) {
            data["summMetrics"] = [];
            for (let item of this.summMetrics)
                data["summMetrics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDMetricGroup {
    id: TVDMetricGroupID;
    brandGroup: BrandGroup;
    indvMetrics: TVDMetric[];
    summMetrics: TVDMetric[];
}

export enum TVDMetricGroupID {
    Default_tvd = "default_tvd",
    Smartpower = "smartpower",
    Aquanomic = "aquanomic",
    Dist_business = "dist_business",
    Pest_tvd = "pest_tvd",
    Costassumptionsmetrics = "costassumptionsmetrics",
    Pest_costassumptionsmetrics = "pest_costassumptionsmetrics",
}

export enum BrandGroup {
    All = "All",
    Ecolab = "Ecolab",
    Distributor = "Distributor",
}

export abstract class TVDMetric implements ITVDMetric {
    id!: TVDMetricID;
    sortSequenceNumber!: number;
    brand?: string | undefined;

    protected _discriminator: string;

    constructor(data?: ITVDMetric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "TVDMetric";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortSequenceNumber = _data["sortSequenceNumber"];
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): TVDMetric {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TvdCostMetric") {
            let result = new TvdCostMetric();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TvdGrowthMetric") {
            let result = new TvdGrowthMetric();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'TVDMetric' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id;
        data["sortSequenceNumber"] = this.sortSequenceNumber;
        data["brand"] = this.brand;
        return data;
    }
}

export interface ITVDMetric {
    id: TVDMetricID;
    sortSequenceNumber: number;
    brand?: string | undefined;
}

export enum TVDMetricID {
    Water = "water",
    Energy = "energy",
    Greenhouse_gases = "greenhouse_gases",
    Greenhouse_gases_energy = "greenhouse_gases_energy",
    Greenhouse_gases_transport = "greenhouse_gases_transport",
    Greenhouse_gases_packaging = "greenhouse_gases_packaging",
    Plastic_waste = "plastic_waste",
    Cardboard_waste = "cardboard_waste",
    Employee_safety = "employee_safety",
    Productivity = "productivity",
    Cost_avoidance = "cost_avoidance",
    Portfolio_reduction = "portfolio_reduction",
    Replacement = "replacement",
    Repair = "repair",
    Solid_waste = "solid_waste",
    Total_sales = "total_sales",
    Total_services = "total_services",
    Tvd_overall = "tvd_overall",
    Case_growth = "case_growth",
    Sales_growth = "sales_growth",
    Customer_growth = "customer_growth",
    Total_customers = "total_customers",
    Total_case_count = "total_case_count",
    Total_sales_dollars = "total_sales_dollars",
    Delivered_in_full_on_time = "delivered_in_full_on_time",
    Case_fill_rate = "case_fill_rate",
    Full_pallet = "full_pallet",
    Average_order_size = "average_order_size",
    No_charge_additional_services = "no_charge_additional_services",
    General_contractor_cost_avoidance = "general_contractor_cost_avoidance",
    Setup_services = "setup_services",
    Pest_prevention_findings = "pest_prevention_findings",
    Furniture_preservation_assets = "furniture_preservation_assets",
    Furniture_preservation_energy = "furniture_preservation_energy",
    Room_nights_saved = "room_nights_saved",
}

export class TvdCostMetric extends TVDMetric implements ITvdCostMetric {
    valueContribution!: string;
    monetaryContribution!: string;
    modifiedValueContribution?: string | undefined;
    modifiedMonetaryContribution?: string | undefined;

    constructor(data?: ITvdCostMetric) {
        super(data);
        this._discriminator = "TvdCostMetric";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueContribution = _data["valueContribution"];
            this.monetaryContribution = _data["monetaryContribution"];
            this.modifiedValueContribution = _data["modifiedValueContribution"];
            this.modifiedMonetaryContribution = _data["modifiedMonetaryContribution"];
        }
    }

    static override fromJS(data: any): TvdCostMetric {
        data = typeof data === 'object' ? data : {};
        let result = new TvdCostMetric();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueContribution"] = this.valueContribution;
        data["monetaryContribution"] = this.monetaryContribution;
        data["modifiedValueContribution"] = this.modifiedValueContribution;
        data["modifiedMonetaryContribution"] = this.modifiedMonetaryContribution;
        super.toJSON(data);
        return data;
    }
}

export interface ITvdCostMetric extends ITVDMetric {
    valueContribution: string;
    monetaryContribution: string;
    modifiedValueContribution?: string | undefined;
    modifiedMonetaryContribution?: string | undefined;
}

export class TvdGrowthMetric extends TVDMetric implements ITvdGrowthMetric {
    valueContribution!: string;
    monetaryContribution!: string;
    currentValue!: number;
    previousValue!: number;

    constructor(data?: ITvdGrowthMetric) {
        super(data);
        this._discriminator = "TvdGrowthMetric";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueContribution = _data["valueContribution"];
            this.monetaryContribution = _data["monetaryContribution"];
            this.currentValue = _data["currentValue"];
            this.previousValue = _data["previousValue"];
        }
    }

    static override fromJS(data: any): TvdGrowthMetric {
        data = typeof data === 'object' ? data : {};
        let result = new TvdGrowthMetric();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueContribution"] = this.valueContribution;
        data["monetaryContribution"] = this.monetaryContribution;
        data["currentValue"] = this.currentValue;
        data["previousValue"] = this.previousValue;
        super.toJSON(data);
        return data;
    }
}

export interface ITvdGrowthMetric extends ITVDMetric {
    valueContribution: string;
    monetaryContribution: string;
    currentValue: number;
    previousValue: number;
}

/** Request model for the GetMetrics endpoint. */
export class GetMetricsRequest implements IGetMetricsRequest {
    filters!: FilterSet;
    metricCostAssumptions!: MetricCostAssumptions;
    currencyCode!: RecognizedCurrencyCode;
    measurementSystem!: UnitOfMeasureTypes;

    constructor(data?: IGetMetricsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.metricCostAssumptions = _data["metricCostAssumptions"] ? MetricCostAssumptions.fromJS(_data["metricCostAssumptions"]) : undefined as any;
            this.currencyCode = _data["currencyCode"];
            this.measurementSystem = _data["measurementSystem"];
        }
    }

    static fromJS(data: any): GetMetricsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["metricCostAssumptions"] = this.metricCostAssumptions ? this.metricCostAssumptions.toJSON() : undefined as any;
        data["currencyCode"] = this.currencyCode;
        data["measurementSystem"] = this.measurementSystem;
        return data;
    }
}

/** Request model for the GetMetrics endpoint. */
export interface IGetMetricsRequest {
    filters: FilterSet;
    metricCostAssumptions: MetricCostAssumptions;
    currencyCode: RecognizedCurrencyCode;
    measurementSystem: UnitOfMeasureTypes;
}

export enum RecognizedCurrencyCode {
    Unknown = "Unknown",
    ADP = "ADP",
    AED = "AED",
    AFA = "AFA",
    AFN = "AFN",
    ALL = "ALL",
    AMD = "AMD",
    ANG = "ANG",
    AOA = "AOA",
    ARS = "ARS",
    AUD = "AUD",
    AWG = "AWG",
    AZM = "AZM",
    AZN = "AZN",
    BAM = "BAM",
    BBD = "BBD",
    BDT = "BDT",
    BGN = "BGN",
    BHD = "BHD",
    BIF = "BIF",
    BMD = "BMD",
    BND = "BND",
    BOB = "BOB",
    BRL = "BRL",
    BSD = "BSD",
    BTN = "BTN",
    BWP = "BWP",
    BYR = "BYR",
    BZD = "BZD",
    CAD = "CAD",
    CDF = "CDF",
    CHF = "CHF",
    CLP = "CLP",
    CNH = "CNH",
    CNY = "CNY",
    COP = "COP",
    CRC = "CRC",
    CSD = "CSD",
    CUP = "CUP",
    CVE = "CVE",
    CYP = "CYP",
    CZK = "CZK",
    DHS = "DHS",
    DJF = "DJF",
    DKK = "DKK",
    DOP = "DOP",
    DZD = "DZD",
    ECS = "ECS",
    EEK = "EEK",
    EGP = "EGP",
    ERN = "ERN",
    ETB = "ETB",
    EUR = "EUR",
    FJD = "FJD",
    GBP = "GBP",
    GEL = "GEL",
    GHC = "GHC",
    GHS = "GHS",
    GMD = "GMD",
    GNF = "GNF",
    GTQ = "GTQ",
    GWP = "GWP",
    GYD = "GYD",
    HKD = "HKD",
    HNL = "HNL",
    HRK = "HRK",
    HUF = "HUF",
    IDR = "IDR",
    ILS = "ILS",
    INR = "INR",
    IQD = "IQD",
    IRR = "IRR",
    ISK = "ISK",
    JMD = "JMD",
    JOD = "JOD",
    JPY = "JPY",
    KES = "KES",
    KGS = "KGS",
    KHR = "KHR",
    KMF = "KMF",
    KRW = "KRW",
    KWD = "KWD",
    KYD = "KYD",
    KZT = "KZT",
    LAK = "LAK",
    LBP = "LBP",
    LKR = "LKR",
    LRD = "LRD",
    LSL = "LSL",
    LTL = "LTL",
    LVL = "LVL",
    LYD = "LYD",
    MAD = "MAD",
    MDL = "MDL",
    MGA = "MGA",
    MKD = "MKD",
    MMK = "MMK",
    MNT = "MNT",
    MOP = "MOP",
    MRO = "MRO",
    MRU = "MRU",
    MTL = "MTL",
    MUR = "MUR",
    MVR = "MVR",
    MWK = "MWK",
    MXN = "MXN",
    MYR = "MYR",
    MZM = "MZM",
    MZN = "MZN",
    NAD = "NAD",
    NGN = "NGN",
    NIC = "NIC",
    NIO = "NIO",
    NOK = "NOK",
    NPR = "NPR",
    NZD = "NZD",
    OMR = "OMR",
    PAB = "PAB",
    PEN = "PEN",
    PGK = "PGK",
    PHP = "PHP",
    PKR = "PKR",
    PLN = "PLN",
    PYG = "PYG",
    QAR = "QAR",
    RMB = "RMB",
    ROL = "ROL",
    RON = "RON",
    RSD = "RSD",
    RUB = "RUB",
    RUR = "RUR",
    RWF = "RWF",
    SAR = "SAR",
    SBD = "SBD",
    SCR = "SCR",
    SDD = "SDD",
    SDP = "SDP",
    SEK = "SEK",
    SGD = "SGD",
    SIT = "SIT",
    SKK = "SKK",
    SLL = "SLL",
    SOS = "SOS",
    SRD = "SRD",
    STD = "STD",
    SVC = "SVC",
    SYP = "SYP",
    SZL = "SZL",
    THB = "THB",
    TJS = "TJS",
    TMM = "TMM",
    TMT = "TMT",
    TND = "TND",
    TOP = "TOP",
    TRL = "TRL",
    TRY = "TRY",
    TTD = "TTD",
    TWD = "TWD",
    TZS = "TZS",
    UAH = "UAH",
    UGX = "UGX",
    USD = "USD",
    UYU = "UYU",
    UZS = "UZS",
    VEB = "VEB",
    VEF = "VEF",
    VND = "VND",
    VUV = "VUV",
    WST = "WST",
    XAF = "XAF",
    XCD = "XCD",
    XOF = "XOF",
    XPF = "XPF",
    YER = "YER",
    ZAR = "ZAR",
    ZMK = "ZMK",
    ZMW = "ZMW",
    ZWD = "ZWD",
}

/** Response model for the GetAllProgramMetrics endpoint. */
export class GetAllProgramMetricsResponse implements IGetAllProgramMetricsResponse {
    data?: TVDProgram[] | undefined;

    constructor(data?: IGetAllProgramMetricsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TVDProgram.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllProgramMetricsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProgramMetricsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response model for the GetAllProgramMetrics endpoint. */
export interface IGetAllProgramMetricsResponse {
    data?: TVDProgram[] | undefined;
}

export class TVDProgram implements ITVDProgram {
    program?: string | undefined;
    programMetrics?: TVDProgramRegion[] | undefined;

    constructor(data?: ITVDProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            if (Array.isArray(_data["programMetrics"])) {
                this.programMetrics = [] as any;
                for (let item of _data["programMetrics"])
                    this.programMetrics!.push(TVDProgramRegion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDProgram {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        if (Array.isArray(this.programMetrics)) {
            data["programMetrics"] = [];
            for (let item of this.programMetrics)
                data["programMetrics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDProgram {
    program?: string | undefined;
    programMetrics?: TVDProgramRegion[] | undefined;
}

export class TVDProgramRegion implements ITVDProgramRegion {
    region?: string | undefined;
    totalProducts!: number;
    totalLocations!: number;
    totalValueDelivered!: Money;
    impactCategories?: TVDImpactCategory[] | undefined;

    constructor(data?: ITVDProgramRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalValueDelivered = new Money();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.totalProducts = _data["totalProducts"];
            this.totalLocations = _data["totalLocations"];
            this.totalValueDelivered = _data["totalValueDelivered"] ? Money.fromJS(_data["totalValueDelivered"]) : new Money();
            if (Array.isArray(_data["impactCategories"])) {
                this.impactCategories = [] as any;
                for (let item of _data["impactCategories"])
                    this.impactCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): TVDProgramRegion {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgramRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["totalProducts"] = this.totalProducts;
        data["totalLocations"] = this.totalLocations;
        data["totalValueDelivered"] = this.totalValueDelivered ? this.totalValueDelivered.toJSON() : undefined as any;
        if (Array.isArray(this.impactCategories)) {
            data["impactCategories"] = [];
            for (let item of this.impactCategories)
                data["impactCategories"].push(item);
        }
        return data;
    }
}

export interface ITVDProgramRegion {
    region?: string | undefined;
    totalProducts: number;
    totalLocations: number;
    totalValueDelivered: Money;
    impactCategories?: TVDImpactCategory[] | undefined;
}

export class Money implements IMoney {
    value!: number;
    currencyCodeId!: RecognizedCurrencyCode;
    asOf!: Date;

    constructor(data?: IMoney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.currencyCodeId = _data["currencyCodeId"];
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Money {
        data = typeof data === 'object' ? data : {};
        let result = new Money();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["currencyCodeId"] = this.currencyCodeId;
        data["asOf"] = this.asOf ? this.asOf.toISOString() : undefined as any;
        return data;
    }
}

export interface IMoney {
    value: number;
    currencyCodeId: RecognizedCurrencyCode;
    asOf: Date;
}

export enum TVDImpactCategory {
    FoodSafety = "FoodSafety",
    HumanSafety = "HumanSafety",
    WaterSafety = "WaterSafety",
    Brand = "Brand",
    DelightedGuests = "DelightedGuests",
    Quality = "Quality",
    RegulatoryCompliance = "RegulatoryCompliance",
    IndustryCompliance = "IndustryCompliance",
    LaborProductivity = "LaborProductivity",
    LocationProductivity = "LocationProductivity",
    ProductOptimization = "ProductOptimization",
    RawMaterialOptimization = "RawMaterialOptimization",
    Capacity = "Capacity",
    AssetProtection = "AssetProtection",
    Reliability = "Reliability",
    Water = "Water",
    ElectricalEnergy = "ElectricalEnergy",
    ThermalEnergy = "ThermalEnergy",
    GreenhouseGases = "GreenhouseGases",
    SolidWaste = "SolidWaste",
    LiquidWaste = "LiquidWaste",
    AirEmissions = "AirEmissions",
}

/** Request model for the GetAllProgramMetrics endpoint. */
export class GetAllProgramMetricsRequest implements IGetAllProgramMetricsRequest {
    filters!: FilterSet;
    currencyCode!: RecognizedCurrencyCode;
    measurementSystem!: UnitOfMeasureTypes;

    constructor(data?: IGetAllProgramMetricsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.currencyCode = _data["currencyCode"];
            this.measurementSystem = _data["measurementSystem"];
        }
    }

    static fromJS(data: any): GetAllProgramMetricsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProgramMetricsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["currencyCode"] = this.currencyCode;
        data["measurementSystem"] = this.measurementSystem;
        return data;
    }
}

/** Request model for the GetAllProgramMetrics endpoint. */
export interface IGetAllProgramMetricsRequest {
    filters: FilterSet;
    currencyCode: RecognizedCurrencyCode;
    measurementSystem: UnitOfMeasureTypes;
}

/** Response model for the GetMetricsByProgramName endpoint. */
export class GetMetricsByProgramNameResponse implements IGetMetricsByProgramNameResponse {
    data?: TVDProgramDetails | undefined;

    constructor(data?: IGetMetricsByProgramNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TVDProgramDetails.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMetricsByProgramNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByProgramNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

/** Response model for the GetMetricsByProgramName endpoint. */
export interface IGetMetricsByProgramNameResponse {
    data?: TVDProgramDetails | undefined;
}

export class TVDProgramDetails implements ITVDProgramDetails {
    program!: string | undefined;
    programDetailsByRegion!: TVDProgramRegionDetails[] | undefined;

    constructor(data?: ITVDProgramDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            if (Array.isArray(_data["programDetailsByRegion"])) {
                this.programDetailsByRegion = [] as any;
                for (let item of _data["programDetailsByRegion"])
                    this.programDetailsByRegion!.push(TVDProgramRegionDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDProgramDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgramDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        if (Array.isArray(this.programDetailsByRegion)) {
            data["programDetailsByRegion"] = [];
            for (let item of this.programDetailsByRegion)
                data["programDetailsByRegion"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDProgramDetails {
    program: string | undefined;
    programDetailsByRegion: TVDProgramRegionDetails[] | undefined;
}

export class TVDProgramRegionDetails implements ITVDProgramRegionDetails {
    region!: string | undefined;
    programDataByProduct!: TVDProgramProductDetails[] | undefined;

    constructor(data?: ITVDProgramRegionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            if (Array.isArray(_data["programDataByProduct"])) {
                this.programDataByProduct = [] as any;
                for (let item of _data["programDataByProduct"])
                    this.programDataByProduct!.push(TVDProgramProductDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDProgramRegionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgramRegionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        if (Array.isArray(this.programDataByProduct)) {
            data["programDataByProduct"] = [];
            for (let item of this.programDataByProduct)
                data["programDataByProduct"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDProgramRegionDetails {
    region: string | undefined;
    programDataByProduct: TVDProgramProductDetails[] | undefined;
}

export class TVDProgramProductDetails implements ITVDProgramProductDetails {
    program!: string | undefined;
    productCode!: string | undefined;
    productName!: string | undefined;
    totalValueDelivered!: Money;
    impactCategories!: TVDImpactCategory[] | undefined;
    locations!: TVDProgramLocationDetails[] | undefined;

    constructor(data?: ITVDProgramProductDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalValueDelivered = new Money();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.totalValueDelivered = _data["totalValueDelivered"] ? Money.fromJS(_data["totalValueDelivered"]) : new Money();
            if (Array.isArray(_data["impactCategories"])) {
                this.impactCategories = [] as any;
                for (let item of _data["impactCategories"])
                    this.impactCategories!.push(item);
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TVDProgramLocationDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDProgramProductDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgramProductDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["totalValueDelivered"] = this.totalValueDelivered ? this.totalValueDelivered.toJSON() : undefined as any;
        if (Array.isArray(this.impactCategories)) {
            data["impactCategories"] = [];
            for (let item of this.impactCategories)
                data["impactCategories"].push(item);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITVDProgramProductDetails {
    program: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    totalValueDelivered: Money;
    impactCategories: TVDImpactCategory[] | undefined;
    locations: TVDProgramLocationDetails[] | undefined;
}

export class TVDProgramLocationDetails implements ITVDProgramLocationDetails {
    siteId?: string | undefined;
    siteName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    totalValueDelivered!: Money;
    casesPurchased!: number;
    impactCategories?: TVDImpactCategory[] | undefined;

    constructor(data?: ITVDProgramLocationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalValueDelivered = new Money();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.country = _data["country"];
            this.region = _data["region"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.totalValueDelivered = _data["totalValueDelivered"] ? Money.fromJS(_data["totalValueDelivered"]) : new Money();
            this.casesPurchased = _data["casesPurchased"];
            if (Array.isArray(_data["impactCategories"])) {
                this.impactCategories = [] as any;
                for (let item of _data["impactCategories"])
                    this.impactCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): TVDProgramLocationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TVDProgramLocationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["country"] = this.country;
        data["region"] = this.region;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["totalValueDelivered"] = this.totalValueDelivered ? this.totalValueDelivered.toJSON() : undefined as any;
        data["casesPurchased"] = this.casesPurchased;
        if (Array.isArray(this.impactCategories)) {
            data["impactCategories"] = [];
            for (let item of this.impactCategories)
                data["impactCategories"].push(item);
        }
        return data;
    }
}

export interface ITVDProgramLocationDetails {
    siteId?: string | undefined;
    siteName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    totalValueDelivered: Money;
    casesPurchased: number;
    impactCategories?: TVDImpactCategory[] | undefined;
}

/** Request model for the GetMetricsByProgramName endpoint. */
export class GetMetricsByProgramNameRequest implements IGetMetricsByProgramNameRequest {
    filters!: FilterSet;
    currencyCode!: RecognizedCurrencyCode;
    measurementSystem!: UnitOfMeasureTypes;

    constructor(data?: IGetMetricsByProgramNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.currencyCode = _data["currencyCode"];
            this.measurementSystem = _data["measurementSystem"];
        }
    }

    static fromJS(data: any): GetMetricsByProgramNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByProgramNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["currencyCode"] = this.currencyCode;
        data["measurementSystem"] = this.measurementSystem;
        return data;
    }
}

/** Request model for the GetMetricsByProgramName endpoint. */
export interface IGetMetricsByProgramNameRequest {
    filters: FilterSet;
    currencyCode: RecognizedCurrencyCode;
    measurementSystem: UnitOfMeasureTypes;
}

export class GetMetricsByProductResponse implements IGetMetricsByProductResponse {
    data?: TVDByProductModel | undefined;

    constructor(data?: IGetMetricsByProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TVDByProductModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMetricsByProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMetricsByProductResponse {
    data?: TVDByProductModel | undefined;
}

/** The response model containing necessary data for the TVD by Location page */
export class TVDByProductModel implements ITVDByProductModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of distinct contributing products  */
    totalContributingProducts?: string | undefined;
    /** The average TVD metric (quantity) per location */
    avgTVDMetricQuantity?: string | undefined;
    /** The average TVD metric (dollars) per location */
    avgTVDMetricDollars?: string | undefined;
    /** The locations with info based on the TVD metric */
    productRows?: TVDByProductDataRow[] | undefined;

    constructor(data?: ITVDByProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricType = _data["metricType"];
            this.metricUnit = _data["metricUnit"];
            this.totalLocations = _data["totalLocations"];
            this.totalContributingProducts = _data["totalContributingProducts"];
            this.avgTVDMetricQuantity = _data["avgTVDMetricQuantity"];
            this.avgTVDMetricDollars = _data["avgTVDMetricDollars"];
            if (Array.isArray(_data["productRows"])) {
                this.productRows = [] as any;
                for (let item of _data["productRows"])
                    this.productRows!.push(TVDByProductDataRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDByProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new TVDByProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricType"] = this.metricType;
        data["metricUnit"] = this.metricUnit;
        data["totalLocations"] = this.totalLocations;
        data["totalContributingProducts"] = this.totalContributingProducts;
        data["avgTVDMetricQuantity"] = this.avgTVDMetricQuantity;
        data["avgTVDMetricDollars"] = this.avgTVDMetricDollars;
        if (Array.isArray(this.productRows)) {
            data["productRows"] = [];
            for (let item of this.productRows)
                data["productRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** The response model containing necessary data for the TVD by Location page */
export interface ITVDByProductModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of distinct contributing products  */
    totalContributingProducts?: string | undefined;
    /** The average TVD metric (quantity) per location */
    avgTVDMetricQuantity?: string | undefined;
    /** The average TVD metric (dollars) per location */
    avgTVDMetricDollars?: string | undefined;
    /** The locations with info based on the TVD metric */
    productRows?: TVDByProductDataRow[] | undefined;
}

/** Represents one row to be displayed on the TVD by Product page. */
export class TVDByProductDataRow extends TVDDetailRow implements ITVDByProductDataRow {
    /** SKU of the product represented */
    productCode?: string | undefined;
    /** Name of the product represented */
    productName?: string | undefined;
    /** Product Description */
    productDesc?: string | undefined;
    /** Solution of the product represented */
    solution?: string | undefined;
    /** Number of locations contributing to the TVD metric calculations */
    numberOfLocations!: number;
    isEDPRental!: boolean;
    /** Category of measurement for the quantity (Liquid for Gallons/Liters, Solid for Cases) */
    measurementCategory!: MeasurementCategory;
    quantityPurchased!: number;

    constructor(data?: ITVDByProductDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productDesc = _data["productDesc"];
            this.solution = _data["solution"];
            this.numberOfLocations = _data["numberOfLocations"];
            this.isEDPRental = _data["isEDPRental"];
            this.measurementCategory = _data["measurementCategory"];
            this.quantityPurchased = _data["quantityPurchased"];
        }
    }

    static override fromJS(data: any): TVDByProductDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new TVDByProductDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productDesc"] = this.productDesc;
        data["solution"] = this.solution;
        data["numberOfLocations"] = this.numberOfLocations;
        data["isEDPRental"] = this.isEDPRental;
        data["measurementCategory"] = this.measurementCategory;
        data["quantityPurchased"] = this.quantityPurchased;
        super.toJSON(data);
        return data;
    }
}

/** Represents one row to be displayed on the TVD by Product page. */
export interface ITVDByProductDataRow extends ITVDDetailRow {
    /** SKU of the product represented */
    productCode?: string | undefined;
    /** Name of the product represented */
    productName?: string | undefined;
    /** Product Description */
    productDesc?: string | undefined;
    /** Solution of the product represented */
    solution?: string | undefined;
    /** Number of locations contributing to the TVD metric calculations */
    numberOfLocations: number;
    isEDPRental: boolean;
    /** Category of measurement for the quantity (Liquid for Gallons/Liters, Solid for Cases) */
    measurementCategory: MeasurementCategory;
    quantityPurchased: number;
}

export enum MeasurementCategory {
    Liquid = "Liquid",
    Solid = "Solid",
    Gas = "Gas",
}

export class GetMetricsByProductRequest implements IGetMetricsByProductRequest {
    filters!: FilterSet;
    metricCostAssumptions!: MetricCostAssumptions;
    program?: string | undefined;
    brandGroup!: BrandGroup;
    brands!: string[];
    currencyCode!: RecognizedCurrencyCode;
    measurementSystem!: UnitOfMeasureTypes;
    advancedFilter?: TvdProductAdvancedFilter | undefined;

    constructor(data?: IGetMetricsByProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
            this.brands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.metricCostAssumptions = _data["metricCostAssumptions"] ? MetricCostAssumptions.fromJS(_data["metricCostAssumptions"]) : undefined as any;
            this.program = _data["program"];
            this.brandGroup = _data["brandGroup"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            this.currencyCode = _data["currencyCode"];
            this.measurementSystem = _data["measurementSystem"];
            this.advancedFilter = _data["advancedFilter"] ? TvdProductAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMetricsByProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["metricCostAssumptions"] = this.metricCostAssumptions ? this.metricCostAssumptions.toJSON() : undefined as any;
        data["program"] = this.program;
        data["brandGroup"] = this.brandGroup;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        data["measurementSystem"] = this.measurementSystem;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMetricsByProductRequest {
    filters: FilterSet;
    metricCostAssumptions: MetricCostAssumptions;
    program?: string | undefined;
    brandGroup: BrandGroup;
    brands: string[];
    currencyCode: RecognizedCurrencyCode;
    measurementSystem: UnitOfMeasureTypes;
    advancedFilter?: TvdProductAdvancedFilter | undefined;
}

export class TvdProductAdvancedFilter implements ITvdProductAdvancedFilter {
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;
    productSku?: string[] | undefined;

    constructor(data?: ITvdProductAdvancedFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productGroup"])) {
                this.productGroup = [] as any;
                for (let item of _data["productGroup"])
                    this.productGroup!.push(item);
            }
            if (Array.isArray(_data["productName"])) {
                this.productName = [] as any;
                for (let item of _data["productName"])
                    this.productName!.push(item);
            }
            if (Array.isArray(_data["productSku"])) {
                this.productSku = [] as any;
                for (let item of _data["productSku"])
                    this.productSku!.push(item);
            }
        }
    }

    static fromJS(data: any): TvdProductAdvancedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TvdProductAdvancedFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productGroup)) {
            data["productGroup"] = [];
            for (let item of this.productGroup)
                data["productGroup"].push(item);
        }
        if (Array.isArray(this.productName)) {
            data["productName"] = [];
            for (let item of this.productName)
                data["productName"].push(item);
        }
        if (Array.isArray(this.productSku)) {
            data["productSku"] = [];
            for (let item of this.productSku)
                data["productSku"].push(item);
        }
        return data;
    }
}

export interface ITvdProductAdvancedFilter {
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;
    productSku?: string[] | undefined;
}

export class GetMetricsByLocationResponse implements IGetMetricsByLocationResponse {
    data?: TVDByLocationModel | undefined;

    constructor(data?: IGetMetricsByLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TVDByLocationModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMetricsByLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMetricsByLocationResponse {
    data?: TVDByLocationModel | undefined;
}

/** The response model containing necessary data for the TVD by Location page */
export class TVDByLocationModel implements ITVDByLocationModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of distinct contributing products  */
    totalContributingProducts?: string | undefined;
    /** The average TVD metric (quantity) per location */
    avgTVDMetricQuantity?: string | undefined;
    /** The average TVD metric (dollars) per location */
    avgTVDMetricDollars?: string | undefined;
    /** The locations with info based on the TVD metric */
    locationRows?: TVDByLocationDataRow[] | undefined;

    constructor(data?: ITVDByLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricType = _data["metricType"];
            this.metricUnit = _data["metricUnit"];
            this.totalLocations = _data["totalLocations"];
            this.totalContributingProducts = _data["totalContributingProducts"];
            this.avgTVDMetricQuantity = _data["avgTVDMetricQuantity"];
            this.avgTVDMetricDollars = _data["avgTVDMetricDollars"];
            if (Array.isArray(_data["locationRows"])) {
                this.locationRows = [] as any;
                for (let item of _data["locationRows"])
                    this.locationRows!.push(TVDByLocationDataRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVDByLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TVDByLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricType"] = this.metricType;
        data["metricUnit"] = this.metricUnit;
        data["totalLocations"] = this.totalLocations;
        data["totalContributingProducts"] = this.totalContributingProducts;
        data["avgTVDMetricQuantity"] = this.avgTVDMetricQuantity;
        data["avgTVDMetricDollars"] = this.avgTVDMetricDollars;
        if (Array.isArray(this.locationRows)) {
            data["locationRows"] = [];
            for (let item of this.locationRows)
                data["locationRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** The response model containing necessary data for the TVD by Location page */
export interface ITVDByLocationModel {
    /** The type of TVD metric that the page pertains to */
    metricType?: string | undefined;
    /** Represents the unit of measurement for the metric type */
    metricUnit?: string | undefined;
    /** The total number of locations based on the applied filter */
    totalLocations?: string | undefined;
    /** The total number of distinct contributing products  */
    totalContributingProducts?: string | undefined;
    /** The average TVD metric (quantity) per location */
    avgTVDMetricQuantity?: string | undefined;
    /** The average TVD metric (dollars) per location */
    avgTVDMetricDollars?: string | undefined;
    /** The locations with info based on the TVD metric */
    locationRows?: TVDByLocationDataRow[] | undefined;
}

/** Represents one row to be displayed on the TVD by Location page. */
export class TVDByLocationDataRow extends TVDDetailRow implements ITVDByLocationDataRow {
    /** Site ID of the location represented */
    siteID?: string | undefined;
    /** Name of the location represented */
    siteName?: string | undefined;
    /** Street Address of the location represented */
    streetAddress?: string | undefined;
    /** City of the location represented */
    city?: string | undefined;
    /** State of the location represented */
    state?: string | undefined;
    /** Zip code of the location represented */
    zipCode?: string | undefined;
    /** Number of products contributing to the TVD metric calculations */
    contributingProducts!: number;
    /** H5 Number of the location represented */
    h5Number?: string | undefined;
    /** H5 Name of the location represented */
    h5Name?: string | undefined;
    /** H7 Number of the location represented */
    h7Number?: string | undefined;
    /** H7 Name of the location represented */
    h7Name?: string | undefined;
    /** Country code of the location represented */
    countryCode?: string | undefined;
    /** Territory Representative Name of the location represented */
    trName?: string | undefined;
    /** Area Manager Name of the location represented */
    amName?: string | undefined;
    /** District Manager Name of the location represented */
    dmName?: string | undefined;

    constructor(data?: ITVDByLocationDataRow) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteID = _data["siteID"];
            this.siteName = _data["siteName"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.contributingProducts = _data["contributingProducts"];
            this.h5Number = _data["h5Number"];
            this.h5Name = _data["h5Name"];
            this.h7Number = _data["h7Number"];
            this.h7Name = _data["h7Name"];
            this.countryCode = _data["countryCode"];
            this.trName = _data["trName"];
            this.amName = _data["amName"];
            this.dmName = _data["dmName"];
        }
    }

    static override fromJS(data: any): TVDByLocationDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new TVDByLocationDataRow();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        data["siteName"] = this.siteName;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["contributingProducts"] = this.contributingProducts;
        data["h5Number"] = this.h5Number;
        data["h5Name"] = this.h5Name;
        data["h7Number"] = this.h7Number;
        data["h7Name"] = this.h7Name;
        data["countryCode"] = this.countryCode;
        data["trName"] = this.trName;
        data["amName"] = this.amName;
        data["dmName"] = this.dmName;
        super.toJSON(data);
        return data;
    }
}

/** Represents one row to be displayed on the TVD by Location page. */
export interface ITVDByLocationDataRow extends ITVDDetailRow {
    /** Site ID of the location represented */
    siteID?: string | undefined;
    /** Name of the location represented */
    siteName?: string | undefined;
    /** Street Address of the location represented */
    streetAddress?: string | undefined;
    /** City of the location represented */
    city?: string | undefined;
    /** State of the location represented */
    state?: string | undefined;
    /** Zip code of the location represented */
    zipCode?: string | undefined;
    /** Number of products contributing to the TVD metric calculations */
    contributingProducts: number;
    /** H5 Number of the location represented */
    h5Number?: string | undefined;
    /** H5 Name of the location represented */
    h5Name?: string | undefined;
    /** H7 Number of the location represented */
    h7Number?: string | undefined;
    /** H7 Name of the location represented */
    h7Name?: string | undefined;
    /** Country code of the location represented */
    countryCode?: string | undefined;
    /** Territory Representative Name of the location represented */
    trName?: string | undefined;
    /** Area Manager Name of the location represented */
    amName?: string | undefined;
    /** District Manager Name of the location represented */
    dmName?: string | undefined;
}

export class GetMetricsByLocationRequest implements IGetMetricsByLocationRequest {
    filters!: FilterSet;
    metricCostAssumptions!: MetricCostAssumptions;
    program?: string | undefined;
    brandGroup!: BrandGroup;
    brands!: string[];
    currencyCode!: RecognizedCurrencyCode;
    measurementSystem!: UnitOfMeasureTypes;
    advancedFilter?: TvdLocationAdvancedFilter | undefined;

    constructor(data?: IGetMetricsByLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
            this.brands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.metricCostAssumptions = _data["metricCostAssumptions"] ? MetricCostAssumptions.fromJS(_data["metricCostAssumptions"]) : undefined as any;
            this.program = _data["program"];
            this.brandGroup = _data["brandGroup"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            this.currencyCode = _data["currencyCode"];
            this.measurementSystem = _data["measurementSystem"];
            this.advancedFilter = _data["advancedFilter"] ? TvdLocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMetricsByLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetricsByLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["metricCostAssumptions"] = this.metricCostAssumptions ? this.metricCostAssumptions.toJSON() : undefined as any;
        data["program"] = this.program;
        data["brandGroup"] = this.brandGroup;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        data["measurementSystem"] = this.measurementSystem;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMetricsByLocationRequest {
    filters: FilterSet;
    metricCostAssumptions: MetricCostAssumptions;
    program?: string | undefined;
    brandGroup: BrandGroup;
    brands: string[];
    currencyCode: RecognizedCurrencyCode;
    measurementSystem: UnitOfMeasureTypes;
    advancedFilter?: TvdLocationAdvancedFilter | undefined;
}

export class TvdLocationAdvancedFilter implements ITvdLocationAdvancedFilter {
    siteNumber?: string[] | undefined;
    siteName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;

    constructor(data?: ITvdLocationAdvancedFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["siteNumber"])) {
                this.siteNumber = [] as any;
                for (let item of _data["siteNumber"])
                    this.siteNumber!.push(item);
            }
            if (Array.isArray(_data["siteName"])) {
                this.siteName = [] as any;
                for (let item of _data["siteName"])
                    this.siteName!.push(item);
            }
            if (Array.isArray(_data["country"])) {
                this.country = [] as any;
                for (let item of _data["country"])
                    this.country!.push(item);
            }
            if (Array.isArray(_data["state"])) {
                this.state = [] as any;
                for (let item of _data["state"])
                    this.state!.push(item);
            }
            if (Array.isArray(_data["city"])) {
                this.city = [] as any;
                for (let item of _data["city"])
                    this.city!.push(item);
            }
            if (Array.isArray(_data["zipCode"])) {
                this.zipCode = [] as any;
                for (let item of _data["zipCode"])
                    this.zipCode!.push(item);
            }
        }
    }

    static fromJS(data: any): TvdLocationAdvancedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TvdLocationAdvancedFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siteNumber)) {
            data["siteNumber"] = [];
            for (let item of this.siteNumber)
                data["siteNumber"].push(item);
        }
        if (Array.isArray(this.siteName)) {
            data["siteName"] = [];
            for (let item of this.siteName)
                data["siteName"].push(item);
        }
        if (Array.isArray(this.country)) {
            data["country"] = [];
            for (let item of this.country)
                data["country"].push(item);
        }
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item);
        }
        if (Array.isArray(this.city)) {
            data["city"] = [];
            for (let item of this.city)
                data["city"].push(item);
        }
        if (Array.isArray(this.zipCode)) {
            data["zipCode"] = [];
            for (let item of this.zipCode)
                data["zipCode"].push(item);
        }
        return data;
    }
}

export interface ITvdLocationAdvancedFilter {
    siteNumber?: string[] | undefined;
    siteName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;
}

export class GetDefaultRatesResponse implements IGetDefaultRatesResponse {
    data?: DefaultTvdRates | undefined;

    constructor(data?: IGetDefaultRatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DefaultTvdRates.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetDefaultRatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultRatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetDefaultRatesResponse {
    data?: DefaultTvdRates | undefined;
}

export class DefaultTvdRates implements IDefaultTvdRates {
    region?: string | undefined;
    division?: string | undefined;
    tvdRateDetails?: DefaultTvdRateDetails[] | undefined;

    constructor(data?: IDefaultTvdRates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.division = _data["division"];
            if (Array.isArray(_data["tvdRateDetails"])) {
                this.tvdRateDetails = [] as any;
                for (let item of _data["tvdRateDetails"])
                    this.tvdRateDetails!.push(DefaultTvdRateDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DefaultTvdRates {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultTvdRates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["division"] = this.division;
        if (Array.isArray(this.tvdRateDetails)) {
            data["tvdRateDetails"] = [];
            for (let item of this.tvdRateDetails)
                data["tvdRateDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDefaultTvdRates {
    region?: string | undefined;
    division?: string | undefined;
    tvdRateDetails?: DefaultTvdRateDetails[] | undefined;
}

export class DefaultTvdRateDetails implements IDefaultTvdRateDetails {
    id?: string | undefined;
    category?: string | undefined;
    rate?: number | undefined;
    uom?: string | undefined;
    isMonetaryRate!: boolean;
    region?: string | undefined;
    country?: string | undefined;

    constructor(data?: IDefaultTvdRateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.rate = _data["rate"];
            this.uom = _data["uom"];
            this.isMonetaryRate = _data["isMonetaryRate"];
            this.region = _data["region"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): DefaultTvdRateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultTvdRateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["rate"] = this.rate;
        data["uom"] = this.uom;
        data["isMonetaryRate"] = this.isMonetaryRate;
        data["region"] = this.region;
        data["country"] = this.country;
        return data;
    }
}

export interface IDefaultTvdRateDetails {
    id?: string | undefined;
    category?: string | undefined;
    rate?: number | undefined;
    uom?: string | undefined;
    isMonetaryRate: boolean;
    region?: string | undefined;
    country?: string | undefined;
}

export class GetDefaultRatesRequest implements IGetDefaultRatesRequest {
    filters!: FilterSet;
    currencyCode!: RecognizedCurrencyCode;
    unitOfMeasureSystem!: UnitOfMeasureTypes;

    constructor(data?: IGetDefaultRatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.currencyCode = _data["currencyCode"];
            this.unitOfMeasureSystem = _data["unitOfMeasureSystem"];
        }
    }

    static fromJS(data: any): GetDefaultRatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultRatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["currencyCode"] = this.currencyCode;
        data["unitOfMeasureSystem"] = this.unitOfMeasureSystem;
        return data;
    }
}

export interface IGetDefaultRatesRequest {
    filters: FilterSet;
    currencyCode: RecognizedCurrencyCode;
    unitOfMeasureSystem: UnitOfMeasureTypes;
}

export class GetTotalSolutionGroupsExpandedDataResponse implements IGetTotalSolutionGroupsExpandedDataResponse {
    data?: SPLocationExpandedSolutionGroupsDTO | undefined;

    constructor(data?: IGetTotalSolutionGroupsExpandedDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SPLocationExpandedSolutionGroupsDTO.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTotalSolutionGroupsExpandedDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalSolutionGroupsExpandedDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalSolutionGroupsExpandedDataResponse {
    data?: SPLocationExpandedSolutionGroupsDTO | undefined;
}

export class SPLocationExpandedSolutionGroupsDTO implements ISPLocationExpandedSolutionGroupsDTO {
    siteId?: string | undefined;
    totalSolutionGroups!: number;
    solutionGroups?: SolutionGroupDTO[] | undefined;

    constructor(data?: ISPLocationExpandedSolutionGroupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.totalSolutionGroups = _data["totalSolutionGroups"];
            if (Array.isArray(_data["solutionGroups"])) {
                this.solutionGroups = [] as any;
                for (let item of _data["solutionGroups"])
                    this.solutionGroups!.push(SolutionGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SPLocationExpandedSolutionGroupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SPLocationExpandedSolutionGroupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["totalSolutionGroups"] = this.totalSolutionGroups;
        if (Array.isArray(this.solutionGroups)) {
            data["solutionGroups"] = [];
            for (let item of this.solutionGroups)
                data["solutionGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISPLocationExpandedSolutionGroupsDTO {
    siteId?: string | undefined;
    totalSolutionGroups: number;
    solutionGroups?: SolutionGroupDTO[] | undefined;
}

export class SolutionGroupDTO implements ISolutionGroupDTO {
    solutionGroup?: string | undefined;
    countOfProducts!: number;
    totalSalesAmt!: number;
    otherDistributor!: boolean;
    products?: ProductDTO[] | undefined;
    region?: string | undefined;
    isPurchased!: boolean;

    constructor(data?: ISolutionGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solutionGroup = _data["solutionGroup"];
            this.countOfProducts = _data["countOfProducts"];
            this.totalSalesAmt = _data["totalSalesAmt"];
            this.otherDistributor = _data["otherDistributor"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDTO.fromJS(item));
            }
            this.region = _data["region"];
            this.isPurchased = _data["isPurchased"];
        }
    }

    static fromJS(data: any): SolutionGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solutionGroup"] = this.solutionGroup;
        data["countOfProducts"] = this.countOfProducts;
        data["totalSalesAmt"] = this.totalSalesAmt;
        data["otherDistributor"] = this.otherDistributor;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["region"] = this.region;
        data["isPurchased"] = this.isPurchased;
        return data;
    }
}

export interface ISolutionGroupDTO {
    solutionGroup?: string | undefined;
    countOfProducts: number;
    totalSalesAmt: number;
    otherDistributor: boolean;
    products?: ProductDTO[] | undefined;
    region?: string | undefined;
    isPurchased: boolean;
}

export class ProductDTO implements IProductDTO {
    region?: string | undefined;
    productName?: string | undefined;
    productCode?: string | undefined;
    rebate!: number;
    mpl!: number;
    spl!: number;
    lastPurchased?: string | undefined;
    distributorProduct?: string | undefined;
    productTotalSalesAmt!: number;
    productTotalSalesQty!: number;
    isPurchased!: boolean;

    constructor(data?: IProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.rebate = _data["rebate"];
            this.mpl = _data["mpl"];
            this.spl = _data["spl"];
            this.lastPurchased = _data["lastPurchased"];
            this.distributorProduct = _data["distributorProduct"];
            this.productTotalSalesAmt = _data["productTotalSalesAmt"];
            this.productTotalSalesQty = _data["productTotalSalesQty"];
            this.isPurchased = _data["isPurchased"];
        }
    }

    static fromJS(data: any): ProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["rebate"] = this.rebate;
        data["mpl"] = this.mpl;
        data["spl"] = this.spl;
        data["lastPurchased"] = this.lastPurchased;
        data["distributorProduct"] = this.distributorProduct;
        data["productTotalSalesAmt"] = this.productTotalSalesAmt;
        data["productTotalSalesQty"] = this.productTotalSalesQty;
        data["isPurchased"] = this.isPurchased;
        return data;
    }
}

export interface IProductDTO {
    region?: string | undefined;
    productName?: string | undefined;
    productCode?: string | undefined;
    rebate: number;
    mpl: number;
    spl: number;
    lastPurchased?: string | undefined;
    distributorProduct?: string | undefined;
    productTotalSalesAmt: number;
    productTotalSalesQty: number;
    isPurchased: boolean;
}

export class GetTotalSolutionGroupsExpandedDataRequest implements IGetTotalSolutionGroupsExpandedDataRequest {
    filters!: FilterSet | undefined;
    widgetType!: SolutionGroupWidgetType;
    siteId!: string | undefined;

    constructor(data?: IGetTotalSolutionGroupsExpandedDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : undefined as any;
            this.widgetType = _data["widgetType"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): GetTotalSolutionGroupsExpandedDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalSolutionGroupsExpandedDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["widgetType"] = this.widgetType;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IGetTotalSolutionGroupsExpandedDataRequest {
    filters: FilterSet | undefined;
    widgetType: SolutionGroupWidgetType;
    siteId: string | undefined;
}

export enum SolutionGroupWidgetType {
    All = "All",
    Rebate = "Rebate",
    SPL = "SPL",
    MPL = "MPL",
}

export class GetSummaryFiltersResponse implements IGetSummaryFiltersResponse {
    data?: SolutionParticipationSummaryFiltersDTO[] | undefined;

    constructor(data?: IGetSummaryFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SolutionParticipationSummaryFiltersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSummaryFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSummaryFiltersResponse {
    data?: SolutionParticipationSummaryFiltersDTO[] | undefined;
}

export class SolutionParticipationSummaryFiltersDTO implements ISolutionParticipationSummaryFiltersDTO {
    platform?: string | undefined;
    solution?: string | undefined;
    productGroup?: string | undefined;
    productName?: string | undefined;
    productSku?: string | undefined;
    brand?: string | undefined;

    constructor(data?: ISolutionParticipationSummaryFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.solution = _data["solution"];
            this.productGroup = _data["productGroup"];
            this.productName = _data["productName"];
            this.productSku = _data["productSku"];
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): SolutionParticipationSummaryFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionParticipationSummaryFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["solution"] = this.solution;
        data["productGroup"] = this.productGroup;
        data["productName"] = this.productName;
        data["productSku"] = this.productSku;
        data["brand"] = this.brand;
        return data;
    }
}

export interface ISolutionParticipationSummaryFiltersDTO {
    platform?: string | undefined;
    solution?: string | undefined;
    productGroup?: string | undefined;
    productName?: string | undefined;
    productSku?: string | undefined;
    brand?: string | undefined;
}

export class GetSummaryFiltersRequest implements IGetSummaryFiltersRequest {
    filters!: FilterSet | undefined;

    constructor(data?: IGetSummaryFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSummaryFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSummaryFiltersRequest {
    filters: FilterSet | undefined;
}

export class GetSummaryDetailsFiltersResponse implements IGetSummaryDetailsFiltersResponse {
    data?: SPSummaryDetailsAdvFiltersDTO[] | undefined;

    constructor(data?: IGetSummaryDetailsFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SPSummaryDetailsAdvFiltersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSummaryDetailsFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDetailsFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSummaryDetailsFiltersResponse {
    data?: SPSummaryDetailsAdvFiltersDTO[] | undefined;
}

export class SPSummaryDetailsAdvFiltersDTO implements ISPSummaryDetailsAdvFiltersDTO {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    productSku?: string | undefined;
    brand?: string | undefined;
    productGroup?: string | undefined;
    productName?: string | undefined;

    constructor(data?: ISPSummaryDetailsAdvFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.productSku = _data["productSku"];
            this.brand = _data["brand"];
            this.productGroup = _data["productGroup"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): SPSummaryDetailsAdvFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SPSummaryDetailsAdvFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["productSku"] = this.productSku;
        data["brand"] = this.brand;
        data["productGroup"] = this.productGroup;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ISPSummaryDetailsAdvFiltersDTO {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    productSku?: string | undefined;
    brand?: string | undefined;
    productGroup?: string | undefined;
    productName?: string | undefined;
}

export class GetSummaryDetailsFiltersRequest implements IGetSummaryDetailsFiltersRequest {
    filters!: FilterSet | undefined;

    constructor(data?: IGetSummaryDetailsFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSummaryDetailsFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDetailsFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSummaryDetailsFiltersRequest {
    filters: FilterSet | undefined;
}

export class GetSolutionSummaryResponse implements IGetSolutionSummaryResponse {
    data?: SolutionSummaryResponse | undefined;

    constructor(data?: IGetSolutionSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SolutionSummaryResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionSummaryResponse {
    data?: SolutionSummaryResponse | undefined;
}

export class SolutionSummaryResponse implements ISolutionSummaryResponse {
    solutionParticipationSummary?: SolutionParticipationSummaryDto[] | undefined;
    solutionParticipationSolutionsPerLocationAvg!: number;

    constructor(data?: ISolutionSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["solutionParticipationSummary"])) {
                this.solutionParticipationSummary = [] as any;
                for (let item of _data["solutionParticipationSummary"])
                    this.solutionParticipationSummary!.push(SolutionParticipationSummaryDto.fromJS(item));
            }
            this.solutionParticipationSolutionsPerLocationAvg = _data["solutionParticipationSolutionsPerLocationAvg"];
        }
    }

    static fromJS(data: any): SolutionSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.solutionParticipationSummary)) {
            data["solutionParticipationSummary"] = [];
            for (let item of this.solutionParticipationSummary)
                data["solutionParticipationSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["solutionParticipationSolutionsPerLocationAvg"] = this.solutionParticipationSolutionsPerLocationAvg;
        return data;
    }
}

export interface ISolutionSummaryResponse {
    solutionParticipationSummary?: SolutionParticipationSummaryDto[] | undefined;
    solutionParticipationSolutionsPerLocationAvg: number;
}

export class SolutionParticipationSummaryDto implements ISolutionParticipationSummaryDto {
    solution?: string | undefined;
    compliant?: string | undefined;
    nonCompliant?: string | undefined;
    productCount!: number;
    compliantCount?: string | undefined;
    nonCompliantCount?: string | undefined;

    constructor(data?: ISolutionParticipationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.compliant = _data["compliant"];
            this.nonCompliant = _data["nonCompliant"];
            this.productCount = _data["productCount"];
            this.compliantCount = _data["compliantCount"];
            this.nonCompliantCount = _data["nonCompliantCount"];
        }
    }

    static fromJS(data: any): SolutionParticipationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionParticipationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["compliant"] = this.compliant;
        data["nonCompliant"] = this.nonCompliant;
        data["productCount"] = this.productCount;
        data["compliantCount"] = this.compliantCount;
        data["nonCompliantCount"] = this.nonCompliantCount;
        return data;
    }
}

export interface ISolutionParticipationSummaryDto {
    solution?: string | undefined;
    compliant?: string | undefined;
    nonCompliant?: string | undefined;
    productCount: number;
    compliantCount?: string | undefined;
    nonCompliantCount?: string | undefined;
}

export class GetSolutionSummaryRequest implements IGetSolutionSummaryRequest {
    filters!: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;

    constructor(data?: IGetSolutionSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? SummaryAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionSummaryRequest {
    filters: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;
}

export class SummaryAdvancedFilter implements ISummaryAdvancedFilter {
    platform?: string[] | undefined;
    solution?: string[] | undefined;
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;
    productSku?: string[] | undefined;
    brand?: string[] | undefined;

    constructor(data?: ISummaryAdvancedFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            if (Array.isArray(_data["solution"])) {
                this.solution = [] as any;
                for (let item of _data["solution"])
                    this.solution!.push(item);
            }
            if (Array.isArray(_data["productGroup"])) {
                this.productGroup = [] as any;
                for (let item of _data["productGroup"])
                    this.productGroup!.push(item);
            }
            if (Array.isArray(_data["productName"])) {
                this.productName = [] as any;
                for (let item of _data["productName"])
                    this.productName!.push(item);
            }
            if (Array.isArray(_data["productSku"])) {
                this.productSku = [] as any;
                for (let item of _data["productSku"])
                    this.productSku!.push(item);
            }
            if (Array.isArray(_data["brand"])) {
                this.brand = [] as any;
                for (let item of _data["brand"])
                    this.brand!.push(item);
            }
        }
    }

    static fromJS(data: any): SummaryAdvancedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryAdvancedFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        if (Array.isArray(this.solution)) {
            data["solution"] = [];
            for (let item of this.solution)
                data["solution"].push(item);
        }
        if (Array.isArray(this.productGroup)) {
            data["productGroup"] = [];
            for (let item of this.productGroup)
                data["productGroup"].push(item);
        }
        if (Array.isArray(this.productName)) {
            data["productName"] = [];
            for (let item of this.productName)
                data["productName"].push(item);
        }
        if (Array.isArray(this.productSku)) {
            data["productSku"] = [];
            for (let item of this.productSku)
                data["productSku"].push(item);
        }
        if (Array.isArray(this.brand)) {
            data["brand"] = [];
            for (let item of this.brand)
                data["brand"].push(item);
        }
        return data;
    }
}

export interface ISummaryAdvancedFilter {
    platform?: string[] | undefined;
    solution?: string[] | undefined;
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;
    productSku?: string[] | undefined;
    brand?: string[] | undefined;
}

export class GetSolutionParticipationSalesResponse implements IGetSolutionParticipationSalesResponse {
    data?: SolutionParticipationSalesDto[] | undefined;

    constructor(data?: IGetSolutionParticipationSalesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SolutionParticipationSalesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSolutionParticipationSalesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionParticipationSalesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSolutionParticipationSalesResponse {
    data?: SolutionParticipationSalesDto[] | undefined;
}

export class SolutionParticipationSalesDto implements ISolutionParticipationSalesDto {
    solution?: string | undefined;
    totalSales!: number;
    salesTrends?: SaleTrend[] | undefined;

    constructor(data?: ISolutionParticipationSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.totalSales = _data["totalSales"];
            if (Array.isArray(_data["salesTrends"])) {
                this.salesTrends = [] as any;
                for (let item of _data["salesTrends"])
                    this.salesTrends!.push(SaleTrend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SolutionParticipationSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionParticipationSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["totalSales"] = this.totalSales;
        if (Array.isArray(this.salesTrends)) {
            data["salesTrends"] = [];
            for (let item of this.salesTrends)
                data["salesTrends"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISolutionParticipationSalesDto {
    solution?: string | undefined;
    totalSales: number;
    salesTrends?: SaleTrend[] | undefined;
}

export class SaleTrend implements ISaleTrend {
    month?: string | undefined;
    year?: string | undefined;
    saleByMonth!: number;

    constructor(data?: ISaleTrend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.saleByMonth = _data["saleByMonth"];
        }
    }

    static fromJS(data: any): SaleTrend {
        data = typeof data === 'object' ? data : {};
        let result = new SaleTrend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["saleByMonth"] = this.saleByMonth;
        return data;
    }
}

export interface ISaleTrend {
    month?: string | undefined;
    year?: string | undefined;
    saleByMonth: number;
}

export class GetSolutionParticipationSalesRequest implements IGetSolutionParticipationSalesRequest {
    filters!: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;

    constructor(data?: IGetSolutionParticipationSalesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? SummaryAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionParticipationSalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionParticipationSalesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionParticipationSalesRequest {
    filters: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;
}

export class GetSolutionParticipationCasesResponse implements IGetSolutionParticipationCasesResponse {
    data?: SolutionParticipationCasesDto[] | undefined;

    constructor(data?: IGetSolutionParticipationCasesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SolutionParticipationCasesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSolutionParticipationCasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionParticipationCasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSolutionParticipationCasesResponse {
    data?: SolutionParticipationCasesDto[] | undefined;
}

export class SolutionParticipationCasesDto implements ISolutionParticipationCasesDto {
    solution?: string | undefined;
    totalCases!: number;
    casesTrends?: CaseTrend[] | undefined;

    constructor(data?: ISolutionParticipationCasesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.totalCases = _data["totalCases"];
            if (Array.isArray(_data["casesTrends"])) {
                this.casesTrends = [] as any;
                for (let item of _data["casesTrends"])
                    this.casesTrends!.push(CaseTrend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SolutionParticipationCasesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionParticipationCasesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["totalCases"] = this.totalCases;
        if (Array.isArray(this.casesTrends)) {
            data["casesTrends"] = [];
            for (let item of this.casesTrends)
                data["casesTrends"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISolutionParticipationCasesDto {
    solution?: string | undefined;
    totalCases: number;
    casesTrends?: CaseTrend[] | undefined;
}

export class CaseTrend implements ICaseTrend {
    month?: string | undefined;
    year?: string | undefined;
    caseByMonth!: number;

    constructor(data?: ICaseTrend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.caseByMonth = _data["caseByMonth"];
        }
    }

    static fromJS(data: any): CaseTrend {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTrend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["caseByMonth"] = this.caseByMonth;
        return data;
    }
}

export interface ICaseTrend {
    month?: string | undefined;
    year?: string | undefined;
    caseByMonth: number;
}

export class GetSolutionParticipationCasesRequest implements IGetSolutionParticipationCasesRequest {
    filters!: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;

    constructor(data?: IGetSolutionParticipationCasesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? SummaryAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionParticipationCasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionParticipationCasesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionParticipationCasesRequest {
    filters: FilterSet;
    advancedFilter?: SummaryAdvancedFilter | undefined;
}

export class GetSolutionGroupsByLocationResponse implements IGetSolutionGroupsByLocationResponse {
    data?: SpGroupDataResponse | undefined;

    constructor(data?: IGetSolutionGroupsByLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SpGroupDataResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionGroupsByLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionGroupsByLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionGroupsByLocationResponse {
    data?: SpGroupDataResponse | undefined;
}

export class SpGroupDataResponse implements ISpGroupDataResponse {
    totalCount!: number;
    solutionGroups?: string[] | undefined;
    spGroupLocations?: SpGroupLocation[] | undefined;

    constructor(data?: ISpGroupDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["solutionGroups"])) {
                this.solutionGroups = [] as any;
                for (let item of _data["solutionGroups"])
                    this.solutionGroups!.push(item);
            }
            if (Array.isArray(_data["spGroupLocations"])) {
                this.spGroupLocations = [] as any;
                for (let item of _data["spGroupLocations"])
                    this.spGroupLocations!.push(SpGroupLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpGroupDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpGroupDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.solutionGroups)) {
            data["solutionGroups"] = [];
            for (let item of this.solutionGroups)
                data["solutionGroups"].push(item);
        }
        if (Array.isArray(this.spGroupLocations)) {
            data["spGroupLocations"] = [];
            for (let item of this.spGroupLocations)
                data["spGroupLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpGroupDataResponse {
    totalCount: number;
    solutionGroups?: string[] | undefined;
    spGroupLocations?: SpGroupLocation[] | undefined;
}

export class SpGroupLocation implements ISpGroupLocation {
    siteId?: string | undefined;
    siteName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    count!: number;
    compliance!: number;
    greenCount!: number;
    territoryRep?: string | undefined;
    districtManager?: string | undefined;
    areaManager?: string | undefined;
    solutions?: { [key: string]: SolutionGroupStatusData; } | undefined;

    constructor(data?: ISpGroupLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.count = _data["count"];
            this.compliance = _data["compliance"];
            this.greenCount = _data["greenCount"];
            this.territoryRep = _data["territoryRep"];
            this.districtManager = _data["districtManager"];
            this.areaManager = _data["areaManager"];
            if (_data["solutions"]) {
                this.solutions = {} as any;
                for (let key in _data["solutions"]) {
                    if (_data["solutions"].hasOwnProperty(key))
                        (this.solutions as any)![key] = _data["solutions"][key] ? SolutionGroupStatusData.fromJS(_data["solutions"][key]) : new SolutionGroupStatusData();
                }
            }
        }
    }

    static fromJS(data: any): SpGroupLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SpGroupLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["count"] = this.count;
        data["compliance"] = this.compliance;
        data["greenCount"] = this.greenCount;
        data["territoryRep"] = this.territoryRep;
        data["districtManager"] = this.districtManager;
        data["areaManager"] = this.areaManager;
        if (this.solutions) {
            data["solutions"] = {};
            for (let key in this.solutions) {
                if (this.solutions.hasOwnProperty(key))
                    (data["solutions"] as any)[key] = this.solutions[key] ? this.solutions[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface ISpGroupLocation {
    siteId?: string | undefined;
    siteName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    count: number;
    compliance: number;
    greenCount: number;
    territoryRep?: string | undefined;
    districtManager?: string | undefined;
    areaManager?: string | undefined;
    solutions?: { [key: string]: SolutionGroupStatusData; } | undefined;
}

export class SolutionGroupStatusData implements ISolutionGroupStatusData {
    status?: string | undefined;
    complianceStatus!: ProductPurchaseComplianceStatus;
    cases?: string | undefined;
    sales?: string | undefined;

    constructor(data?: ISolutionGroupStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.complianceStatus = _data["complianceStatus"];
            this.cases = _data["cases"];
            this.sales = _data["sales"];
        }
    }

    static fromJS(data: any): SolutionGroupStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionGroupStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["complianceStatus"] = this.complianceStatus;
        data["cases"] = this.cases;
        data["sales"] = this.sales;
        return data;
    }
}

export interface ISolutionGroupStatusData {
    status?: string | undefined;
    complianceStatus: ProductPurchaseComplianceStatus;
    cases?: string | undefined;
    sales?: string | undefined;
}

export enum ProductPurchaseComplianceStatus {
    NotPurchased = "NotPurchased",
    PurchasedNonCompliant = "PurchasedNonCompliant",
    PurchasedCompliant = "PurchasedCompliant",
}

export class GetSolutionGroupsByLocationRequest implements IGetSolutionGroupsByLocationRequest {
    filters!: FilterSet;
    widgetType!: SolutionGroupWidgetType;
    pageRequest?: PageRequest | undefined;
    context!: SolutionSummaryContext;
    advancedFilter?: LocationAdvancedFilter | undefined;

    constructor(data?: IGetSolutionGroupsByLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.widgetType = _data["widgetType"];
            this.pageRequest = _data["pageRequest"] ? PageRequest.fromJS(_data["pageRequest"]) : undefined as any;
            this.context = _data["context"];
            this.advancedFilter = _data["advancedFilter"] ? LocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSolutionGroupsByLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSolutionGroupsByLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["widgetType"] = this.widgetType;
        data["pageRequest"] = this.pageRequest ? this.pageRequest.toJSON() : undefined as any;
        data["context"] = this.context;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSolutionGroupsByLocationRequest {
    filters: FilterSet;
    widgetType: SolutionGroupWidgetType;
    pageRequest?: PageRequest | undefined;
    context: SolutionSummaryContext;
    advancedFilter?: LocationAdvancedFilter | undefined;
}

export class PageRequest implements IPageRequest {
    pageNumber!: number;
    pageSize!: number;

    constructor(data?: IPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPageRequest {
    pageNumber: number;
    pageSize: number;
}

export enum SolutionSummaryContext {
    Sales = "Sales",
    Cases = "Cases",
}

export class ProductAdvancedFilter implements IProductAdvancedFilter {
    accountNumber?: string[] | undefined;
    accountName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;
    productSku?: string[] | undefined;
    brand?: string[] | undefined;

    constructor(data?: IProductAdvancedFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountNumber"])) {
                this.accountNumber = [] as any;
                for (let item of _data["accountNumber"])
                    this.accountNumber!.push(item);
            }
            if (Array.isArray(_data["accountName"])) {
                this.accountName = [] as any;
                for (let item of _data["accountName"])
                    this.accountName!.push(item);
            }
            if (Array.isArray(_data["country"])) {
                this.country = [] as any;
                for (let item of _data["country"])
                    this.country!.push(item);
            }
            if (Array.isArray(_data["state"])) {
                this.state = [] as any;
                for (let item of _data["state"])
                    this.state!.push(item);
            }
            if (Array.isArray(_data["city"])) {
                this.city = [] as any;
                for (let item of _data["city"])
                    this.city!.push(item);
            }
            if (Array.isArray(_data["zipCode"])) {
                this.zipCode = [] as any;
                for (let item of _data["zipCode"])
                    this.zipCode!.push(item);
            }
            if (Array.isArray(_data["productSku"])) {
                this.productSku = [] as any;
                for (let item of _data["productSku"])
                    this.productSku!.push(item);
            }
            if (Array.isArray(_data["brand"])) {
                this.brand = [] as any;
                for (let item of _data["brand"])
                    this.brand!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductAdvancedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAdvancedFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountNumber)) {
            data["accountNumber"] = [];
            for (let item of this.accountNumber)
                data["accountNumber"].push(item);
        }
        if (Array.isArray(this.accountName)) {
            data["accountName"] = [];
            for (let item of this.accountName)
                data["accountName"].push(item);
        }
        if (Array.isArray(this.country)) {
            data["country"] = [];
            for (let item of this.country)
                data["country"].push(item);
        }
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item);
        }
        if (Array.isArray(this.city)) {
            data["city"] = [];
            for (let item of this.city)
                data["city"].push(item);
        }
        if (Array.isArray(this.zipCode)) {
            data["zipCode"] = [];
            for (let item of this.zipCode)
                data["zipCode"].push(item);
        }
        if (Array.isArray(this.productSku)) {
            data["productSku"] = [];
            for (let item of this.productSku)
                data["productSku"].push(item);
        }
        if (Array.isArray(this.brand)) {
            data["brand"] = [];
            for (let item of this.brand)
                data["brand"].push(item);
        }
        return data;
    }
}

export interface IProductAdvancedFilter {
    accountNumber?: string[] | undefined;
    accountName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;
    productSku?: string[] | undefined;
    brand?: string[] | undefined;
}

export class LocationAdvancedFilter extends ProductAdvancedFilter implements ILocationAdvancedFilter {
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;

    constructor(data?: ILocationAdvancedFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["productGroup"])) {
                this.productGroup = [] as any;
                for (let item of _data["productGroup"])
                    this.productGroup!.push(item);
            }
            if (Array.isArray(_data["productName"])) {
                this.productName = [] as any;
                for (let item of _data["productName"])
                    this.productName!.push(item);
            }
        }
    }

    static override fromJS(data: any): LocationAdvancedFilter {
        data = typeof data === 'object' ? data : {};
        let result = new LocationAdvancedFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productGroup)) {
            data["productGroup"] = [];
            for (let item of this.productGroup)
                data["productGroup"].push(item);
        }
        if (Array.isArray(this.productName)) {
            data["productName"] = [];
            for (let item of this.productName)
                data["productName"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILocationAdvancedFilter extends IProductAdvancedFilter {
    productGroup?: string[] | undefined;
    productName?: string[] | undefined;
}

export class GetProductViewResponse implements IGetProductViewResponse {
    data?: ProductViewData | undefined;

    constructor(data?: IGetProductViewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductViewData.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetProductViewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductViewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetProductViewResponse {
    data?: ProductViewData | undefined;
}

export class ProductViewData implements IProductViewData {
    totalCount!: number;
    products?: ViewByProductDto[] | undefined;

    constructor(data?: IProductViewData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ViewByProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductViewData {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductViewData {
    totalCount: number;
    products?: ViewByProductDto[] | undefined;
}

export class ViewByProductDto implements IViewByProductDto {
    productName?: string | undefined;
    productCode?: string | undefined;
    totalSalesAmount!: Money;
    totalSalesQuantity!: number;
    totalAccountCount!: number;
    accountInfo?: AccountInfo[] | undefined;
    region?: string | undefined;

    constructor(data?: IViewByProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalSalesAmount = new Money();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.totalSalesAmount = _data["totalSalesAmount"] ? Money.fromJS(_data["totalSalesAmount"]) : new Money();
            this.totalSalesQuantity = _data["totalSalesQuantity"];
            this.totalAccountCount = _data["totalAccountCount"];
            if (Array.isArray(_data["accountInfo"])) {
                this.accountInfo = [] as any;
                for (let item of _data["accountInfo"])
                    this.accountInfo!.push(AccountInfo.fromJS(item));
            }
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): ViewByProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewByProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["totalSalesAmount"] = this.totalSalesAmount ? this.totalSalesAmount.toJSON() : undefined as any;
        data["totalSalesQuantity"] = this.totalSalesQuantity;
        data["totalAccountCount"] = this.totalAccountCount;
        if (Array.isArray(this.accountInfo)) {
            data["accountInfo"] = [];
            for (let item of this.accountInfo)
                data["accountInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["region"] = this.region;
        return data;
    }
}

export interface IViewByProductDto {
    productName?: string | undefined;
    productCode?: string | undefined;
    totalSalesAmount: Money;
    totalSalesQuantity: number;
    totalAccountCount: number;
    accountInfo?: AccountInfo[] | undefined;
    region?: string | undefined;
}

export class AccountInfo implements IAccountInfo {
    accountName?: string | undefined;
    accountNumber?: string | undefined;

    constructor(data?: IAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAccountInfo {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
}

export class GetProductViewRequest implements IGetProductViewRequest {
    filters!: FilterSet;
    advancedFilter?: ProductAdvancedFilter | undefined;
    drilldownLevel!: ProductDrilldownLevel;
    productCode?: string | undefined;
    solution?: string | undefined;
    searchString?: string | undefined;
    pageRequest?: PageRequest | undefined;
    sortColumn?: SolutionParticipationProductSortColumn | undefined;
    sortDirection?: SortDirection | undefined;

    constructor(data?: IGetProductViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? ProductAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
            this.drilldownLevel = _data["drilldownLevel"];
            this.productCode = _data["productCode"];
            this.solution = _data["solution"];
            this.searchString = _data["searchString"];
            this.pageRequest = _data["pageRequest"] ? PageRequest.fromJS(_data["pageRequest"]) : undefined as any;
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetProductViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        data["drilldownLevel"] = this.drilldownLevel;
        data["productCode"] = this.productCode;
        data["solution"] = this.solution;
        data["searchString"] = this.searchString;
        data["pageRequest"] = this.pageRequest ? this.pageRequest.toJSON() : undefined as any;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetProductViewRequest {
    filters: FilterSet;
    advancedFilter?: ProductAdvancedFilter | undefined;
    drilldownLevel: ProductDrilldownLevel;
    productCode?: string | undefined;
    solution?: string | undefined;
    searchString?: string | undefined;
    pageRequest?: PageRequest | undefined;
    sortColumn?: SolutionParticipationProductSortColumn | undefined;
    sortDirection?: SortDirection | undefined;
}

export enum ProductDrilldownLevel {
    Product = "Product",
    Account = "Account",
}

export enum SolutionParticipationProductSortColumn {
    ProductCode = "ProductCode",
    ProductName = "ProductName",
    TotalSales = "TotalSales",
    TotalCases = "TotalCases",
    TotalAccountCount = "TotalAccountCount",
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class GetLocationViewResponse implements IGetLocationViewResponse {
    data?: LocationViewData | undefined;

    constructor(data?: IGetLocationViewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LocationViewData.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationViewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationViewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationViewResponse {
    data?: LocationViewData | undefined;
}

export class LocationViewData implements ILocationViewData {
    totalUsageLocationCount!: number;
    totalNonUsageLocationCount!: number;
    locations?: ViewByLocationDto[] | undefined;

    constructor(data?: ILocationViewData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsageLocationCount = _data["totalUsageLocationCount"];
            this.totalNonUsageLocationCount = _data["totalNonUsageLocationCount"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ViewByLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationViewData {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViewData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsageLocationCount"] = this.totalUsageLocationCount;
        data["totalNonUsageLocationCount"] = this.totalNonUsageLocationCount;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocationViewData {
    totalUsageLocationCount: number;
    totalNonUsageLocationCount: number;
    locations?: ViewByLocationDto[] | undefined;
}

export class ViewByLocationDto implements IViewByLocationDto {
    mdmSiteId?: string | undefined;
    siteName?: string | undefined;
    accountCount!: number;
    accountNumber?: string | undefined;
    productCount!: number;
    productInfo?: ProductInfo[] | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    totalSales!: Money;
    totalCases!: number;
    postalAddress?: string | undefined;
    isNonUsageLocations!: boolean;
    region?: string | undefined;

    constructor(data?: IViewByLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalSales = new Money();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mdmSiteId = _data["mdmSiteId"];
            this.siteName = _data["siteName"];
            this.accountCount = _data["accountCount"];
            this.accountNumber = _data["accountNumber"];
            this.productCount = _data["productCount"];
            if (Array.isArray(_data["productInfo"])) {
                this.productInfo = [] as any;
                for (let item of _data["productInfo"])
                    this.productInfo!.push(ProductInfo.fromJS(item));
            }
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.totalSales = _data["totalSales"] ? Money.fromJS(_data["totalSales"]) : new Money();
            this.totalCases = _data["totalCases"];
            this.postalAddress = _data["postalAddress"];
            this.isNonUsageLocations = _data["isNonUsageLocations"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): ViewByLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewByLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdmSiteId"] = this.mdmSiteId;
        data["siteName"] = this.siteName;
        data["accountCount"] = this.accountCount;
        data["accountNumber"] = this.accountNumber;
        data["productCount"] = this.productCount;
        if (Array.isArray(this.productInfo)) {
            data["productInfo"] = [];
            for (let item of this.productInfo)
                data["productInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["totalSales"] = this.totalSales ? this.totalSales.toJSON() : undefined as any;
        data["totalCases"] = this.totalCases;
        data["postalAddress"] = this.postalAddress;
        data["isNonUsageLocations"] = this.isNonUsageLocations;
        data["region"] = this.region;
        return data;
    }
}

export interface IViewByLocationDto {
    mdmSiteId?: string | undefined;
    siteName?: string | undefined;
    accountCount: number;
    accountNumber?: string | undefined;
    productCount: number;
    productInfo?: ProductInfo[] | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    totalSales: Money;
    totalCases: number;
    postalAddress?: string | undefined;
    isNonUsageLocations: boolean;
    region?: string | undefined;
}

export class ProductInfo implements IProductInfo {
    productName?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IProductInfo {
    productName?: string | undefined;
    productCode?: string | undefined;
}

export class GetLocationViewRequest implements IGetLocationViewRequest {
    filters!: FilterSet;
    advancedFilter?: LocationAdvancedFilter | undefined;
    drilldownLevel!: LocationDrilldownLevel;
    siteId?: string | undefined;
    solution?: string | undefined;
    searchString?: string | undefined;
    pageRequest?: PageRequest | undefined;
    sortColumn?: SolutionParticipationLocationSortColumn | undefined;
    sortDirection?: SortDirection | undefined;

    constructor(data?: IGetLocationViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? LocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
            this.drilldownLevel = _data["drilldownLevel"];
            this.siteId = _data["siteId"];
            this.solution = _data["solution"];
            this.searchString = _data["searchString"];
            this.pageRequest = _data["pageRequest"] ? PageRequest.fromJS(_data["pageRequest"]) : undefined as any;
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetLocationViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        data["drilldownLevel"] = this.drilldownLevel;
        data["siteId"] = this.siteId;
        data["solution"] = this.solution;
        data["searchString"] = this.searchString;
        data["pageRequest"] = this.pageRequest ? this.pageRequest.toJSON() : undefined as any;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetLocationViewRequest {
    filters: FilterSet;
    advancedFilter?: LocationAdvancedFilter | undefined;
    drilldownLevel: LocationDrilldownLevel;
    siteId?: string | undefined;
    solution?: string | undefined;
    searchString?: string | undefined;
    pageRequest?: PageRequest | undefined;
    sortColumn?: SolutionParticipationLocationSortColumn | undefined;
    sortDirection?: SortDirection | undefined;
}

export enum LocationDrilldownLevel {
    Location = "Location",
    Account = "Account",
}

export enum SolutionParticipationLocationSortColumn {
    SiteId = "SiteId",
    SiteName = "SiteName",
    TotalSales = "TotalSales",
    TotalCases = "TotalCases",
    City = "City",
    Country = "Country",
}

export class GetLocationRebateWidgetDataResponse implements IGetLocationRebateWidgetDataResponse {
    data?: SPLocationRebateWidgetDTO | undefined;

    constructor(data?: IGetLocationRebateWidgetDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SPLocationRebateWidgetDTO.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationRebateWidgetDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationRebateWidgetDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationRebateWidgetDataResponse {
    data?: SPLocationRebateWidgetDTO | undefined;
}

export class SPLocationRebateWidgetDTO implements ISPLocationRebateWidgetDTO {
    totalLocations!: number;
    totalCompliantLocations!: number;
    complianceTarget!: number;
    solutionGroups?: string[] | undefined;

    constructor(data?: ISPLocationRebateWidgetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLocations = _data["totalLocations"];
            this.totalCompliantLocations = _data["totalCompliantLocations"];
            this.complianceTarget = _data["complianceTarget"];
            if (Array.isArray(_data["solutionGroups"])) {
                this.solutionGroups = [] as any;
                for (let item of _data["solutionGroups"])
                    this.solutionGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): SPLocationRebateWidgetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SPLocationRebateWidgetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLocations"] = this.totalLocations;
        data["totalCompliantLocations"] = this.totalCompliantLocations;
        data["complianceTarget"] = this.complianceTarget;
        if (Array.isArray(this.solutionGroups)) {
            data["solutionGroups"] = [];
            for (let item of this.solutionGroups)
                data["solutionGroups"].push(item);
        }
        return data;
    }
}

export interface ISPLocationRebateWidgetDTO {
    totalLocations: number;
    totalCompliantLocations: number;
    complianceTarget: number;
    solutionGroups?: string[] | undefined;
}

export class GetLocationRebateWidgetDataRequest implements IGetLocationRebateWidgetDataRequest {
    filters!: FilterSet;
    advancedFilter?: LocationAdvancedFilter | undefined;

    constructor(data?: IGetLocationRebateWidgetDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.advancedFilter = _data["advancedFilter"] ? LocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationRebateWidgetDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationRebateWidgetDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationRebateWidgetDataRequest {
    filters: FilterSet;
    advancedFilter?: LocationAdvancedFilter | undefined;
}

export class GetLocationProductListWidgetDataResponse implements IGetLocationProductListWidgetDataResponse {
    data?: SPLocationProductListWidgetDTO | undefined;

    constructor(data?: IGetLocationProductListWidgetDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SPLocationProductListWidgetDTO.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationProductListWidgetDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationProductListWidgetDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationProductListWidgetDataResponse {
    data?: SPLocationProductListWidgetDTO | undefined;
}

export class SPLocationProductListWidgetDTO implements ISPLocationProductListWidgetDTO {
    totalLocations!: number;
    avgProductListPurchased!: number;
    productListCount!: number;
    productListType?: string | undefined;

    constructor(data?: ISPLocationProductListWidgetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLocations = _data["totalLocations"];
            this.avgProductListPurchased = _data["avgProductListPurchased"];
            this.productListCount = _data["productListCount"];
            this.productListType = _data["productListType"];
        }
    }

    static fromJS(data: any): SPLocationProductListWidgetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SPLocationProductListWidgetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLocations"] = this.totalLocations;
        data["avgProductListPurchased"] = this.avgProductListPurchased;
        data["productListCount"] = this.productListCount;
        data["productListType"] = this.productListType;
        return data;
    }
}

export interface ISPLocationProductListWidgetDTO {
    totalLocations: number;
    avgProductListPurchased: number;
    productListCount: number;
    productListType?: string | undefined;
}

export class GetLocationProductListWidgetDataRequest implements IGetLocationProductListWidgetDataRequest {
    filters!: FilterSet;
    widgetType!: SolutionGroupWidgetType;
    advancedFilter?: LocationAdvancedFilter | undefined;

    constructor(data?: IGetLocationProductListWidgetDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.widgetType = _data["widgetType"];
            this.advancedFilter = _data["advancedFilter"] ? LocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLocationProductListWidgetDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationProductListWidgetDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["widgetType"] = this.widgetType;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationProductListWidgetDataRequest {
    filters: FilterSet;
    widgetType: SolutionGroupWidgetType;
    advancedFilter?: LocationAdvancedFilter | undefined;
}

export class ExportSolutionGroupsDataRequest implements IExportSolutionGroupsDataRequest {
    filters!: FilterSet;
    widgetType!: SolutionGroupWidgetType;
    advancedFilter?: LocationAdvancedFilter | undefined;

    constructor(data?: IExportSolutionGroupsDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.widgetType = _data["widgetType"];
            this.advancedFilter = _data["advancedFilter"] ? LocationAdvancedFilter.fromJS(_data["advancedFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExportSolutionGroupsDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSolutionGroupsDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["widgetType"] = this.widgetType;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IExportSolutionGroupsDataRequest {
    filters: FilterSet;
    widgetType: SolutionGroupWidgetType;
    advancedFilter?: LocationAdvancedFilter | undefined;
}

export class ExportProductDataRequest implements IExportProductDataRequest {
    filters!: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;

    constructor(data?: IExportProductDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            if (Array.isArray(_data["queryFilters"])) {
                this.queryFilters = [] as any;
                for (let item of _data["queryFilters"])
                    this.queryFilters!.push(QueryFilter.fromJS(item));
            }
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): ExportProductDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProductDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        if (Array.isArray(this.queryFilters)) {
            data["queryFilters"] = [];
            for (let item of this.queryFilters)
                data["queryFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["searchTerm"] = this.searchTerm;
        return data;
    }
}

export interface IExportProductDataRequest {
    filters: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;
}

export class QueryFilter implements IQueryFilter {
    columnFilters?: { [key: string]: any; } | undefined;
    filterOperation?: string | undefined;
    logicalOperator?: string | undefined;

    constructor(data?: IQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["columnFilters"]) {
                this.columnFilters = {} as any;
                for (let key in _data["columnFilters"]) {
                    if (_data["columnFilters"].hasOwnProperty(key))
                        (this.columnFilters as any)![key] = _data["columnFilters"][key];
                }
            }
            this.filterOperation = _data["filterOperation"];
            this.logicalOperator = _data["logicalOperator"];
        }
    }

    static fromJS(data: any): QueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new QueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columnFilters) {
            data["columnFilters"] = {};
            for (let key in this.columnFilters) {
                if (this.columnFilters.hasOwnProperty(key))
                    (data["columnFilters"] as any)[key] = (this.columnFilters as any)[key];
            }
        }
        data["filterOperation"] = this.filterOperation;
        data["logicalOperator"] = this.logicalOperator;
        return data;
    }
}

export interface IQueryFilter {
    columnFilters?: { [key: string]: any; } | undefined;
    filterOperation?: string | undefined;
    logicalOperator?: string | undefined;
}

export class ExportLocationUsageDataRequest implements IExportLocationUsageDataRequest {
    filters!: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;

    constructor(data?: IExportLocationUsageDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            if (Array.isArray(_data["queryFilters"])) {
                this.queryFilters = [] as any;
                for (let item of _data["queryFilters"])
                    this.queryFilters!.push(QueryFilter.fromJS(item));
            }
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): ExportLocationUsageDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLocationUsageDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        if (Array.isArray(this.queryFilters)) {
            data["queryFilters"] = [];
            for (let item of this.queryFilters)
                data["queryFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["searchTerm"] = this.searchTerm;
        return data;
    }
}

export interface IExportLocationUsageDataRequest {
    filters: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;
}

export class ExportLocationNonUsageDataRequest implements IExportLocationNonUsageDataRequest {
    filters!: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;

    constructor(data?: IExportLocationNonUsageDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            if (Array.isArray(_data["queryFilters"])) {
                this.queryFilters = [] as any;
                for (let item of _data["queryFilters"])
                    this.queryFilters!.push(QueryFilter.fromJS(item));
            }
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): ExportLocationNonUsageDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLocationNonUsageDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        if (Array.isArray(this.queryFilters)) {
            data["queryFilters"] = [];
            for (let item of this.queryFilters)
                data["queryFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["searchTerm"] = this.searchTerm;
        return data;
    }
}

export interface IExportLocationNonUsageDataRequest {
    filters: FilterSet;
    queryFilters?: QueryFilter[] | undefined;
    searchTerm?: string | undefined;
}

export class GetPolicyResponse implements IGetPolicyResponse {
    data?: UserPolicy | undefined;

    constructor(data?: IGetPolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserPolicy.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPolicyResponse {
    data?: UserPolicy | undefined;
}

/** Represents the effective policy information for the current user, including assigned roles and permissions. */
export class UserPolicy implements IUserPolicy {
    /** Gets the roles assigned to the user. */
    roles?: Role[] | undefined;
    /** Gets the permissions granted to the user. */
    permissions?: Permission[] | undefined;
    /** Gets basic information about the user for whom the policy was evaluated. */
    user?: UserInfo | undefined;

    constructor(data?: IUserPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.user = _data["user"] ? UserInfo.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new UserPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

/** Represents the effective policy information for the current user, including assigned roles and permissions. */
export interface IUserPolicy {
    /** Gets the roles assigned to the user. */
    roles?: Role[] | undefined;
    /** Gets the permissions granted to the user. */
    permissions?: Permission[] | undefined;
    /** Gets basic information about the user for whom the policy was evaluated. */
    user?: UserInfo | undefined;
}

export enum Role {
    CorporateAccountManager = "CorporateAccountManager",
    Customer = "Customer",
}

export enum Permission {
    Blueprint = "Blueprint",
    ProgramHub = "ProgramHub",
    Impersonation = "Impersonation",
    TVDForAPInstitutional = "TVDForAPInstitutional",
    TVDForLAInstitutional = "TVDForLAInstitutional",
    TVDAndSPForIMEAInstitutional = "TVDAndSPForIMEAInstitutional",
    DistributorSupplyChainMetrics = "DistributorSupplyChainMetrics",
    DistributorEndCustomerCount = "DistributorEndCustomerCount",
    CurrencyServiceFallbackLogic = "CurrencyServiceFallbackLogic",
    TvdBrandGroupTabs = "TvdBrandGroupTabs",
    ActionCenter = "ActionCenter",
    AuditMetricForFRS = "AuditMetricForFRS",
    AuditMetricForQSR = "AuditMetricForQSR",
    CostAssumptionsQSR = "CostAssumptionsQSR",
    CurrencyAndUoMConversion = "CurrencyAndUoMConversion",
    CustomerView = "CustomerView",
    FRSSIEuropeRegion = "FRSSIEuropeRegion",
    OnlineAccess = "OnlineAccess",
}

/** Represents basic user information returned as part of a policy response. */
export class UserInfo implements IUserInfo {
    /** Gets the user's given name. */
    firstName?: string | undefined;
    /** Gets the user's family name. */
    lastName?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

/** Represents basic user information returned as part of a policy response. */
export interface IUserInfo {
    /** Gets the user's given name. */
    firstName?: string | undefined;
    /** Gets the user's family name. */
    lastName?: string | undefined;
}

export class GetFilterHierarchyResponse implements IGetFilterHierarchyResponse {
    data?: ViewFilterHierarchy | undefined;

    constructor(data?: IGetFilterHierarchyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ViewFilterHierarchy.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFilterHierarchyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilterHierarchyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFilterHierarchyResponse {
    data?: ViewFilterHierarchy | undefined;
}

export class ViewFilterHierarchy implements IViewFilterHierarchy {
    division!: Division;
    criteria?: HierarchyCriteriaDto | undefined;
    nodes?: HierarchyNodeDto[] | undefined;

    constructor(data?: IViewFilterHierarchy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.criteria = _data["criteria"] ? HierarchyCriteriaDto.fromJS(_data["criteria"]) : undefined as any;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(HierarchyNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViewFilterHierarchy {
        data = typeof data === 'object' ? data : {};
        let result = new ViewFilterHierarchy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : undefined as any;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IViewFilterHierarchy {
    division: Division;
    criteria?: HierarchyCriteriaDto | undefined;
    nodes?: HierarchyNodeDto[] | undefined;
}

export class HierarchyCriteriaDto implements IHierarchyCriteriaDto {
    division?: string | undefined;
    dateRange?: string | undefined;
    regions?: string[] | undefined;
    countries?: string[] | undefined;

    constructor(data?: IHierarchyCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            this.dateRange = _data["dateRange"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
        }
    }

    static fromJS(data: any): HierarchyCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        data["dateRange"] = this.dateRange;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        return data;
    }
}

export interface IHierarchyCriteriaDto {
    division?: string | undefined;
    dateRange?: string | undefined;
    regions?: string[] | undefined;
    countries?: string[] | undefined;
}

export class HierarchyNodeDto implements IHierarchyNodeDto {
    id?: string | undefined;
    region?: string | undefined;
    country?: string | undefined;
    level!: number;
    hierarchyLevelName?: string | undefined;
    number?: string | undefined;
    name?: string | undefined;
    childCount!: number;
    accountCount!: number;
    children?: HierarchyNodeDto[] | undefined;

    constructor(data?: IHierarchyNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.region = _data["region"];
            this.country = _data["country"];
            this.level = _data["level"];
            this.hierarchyLevelName = _data["hierarchyLevelName"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.childCount = _data["childCount"];
            this.accountCount = _data["accountCount"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(HierarchyNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HierarchyNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["region"] = this.region;
        data["country"] = this.country;
        data["level"] = this.level;
        data["hierarchyLevelName"] = this.hierarchyLevelName;
        data["number"] = this.number;
        data["name"] = this.name;
        data["childCount"] = this.childCount;
        data["accountCount"] = this.accountCount;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHierarchyNodeDto {
    id?: string | undefined;
    region?: string | undefined;
    country?: string | undefined;
    level: number;
    hierarchyLevelName?: string | undefined;
    number?: string | undefined;
    name?: string | undefined;
    childCount: number;
    accountCount: number;
    children?: HierarchyNodeDto[] | undefined;
}

/** Response model for the GetUsers endpoint. */
export class GetUsersResponse implements IGetUsersResponse {
    data?: CustomerUser[] | undefined;

    constructor(data?: IGetUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CustomerUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response model for the GetUsers endpoint. */
export interface IGetUsersResponse {
    data?: CustomerUser[] | undefined;
}

export class CustomerUser implements ICustomerUser {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ICustomerUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): CustomerUser {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ICustomerUser {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

/** Request model for the GetUsers endpoint. */
export class GetUsersRequest implements IGetUsersRequest {

    constructor(data?: IGetUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for the GetUsers endpoint. */
export interface IGetUsersRequest {
}

/** Response model for the GetCustomers endpoint. */
export class GetCustomersResponse implements IGetCustomersResponse {
    data?: Customer[] | undefined;

    constructor(data?: IGetCustomersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Customer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response model for the GetCustomers endpoint. */
export interface IGetCustomersResponse {
    data?: Customer[] | undefined;
}

export class Customer implements ICustomer {
    name?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomer {
    name?: string | undefined;
}

/** Response model for the GetCurrencies endpoint. */
export class GetCurrenciesResponse implements IGetCurrenciesResponse {
    data?: CurrencyDefinition[] | undefined;

    constructor(data?: IGetCurrenciesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CurrencyDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrenciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response model for the GetCurrencies endpoint. */
export interface IGetCurrenciesResponse {
    data?: CurrencyDefinition[] | undefined;
}

export class CurrencyDefinition implements ICurrencyDefinition {
    currencyCodeId!: RecognizedCurrencyCode;
    currencyName?: string | undefined;
    symbol?: string | undefined;

    constructor(data?: ICurrencyDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCodeId = _data["currencyCodeId"];
            this.currencyName = _data["currencyName"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): CurrencyDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCodeId"] = this.currencyCodeId;
        data["currencyName"] = this.currencyName;
        data["symbol"] = this.symbol;
        return data;
    }
}

export interface ICurrencyDefinition {
    currencyCodeId: RecognizedCurrencyCode;
    currencyName?: string | undefined;
    symbol?: string | undefined;
}

/** Response model for the GetConversionRate endpoint. */
export class GetConversionRateResponse implements IGetConversionRateResponse {
    data!: number;

    constructor(data?: IGetConversionRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetConversionRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversionRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

/** Response model for the GetConversionRate endpoint. */
export interface IGetConversionRateResponse {
    data: number;
}

/** Request model for the GetConversionRate endpoint. */
export class GetConversionRateRequest implements IGetConversionRateRequest {

    constructor(data?: IGetConversionRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetConversionRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversionRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for the GetConversionRate endpoint. */
export interface IGetConversionRateRequest {
}

export class GetConfigurationResponse implements IGetConfigurationResponse {
    data?: UiConfigurationSettings | undefined;

    constructor(data?: IGetConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UiConfigurationSettings.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConfigurationResponse {
    data?: UiConfigurationSettings | undefined;
}

export class UiConfigurationSettings implements IUiConfigurationSettings {
    azureMonitorConnectionString?: string | undefined;
    azureMonitorDiagnosticsIsDistributedTracingEnabled!: boolean;
    downloadSettings?: DownloadSettings | undefined;
    globalErrorHandlingLogErrorToConsole!: boolean;
    hostSettings?: HostSettings | undefined;
    featureFlags?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUiConfigurationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureMonitorConnectionString = _data["azureMonitorConnectionString"];
            this.azureMonitorDiagnosticsIsDistributedTracingEnabled = _data["azureMonitorDiagnosticsIsDistributedTracingEnabled"];
            this.downloadSettings = _data["downloadSettings"] ? DownloadSettings.fromJS(_data["downloadSettings"]) : undefined as any;
            this.globalErrorHandlingLogErrorToConsole = _data["globalErrorHandlingLogErrorToConsole"];
            this.hostSettings = _data["hostSettings"] ? HostSettings.fromJS(_data["hostSettings"]) : undefined as any;
            if (_data["featureFlags"]) {
                this.featureFlags = {} as any;
                for (let key in _data["featureFlags"]) {
                    if (_data["featureFlags"].hasOwnProperty(key))
                        (this.featureFlags as any)![key] = _data["featureFlags"][key];
                }
            }
        }
    }

    static fromJS(data: any): UiConfigurationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UiConfigurationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureMonitorConnectionString"] = this.azureMonitorConnectionString;
        data["azureMonitorDiagnosticsIsDistributedTracingEnabled"] = this.azureMonitorDiagnosticsIsDistributedTracingEnabled;
        data["downloadSettings"] = this.downloadSettings ? this.downloadSettings.toJSON() : undefined as any;
        data["globalErrorHandlingLogErrorToConsole"] = this.globalErrorHandlingLogErrorToConsole;
        data["hostSettings"] = this.hostSettings ? this.hostSettings.toJSON() : undefined as any;
        if (this.featureFlags) {
            data["featureFlags"] = {};
            for (let key in this.featureFlags) {
                if (this.featureFlags.hasOwnProperty(key))
                    (data["featureFlags"] as any)[key] = (this.featureFlags as any)[key];
            }
        }
        return data;
    }
}

export interface IUiConfigurationSettings {
    azureMonitorConnectionString?: string | undefined;
    azureMonitorDiagnosticsIsDistributedTracingEnabled: boolean;
    downloadSettings?: DownloadSettings | undefined;
    globalErrorHandlingLogErrorToConsole: boolean;
    hostSettings?: HostSettings | undefined;
    featureFlags?: { [key: string]: boolean; } | undefined;
}

export class DownloadSettings implements IDownloadSettings {
    maxPhotoSelection!: number;

    constructor(data?: IDownloadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxPhotoSelection = _data["maxPhotoSelection"];
        }
    }

    static fromJS(data: any): DownloadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxPhotoSelection"] = this.maxPhotoSelection;
        return data;
    }
}

export interface IDownloadSettings {
    maxPhotoSelection: number;
}

export class HostSettings implements IHostSettings {
    ebrUrl?: string | undefined;
    ebrApiUrl?: string | undefined;
    programHubUrlHost?: string | undefined;
    mixpanel?: Mixpanel | undefined;

    constructor(data?: IHostSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebrUrl = _data["ebrUrl"];
            this.ebrApiUrl = _data["ebrApiUrl"];
            this.programHubUrlHost = _data["programHubUrlHost"];
            this.mixpanel = _data["mixpanel"] ? Mixpanel.fromJS(_data["mixpanel"]) : undefined as any;
        }
    }

    static fromJS(data: any): HostSettings {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebrUrl"] = this.ebrUrl;
        data["ebrApiUrl"] = this.ebrApiUrl;
        data["programHubUrlHost"] = this.programHubUrlHost;
        data["mixpanel"] = this.mixpanel ? this.mixpanel.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostSettings {
    ebrUrl?: string | undefined;
    ebrApiUrl?: string | undefined;
    programHubUrlHost?: string | undefined;
    mixpanel?: Mixpanel | undefined;
}

export class Mixpanel implements IMixpanel {
    token?: string | undefined;
    environment?: string | undefined;
    sessionReplayCaptureRate!: number;

    constructor(data?: IMixpanel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.environment = _data["environment"];
            this.sessionReplayCaptureRate = _data["sessionReplayCaptureRate"];
        }
    }

    static fromJS(data: any): Mixpanel {
        data = typeof data === 'object' ? data : {};
        let result = new Mixpanel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["environment"] = this.environment;
        data["sessionReplayCaptureRate"] = this.sessionReplayCaptureRate;
        return data;
    }
}

export interface IMixpanel {
    token?: string | undefined;
    environment?: string | undefined;
    sessionReplayCaptureRate: number;
}

export class SaveUserServiceInsightRequest implements ISaveUserServiceInsightRequest {
    filters!: FilterSet;
    email!: string;
    userServiceInsightModel!: UserServiceInsightModel[];

    constructor(data?: ISaveUserServiceInsightRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
            this.userServiceInsightModel = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.email = _data["email"];
            if (Array.isArray(_data["userServiceInsightModel"])) {
                this.userServiceInsightModel = [] as any;
                for (let item of _data["userServiceInsightModel"])
                    this.userServiceInsightModel!.push(UserServiceInsightModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveUserServiceInsightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserServiceInsightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["email"] = this.email;
        if (Array.isArray(this.userServiceInsightModel)) {
            data["userServiceInsightModel"] = [];
            for (let item of this.userServiceInsightModel)
                data["userServiceInsightModel"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveUserServiceInsightRequest {
    filters: FilterSet;
    email: string;
    userServiceInsightModel: UserServiceInsightModel[];
}

export abstract class BaseEntity implements IBaseEntity {
    email?: string | undefined;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IBaseEntity {
    email?: string | undefined;
}

export class UserServiceInsightModel extends BaseEntity implements IUserServiceInsightModel {
    finding?: string | undefined;
    nextSteps?: string[] | undefined;
    implications?: string[] | undefined;
    isAddedToPPt!: boolean;
    creationDate!: Date;

    constructor(data?: IUserServiceInsightModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.finding = _data["finding"];
            if (Array.isArray(_data["nextSteps"])) {
                this.nextSteps = [] as any;
                for (let item of _data["nextSteps"])
                    this.nextSteps!.push(item);
            }
            if (Array.isArray(_data["implications"])) {
                this.implications = [] as any;
                for (let item of _data["implications"])
                    this.implications!.push(item);
            }
            this.isAddedToPPt = _data["isAddedToPPt"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): UserServiceInsightModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserServiceInsightModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finding"] = this.finding;
        if (Array.isArray(this.nextSteps)) {
            data["nextSteps"] = [];
            for (let item of this.nextSteps)
                data["nextSteps"].push(item);
        }
        if (Array.isArray(this.implications)) {
            data["implications"] = [];
            for (let item of this.implications)
                data["implications"].push(item);
        }
        data["isAddedToPPt"] = this.isAddedToPPt;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IUserServiceInsightModel extends IBaseEntity {
    finding?: string | undefined;
    nextSteps?: string[] | undefined;
    implications?: string[] | undefined;
    isAddedToPPt: boolean;
    creationDate: Date;
}

export class GetTotalLocationsServicedResponse implements IGetTotalLocationsServicedResponse {
    data?: ServiceInsightsPestKPIModel | undefined;

    constructor(data?: IGetTotalLocationsServicedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ServiceInsightsPestKPIModel.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTotalLocationsServicedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalLocationsServicedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalLocationsServicedResponse {
    data?: ServiceInsightsPestKPIModel | undefined;
}

export class ServiceInsightsPestKPIModel implements IServiceInsightsPestKPIModel {
    type!: PestKPITypes;
    totalCount!: number;

    constructor(data?: IServiceInsightsPestKPIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceInsightsPestKPIModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsPestKPIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IServiceInsightsPestKPIModel {
    type: PestKPITypes;
    totalCount: number;
}

export enum PestKPITypes {
    TotalLocationsServiced = "TotalLocationsServiced",
    TotalScanCount = "TotalScanCount",
}

export class GetTotalLocationsServicedRequest implements IGetTotalLocationsServicedRequest {
    filters!: FilterSet;

    constructor(data?: IGetTotalLocationsServicedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetTotalLocationsServicedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalLocationsServicedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalLocationsServicedRequest {
    filters: FilterSet;
}

export class GetTotalCallsClosedResponse implements IGetTotalCallsClosedResponse {
    data?: ServiceInsightsPestCallsClosedDTO | undefined;

    constructor(data?: IGetTotalCallsClosedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ServiceInsightsPestCallsClosedDTO.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTotalCallsClosedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalCallsClosedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalCallsClosedResponse {
    data?: ServiceInsightsPestCallsClosedDTO | undefined;
}

export class ServiceInsightsPestCallsClosedDTO implements IServiceInsightsPestCallsClosedDTO {
    totalCalls!: number;
    callsClosed!: number;
    percentOfCallsClosed!: number;

    constructor(data?: IServiceInsightsPestCallsClosedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCalls = _data["totalCalls"];
            this.callsClosed = _data["callsClosed"];
            this.percentOfCallsClosed = _data["percentOfCallsClosed"];
        }
    }

    static fromJS(data: any): ServiceInsightsPestCallsClosedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsPestCallsClosedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCalls"] = this.totalCalls;
        data["callsClosed"] = this.callsClosed;
        data["percentOfCallsClosed"] = this.percentOfCallsClosed;
        return data;
    }
}

export interface IServiceInsightsPestCallsClosedDTO {
    totalCalls: number;
    callsClosed: number;
    percentOfCallsClosed: number;
}

export class GetTotalCallsClosedRequest implements IGetTotalCallsClosedRequest {
    filters!: FilterSet;

    constructor(data?: IGetTotalCallsClosedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetTotalCallsClosedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalCallsClosedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalCallsClosedRequest {
    filters: FilterSet;
}

export class GetTotalCallsByTypeResponse implements IGetTotalCallsByTypeResponse {
    data?: SITotalCallsData | undefined;

    constructor(data?: IGetTotalCallsByTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SITotalCallsData.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTotalCallsByTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalCallsByTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalCallsByTypeResponse {
    data?: SITotalCallsData | undefined;
}

export class SITotalCallsData implements ISITotalCallsData {
    totalCalls?: TotalCallsInsightModel[] | undefined;

    constructor(data?: ISITotalCallsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totalCalls"])) {
                this.totalCalls = [] as any;
                for (let item of _data["totalCalls"])
                    this.totalCalls!.push(TotalCallsInsightModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SITotalCallsData {
        data = typeof data === 'object' ? data : {};
        let result = new SITotalCallsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totalCalls)) {
            data["totalCalls"] = [];
            for (let item of this.totalCalls)
                data["totalCalls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISITotalCallsData {
    totalCalls?: TotalCallsInsightModel[] | undefined;
}

export class TotalCallsInsightModel implements ITotalCallsInsightModel {
    callReason?: string | undefined;
    total!: number;
    totalLocations!: number;

    constructor(data?: ITotalCallsInsightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callReason = _data["callReason"];
            this.total = _data["total"];
            this.totalLocations = _data["totalLocations"];
        }
    }

    static fromJS(data: any): TotalCallsInsightModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotalCallsInsightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callReason"] = this.callReason;
        data["total"] = this.total;
        data["totalLocations"] = this.totalLocations;
        return data;
    }
}

export interface ITotalCallsInsightModel {
    callReason?: string | undefined;
    total: number;
    totalLocations: number;
}

export class GetTotalCallsByTypeRequest implements IGetTotalCallsByTypeRequest {
    metricType!: ServiceMetricTypes;
    filters!: FilterSet;

    constructor(data?: IGetTotalCallsByTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricType = _data["metricType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetTotalCallsByTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalCallsByTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricType"] = this.metricType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTotalCallsByTypeRequest {
    metricType: ServiceMetricTypes;
    filters: FilterSet;
}

export enum ServiceMetricTypes {
    Calls = "Calls",
    Observations = "Observations",
    Services = "Services",
    Findings = "Findings",
    CallsByReason = "CallsByReason",
    PestCatches = "PestCatches",
}

export class GetServiceMetricDetailsKpisResponse implements IGetServiceMetricDetailsKpisResponse {
    data?: ServiceInsightsDetailsKpiCardsData[] | undefined;

    constructor(data?: IGetServiceMetricDetailsKpisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceInsightsDetailsKpiCardsData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServiceMetricDetailsKpisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricDetailsKpisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetServiceMetricDetailsKpisResponse {
    data?: ServiceInsightsDetailsKpiCardsData[] | undefined;
}

export class ServiceInsightsDetailsKpiCardsData implements IServiceInsightsDetailsKpiCardsData {
    period!: RollingTimePeriodKind;
    metricTotal?: number | undefined;
    percentageChange?: number | undefined;

    constructor(data?: IServiceInsightsDetailsKpiCardsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.metricTotal = _data["metricTotal"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): ServiceInsightsDetailsKpiCardsData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsDetailsKpiCardsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["metricTotal"] = this.metricTotal;
        data["percentageChange"] = this.percentageChange;
        return data;
    }
}

export interface IServiceInsightsDetailsKpiCardsData {
    period: RollingTimePeriodKind;
    metricTotal?: number | undefined;
    percentageChange?: number | undefined;
}

export class GetServiceMetricDetailsKpisRequest implements IGetServiceMetricDetailsKpisRequest {
    filters!: FilterSet;

    constructor(data?: IGetServiceMetricDetailsKpisRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceMetricDetailsKpisRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricDetailsKpisRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricDetailsKpisRequest {
    filters: FilterSet;
}

export enum SICallTypes {
    UntrackedCalls = "UntrackedCalls",
    TotalCalls = "TotalCalls",
    PhotoObservations = "PhotoObservations",
    VirtualAssistCalls = "VirtualAssistCalls",
    ExtraServiceVisit = "ExtraServiceVisit",
    RegularServiceCalls = "RegularServiceCalls",
    ProgramReviews = "ProgramReviews",
    Installations = "Installations",
    QuickCalls = "QuickCalls",
    Audit = "Audit",
    TrainingSessions = "TrainingSessions",
    DedicatedTrainingCalls = "DedicatedTrainingCalls",
    TrainingTopics = "TrainingTopics",
    InServiceTraining = "InServiceTraining",
    ContractedCleanOut = "ContractedCleanOut",
    ContractedRegular = "ContractedRegular",
    ExtraOneShot = "ExtraOneShot",
    ExtraFollowUp = "ExtraFollowUp",
    Pest = "Pest",
    Sanitation = "Sanitation",
    Structural = "Structural",
    Prep = "Prep",
    ExtraServiceRequest = "ExtraServiceRequest",
}

export class GetServiceMetricByTypeByPeriodResponse implements IGetServiceMetricByTypeByPeriodResponse {
    data?: SIMetricDataByPeriod | undefined;

    constructor(data?: IGetServiceMetricByTypeByPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SIMetricDataByPeriod.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricByTypeByPeriodResponse {
    data?: SIMetricDataByPeriod | undefined;
}

export class SIMetricDataByPeriod implements ISIMetricDataByPeriod {
    periods?: MetricsbyPeriod[] | undefined;
    percentChangeInCount?: number | undefined;
    distinctLocationsCount?: number | undefined;

    constructor(data?: ISIMetricDataByPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(MetricsbyPeriod.fromJS(item));
            }
            this.percentChangeInCount = _data["percentChangeInCount"];
            this.distinctLocationsCount = _data["distinctLocationsCount"];
        }
    }

    static fromJS(data: any): SIMetricDataByPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new SIMetricDataByPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item ? item.toJSON() : undefined as any);
        }
        data["percentChangeInCount"] = this.percentChangeInCount;
        data["distinctLocationsCount"] = this.distinctLocationsCount;
        return data;
    }
}

export interface ISIMetricDataByPeriod {
    periods?: MetricsbyPeriod[] | undefined;
    percentChangeInCount?: number | undefined;
    distinctLocationsCount?: number | undefined;
}

export class MetricsbyPeriod implements IMetricsbyPeriod {
    callReason!: SICallTypes;
    endDate?: string | undefined;
    total!: number;
    totalLocations!: number;

    constructor(data?: IMetricsbyPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callReason = _data["callReason"];
            this.endDate = _data["endDate"];
            this.total = _data["total"];
            this.totalLocations = _data["totalLocations"];
        }
    }

    static fromJS(data: any): MetricsbyPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new MetricsbyPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callReason"] = this.callReason;
        data["endDate"] = this.endDate;
        data["total"] = this.total;
        data["totalLocations"] = this.totalLocations;
        return data;
    }
}

export interface IMetricsbyPeriod {
    callReason: SICallTypes;
    endDate?: string | undefined;
    total: number;
    totalLocations: number;
}

export class GetServiceMetricByTypeByPeriodRequest implements IGetServiceMetricByTypeByPeriodRequest {
    callType!: SICallTypes;
    metricType!: ServiceMetricTypes;
    filters!: FilterSet;

    constructor(data?: IGetServiceMetricByTypeByPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.metricType = _data["metricType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["metricType"] = this.metricType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricByTypeByPeriodRequest {
    callType: SICallTypes;
    metricType: ServiceMetricTypes;
    filters: FilterSet;
}

export class GetServiceMetricByTypeByLocationResponse implements IGetServiceMetricByTypeByLocationResponse {
    data?: MetricsByLocation[] | undefined;

    constructor(data?: IGetServiceMetricByTypeByLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MetricsByLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetServiceMetricByTypeByLocationResponse {
    data?: MetricsByLocation[] | undefined;
}

export class MetricsByLocation implements IMetricsByLocation {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    totalCalls!: number;
    recurringIssues!: number;
    sourceSystemCode?: string | undefined;
    surveyName?: string | undefined;
    surveyDurationInMin?: string | undefined;

    constructor(data?: IMetricsByLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.totalCalls = _data["totalCalls"];
            this.recurringIssues = _data["recurringIssues"];
            this.sourceSystemCode = _data["sourceSystemCode"];
            this.surveyName = _data["surveyName"];
            this.surveyDurationInMin = _data["surveyDurationInMin"];
        }
    }

    static fromJS(data: any): MetricsByLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MetricsByLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["totalCalls"] = this.totalCalls;
        data["recurringIssues"] = this.recurringIssues;
        data["sourceSystemCode"] = this.sourceSystemCode;
        data["surveyName"] = this.surveyName;
        data["surveyDurationInMin"] = this.surveyDurationInMin;
        return data;
    }
}

export interface IMetricsByLocation {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    totalCalls: number;
    recurringIssues: number;
    sourceSystemCode?: string | undefined;
    surveyName?: string | undefined;
    surveyDurationInMin?: string | undefined;
}

export class GetServiceMetricByTypeByLocationRequest implements IGetServiceMetricByTypeByLocationRequest {
    callType!: SICallTypes;
    filters!: FilterSet;

    constructor(data?: IGetServiceMetricByTypeByLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricByTypeByLocationRequest {
    callType: SICallTypes;
    filters: FilterSet;
}

export class GetServiceMetricByTypeByIssueResponse implements IGetServiceMetricByTypeByIssueResponse {
    data?: IssueCount[] | undefined;

    constructor(data?: IGetServiceMetricByTypeByIssueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssueCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByIssueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByIssueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetServiceMetricByTypeByIssueResponse {
    data?: IssueCount[] | undefined;
}

export class IssueCount implements IIssueCount {
    issueName?: string | undefined;
    callCount!: number;
    locations!: number;

    constructor(data?: IIssueCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueName = _data["issueName"];
            this.callCount = _data["callCount"];
            this.locations = _data["locations"];
        }
    }

    static fromJS(data: any): IssueCount {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueName"] = this.issueName;
        data["callCount"] = this.callCount;
        data["locations"] = this.locations;
        return data;
    }
}

export interface IIssueCount {
    issueName?: string | undefined;
    callCount: number;
    locations: number;
}

export class GetServiceMetricByTypeByIssueRequest implements IGetServiceMetricByTypeByIssueRequest {
    callType!: SICallTypes;
    filters!: FilterSet;

    constructor(data?: IGetServiceMetricByTypeByIssueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceMetricByTypeByIssueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricByTypeByIssueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricByTypeByIssueRequest {
    callType: SICallTypes;
    filters: FilterSet;
}

export class GetServiceInsightsByIssueTypeResponse implements IGetServiceInsightsByIssueTypeResponse {
    data?: ServiceInsight[] | undefined;

    constructor(data?: IGetServiceInsightsByIssueTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceInsight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServiceInsightsByIssueTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceInsightsByIssueTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetServiceInsightsByIssueTypeResponse {
    data?: ServiceInsight[] | undefined;
}

export class ServiceInsight implements IServiceInsight {
    observationName?: string | undefined;
    observationCount!: number;
    totalLocations!: number;
    addresses?: AddressDetail[] | undefined;

    constructor(data?: IServiceInsight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationName = _data["observationName"];
            this.observationCount = _data["observationCount"];
            this.totalLocations = _data["totalLocations"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceInsight {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationName"] = this.observationName;
        data["observationCount"] = this.observationCount;
        data["totalLocations"] = this.totalLocations;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceInsight {
    observationName?: string | undefined;
    observationCount: number;
    totalLocations: number;
    addresses?: AddressDetail[] | undefined;
}

export class AddressDetail implements IAddressDetail {
    address?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    shippingStreet?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingPostalCode?: string | undefined;
    shippingCountry?: string | undefined;

    constructor(data?: IAddressDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.shippingStreet = _data["shippingStreet"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingPostalCode = _data["shippingPostalCode"];
            this.shippingCountry = _data["shippingCountry"];
        }
    }

    static fromJS(data: any): AddressDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["shippingStreet"] = this.shippingStreet;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingPostalCode"] = this.shippingPostalCode;
        data["shippingCountry"] = this.shippingCountry;
        return data;
    }
}

export interface IAddressDetail {
    address?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    shippingStreet?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingPostalCode?: string | undefined;
    shippingCountry?: string | undefined;
}

export class GetServiceInsightsByIssueTypeRequest implements IGetServiceInsightsByIssueTypeRequest {
    issueType!: ServiceInsightsIssueType;
    filters!: FilterSet;

    constructor(data?: IGetServiceInsightsByIssueTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueType = _data["issueType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceInsightsByIssueTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceInsightsByIssueTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueType"] = this.issueType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceInsightsByIssueTypeRequest {
    issueType: ServiceInsightsIssueType;
    filters: FilterSet;
}

export enum ServiceInsightsIssueType {
    Overall = "Overall",
    Issues = "Issues",
    Recurring = "Recurring",
}

export class GetServiceDetailFiltersResponse implements IGetServiceDetailFiltersResponse {
    data?: ServiceDetailsAdvFiltersDTO[] | undefined;

    constructor(data?: IGetServiceDetailFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ServiceDetailsAdvFiltersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServiceDetailFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDetailFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetServiceDetailFiltersResponse {
    data?: ServiceDetailsAdvFiltersDTO[] | undefined;
}

export class ServiceDetailsAdvFiltersDTO implements IServiceDetailsAdvFiltersDTO {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    recurringIssue?: string | undefined;

    constructor(data?: IServiceDetailsAdvFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.recurringIssue = _data["recurringIssue"];
        }
    }

    static fromJS(data: any): ServiceDetailsAdvFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDetailsAdvFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["recurringIssue"] = this.recurringIssue;
        return data;
    }
}

export interface IServiceDetailsAdvFiltersDTO {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    recurringIssue?: string | undefined;
}

export class GetServiceDetailFiltersRequest implements IGetServiceDetailFiltersRequest {
    callType!: SICallTypes;
    filters!: FilterSet;

    constructor(data?: IGetServiceDetailFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceDetailFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDetailFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceDetailFiltersRequest {
    callType: SICallTypes;
    filters: FilterSet;
}

export class GetServiceCallPhotosByTypeResponse implements IGetServiceCallPhotosByTypeResponse {
    data?: FinalPhotosResult | undefined;

    constructor(data?: IGetServiceCallPhotosByTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FinalPhotosResult.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceCallPhotosByTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceCallPhotosByTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceCallPhotosByTypeResponse {
    data?: FinalPhotosResult | undefined;
}

export class FinalPhotosResult implements IFinalPhotosResult {
    count!: number;
    totalCount!: number;
    photos?: ExpandedPhotos[] | undefined;

    constructor(data?: IFinalPhotosResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(ExpandedPhotos.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinalPhotosResult {
        data = typeof data === 'object' ? data : {};
        let result = new FinalPhotosResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinalPhotosResult {
    count: number;
    totalCount: number;
    photos?: ExpandedPhotos[] | undefined;
}

export class ExpandedPhotos implements IExpandedPhotos {
    countOfCalls!: number;
    sortBy?: string | undefined;
    photos?: PhotoInfo[] | undefined;

    constructor(data?: IExpandedPhotos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countOfCalls = _data["countOfCalls"];
            this.sortBy = _data["sortBy"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(PhotoInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpandedPhotos {
        data = typeof data === 'object' ? data : {};
        let result = new ExpandedPhotos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countOfCalls"] = this.countOfCalls;
        data["sortBy"] = this.sortBy;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExpandedPhotos {
    countOfCalls: number;
    sortBy?: string | undefined;
    photos?: PhotoInfo[] | undefined;
}

export class PhotoInfo implements IPhotoInfo {
    workOrderId?: string | undefined;
    photoUrl?: string | undefined;
    description?: string | undefined;
    ecolabRepName?: string | undefined;
    endDate?: string | undefined;
    customerName?: string | undefined;
    accountNumber?: string | undefined;
    callReasonCode?: string | undefined;

    constructor(data?: IPhotoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"];
            this.photoUrl = _data["photoUrl"];
            this.description = _data["description"];
            this.ecolabRepName = _data["ecolabRepName"];
            this.endDate = _data["endDate"];
            this.customerName = _data["customerName"];
            this.accountNumber = _data["accountNumber"];
            this.callReasonCode = _data["callReasonCode"];
        }
    }

    static fromJS(data: any): PhotoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId;
        data["photoUrl"] = this.photoUrl;
        data["description"] = this.description;
        data["ecolabRepName"] = this.ecolabRepName;
        data["endDate"] = this.endDate;
        data["customerName"] = this.customerName;
        data["accountNumber"] = this.accountNumber;
        data["callReasonCode"] = this.callReasonCode;
        return data;
    }
}

export interface IPhotoInfo {
    workOrderId?: string | undefined;
    photoUrl?: string | undefined;
    description?: string | undefined;
    ecolabRepName?: string | undefined;
    endDate?: string | undefined;
    customerName?: string | undefined;
    accountNumber?: string | undefined;
    callReasonCode?: string | undefined;
}

export class GetServiceCallPhotosByTypeRequest implements IGetServiceCallPhotosByTypeRequest {
    callType!: SICallTypes;
    filters!: FilterSet;
    sortColumn!: ServiceCallDetailsSortColumn;
    pageRequest!: PageRequest;
    serviceCustomerFilters?: ServiceCustomerFilters | undefined;

    constructor(data?: IGetServiceCallPhotosByTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
            this.pageRequest = new PageRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.sortColumn = _data["sortColumn"];
            this.pageRequest = _data["pageRequest"] ? PageRequest.fromJS(_data["pageRequest"]) : new PageRequest();
            this.serviceCustomerFilters = _data["serviceCustomerFilters"] ? ServiceCustomerFilters.fromJS(_data["serviceCustomerFilters"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceCallPhotosByTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceCallPhotosByTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["sortColumn"] = this.sortColumn;
        data["pageRequest"] = this.pageRequest ? this.pageRequest.toJSON() : undefined as any;
        data["serviceCustomerFilters"] = this.serviceCustomerFilters ? this.serviceCustomerFilters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceCallPhotosByTypeRequest {
    callType: SICallTypes;
    filters: FilterSet;
    sortColumn: ServiceCallDetailsSortColumn;
    pageRequest: PageRequest;
    serviceCustomerFilters?: ServiceCustomerFilters | undefined;
}

export enum ServiceCallDetailsSortColumn {
    Issue = "Issue",
    EndDate = "EndDate",
    Location = "Location",
}

export class ServiceCustomerFilters implements IServiceCustomerFilters {
    accountNumber?: string[] | undefined;
    accountName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;
    recurringIssue?: string[] | undefined;

    constructor(data?: IServiceCustomerFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountNumber"])) {
                this.accountNumber = [] as any;
                for (let item of _data["accountNumber"])
                    this.accountNumber!.push(item);
            }
            if (Array.isArray(_data["accountName"])) {
                this.accountName = [] as any;
                for (let item of _data["accountName"])
                    this.accountName!.push(item);
            }
            if (Array.isArray(_data["country"])) {
                this.country = [] as any;
                for (let item of _data["country"])
                    this.country!.push(item);
            }
            if (Array.isArray(_data["state"])) {
                this.state = [] as any;
                for (let item of _data["state"])
                    this.state!.push(item);
            }
            if (Array.isArray(_data["city"])) {
                this.city = [] as any;
                for (let item of _data["city"])
                    this.city!.push(item);
            }
            if (Array.isArray(_data["zipCode"])) {
                this.zipCode = [] as any;
                for (let item of _data["zipCode"])
                    this.zipCode!.push(item);
            }
            if (Array.isArray(_data["recurringIssue"])) {
                this.recurringIssue = [] as any;
                for (let item of _data["recurringIssue"])
                    this.recurringIssue!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceCustomerFilters {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCustomerFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountNumber)) {
            data["accountNumber"] = [];
            for (let item of this.accountNumber)
                data["accountNumber"].push(item);
        }
        if (Array.isArray(this.accountName)) {
            data["accountName"] = [];
            for (let item of this.accountName)
                data["accountName"].push(item);
        }
        if (Array.isArray(this.country)) {
            data["country"] = [];
            for (let item of this.country)
                data["country"].push(item);
        }
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item);
        }
        if (Array.isArray(this.city)) {
            data["city"] = [];
            for (let item of this.city)
                data["city"].push(item);
        }
        if (Array.isArray(this.zipCode)) {
            data["zipCode"] = [];
            for (let item of this.zipCode)
                data["zipCode"].push(item);
        }
        if (Array.isArray(this.recurringIssue)) {
            data["recurringIssue"] = [];
            for (let item of this.recurringIssue)
                data["recurringIssue"].push(item);
        }
        return data;
    }
}

export interface IServiceCustomerFilters {
    accountNumber?: string[] | undefined;
    accountName?: string[] | undefined;
    country?: string[] | undefined;
    state?: string[] | undefined;
    city?: string[] | undefined;
    zipCode?: string[] | undefined;
    recurringIssue?: string[] | undefined;
}

export class GetServiceCallDetailsByTypeResponse implements IGetServiceCallDetailsByTypeResponse {
    data?: FinalInsightResult | undefined;

    constructor(data?: IGetServiceCallDetailsByTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FinalInsightResult.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceCallDetailsByTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceCallDetailsByTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceCallDetailsByTypeResponse {
    data?: FinalInsightResult | undefined;
}

export class FinalInsightResult implements IFinalInsightResult {
    totalCount!: number;
    records?: ExpandedResult[] | undefined;
    next?: Next | undefined;

    constructor(data?: IFinalInsightResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ExpandedResult.fromJS(item));
            }
            this.next = _data["next"] ? Next.fromJS(_data["next"]) : undefined as any;
        }
    }

    static fromJS(data: any): FinalInsightResult {
        data = typeof data === 'object' ? data : {};
        let result = new FinalInsightResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["next"] = this.next ? this.next.toJSON() : undefined as any;
        return data;
    }
}

export interface IFinalInsightResult {
    totalCount: number;
    records?: ExpandedResult[] | undefined;
    next?: Next | undefined;
}

export class ExpandedResult implements IExpandedResult {
    shippingStreet!: string;
    shippingCity!: string;
    shippingState!: string;
    shippingPostalCd!: string;
    shippingCountry!: string;
    accountName!: string;
    accountNumber!: string;
    unitNumber!: string;
    workOrderId!: string;
    observationName!: string;
    callReason?: string | undefined;
    status!: string;
    startDate?: string | undefined;
    endDate!: string;
    callSummaryNotes!: string;
    trainingCallComments?: string | undefined;
    trainingManager?: string | undefined;
    trainingTopic?: string | undefined;
    workOrderLineItemId?: string | undefined;
    installationCallComments?: string | undefined;
    quickCallComments?: string | undefined;
    esrCallComments?: string | undefined;
    walkthrough!: boolean;
    participants!: number;
    participantNames?: string | undefined;
    trainingPerformed!: boolean;
    ecolabRep!: string;
    equipmentLocation?: string | undefined;
    equipmentType?: string | undefined;
    recurringIssues!: number;
    frontOfHouse!: string;
    backOfHouse!: string;
    /** Represents total observations or issues for a row in Expanded table 
(depending on selected tab. issues for By Issues, obs for others) */
    totalRowCount!: number;
    specificObs!: string[];
    photoInfo!: PhotoInfoDTO[];
    measurement?: string | undefined;
    observationComments?: string | undefined;
    obsId?: string | undefined;
    virtualVisit!: boolean;
    pdfBaseUrl!: string;
    sourceSystemCode?: string | undefined;
    surveyName?: string | undefined;
    surveyDurationInMin?: string | undefined;

    constructor(data?: IExpandedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.specificObs = [];
            this.photoInfo = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shippingStreet = _data["shippingStreet"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingPostalCd = _data["shippingPostalCd"];
            this.shippingCountry = _data["shippingCountry"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.unitNumber = _data["unitNumber"];
            this.workOrderId = _data["workOrderId"];
            this.observationName = _data["observationName"];
            this.callReason = _data["callReason"];
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.callSummaryNotes = _data["callSummaryNotes"];
            this.trainingCallComments = _data["trainingCallComments"];
            this.trainingManager = _data["trainingManager"];
            this.trainingTopic = _data["trainingTopic"];
            this.workOrderLineItemId = _data["workOrderLineItemId"];
            this.installationCallComments = _data["installationCallComments"];
            this.quickCallComments = _data["quickCallComments"];
            this.esrCallComments = _data["esrCallComments"];
            this.walkthrough = _data["walkthrough"];
            this.participants = _data["participants"];
            this.participantNames = _data["participantNames"];
            this.trainingPerformed = _data["trainingPerformed"];
            this.ecolabRep = _data["ecolabRep"];
            this.equipmentLocation = _data["equipmentLocation"];
            this.equipmentType = _data["equipmentType"];
            this.recurringIssues = _data["recurringIssues"];
            this.frontOfHouse = _data["frontOfHouse"];
            this.backOfHouse = _data["backOfHouse"];
            this.totalRowCount = _data["totalRowCount"];
            if (Array.isArray(_data["specificObs"])) {
                this.specificObs = [] as any;
                for (let item of _data["specificObs"])
                    this.specificObs!.push(item);
            }
            if (Array.isArray(_data["photoInfo"])) {
                this.photoInfo = [] as any;
                for (let item of _data["photoInfo"])
                    this.photoInfo!.push(PhotoInfoDTO.fromJS(item));
            }
            this.measurement = _data["measurement"];
            this.observationComments = _data["observationComments"];
            this.obsId = _data["obsId"];
            this.virtualVisit = _data["virtualVisit"];
            this.pdfBaseUrl = _data["pdfBaseUrl"];
            this.sourceSystemCode = _data["sourceSystemCode"];
            this.surveyName = _data["surveyName"];
            this.surveyDurationInMin = _data["surveyDurationInMin"];
        }
    }

    static fromJS(data: any): ExpandedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExpandedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shippingStreet"] = this.shippingStreet;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingPostalCd"] = this.shippingPostalCd;
        data["shippingCountry"] = this.shippingCountry;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["unitNumber"] = this.unitNumber;
        data["workOrderId"] = this.workOrderId;
        data["observationName"] = this.observationName;
        data["callReason"] = this.callReason;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["callSummaryNotes"] = this.callSummaryNotes;
        data["trainingCallComments"] = this.trainingCallComments;
        data["trainingManager"] = this.trainingManager;
        data["trainingTopic"] = this.trainingTopic;
        data["workOrderLineItemId"] = this.workOrderLineItemId;
        data["installationCallComments"] = this.installationCallComments;
        data["quickCallComments"] = this.quickCallComments;
        data["esrCallComments"] = this.esrCallComments;
        data["walkthrough"] = this.walkthrough;
        data["participants"] = this.participants;
        data["participantNames"] = this.participantNames;
        data["trainingPerformed"] = this.trainingPerformed;
        data["ecolabRep"] = this.ecolabRep;
        data["equipmentLocation"] = this.equipmentLocation;
        data["equipmentType"] = this.equipmentType;
        data["recurringIssues"] = this.recurringIssues;
        data["frontOfHouse"] = this.frontOfHouse;
        data["backOfHouse"] = this.backOfHouse;
        data["totalRowCount"] = this.totalRowCount;
        if (Array.isArray(this.specificObs)) {
            data["specificObs"] = [];
            for (let item of this.specificObs)
                data["specificObs"].push(item);
        }
        if (Array.isArray(this.photoInfo)) {
            data["photoInfo"] = [];
            for (let item of this.photoInfo)
                data["photoInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["measurement"] = this.measurement;
        data["observationComments"] = this.observationComments;
        data["obsId"] = this.obsId;
        data["virtualVisit"] = this.virtualVisit;
        data["pdfBaseUrl"] = this.pdfBaseUrl;
        data["sourceSystemCode"] = this.sourceSystemCode;
        data["surveyName"] = this.surveyName;
        data["surveyDurationInMin"] = this.surveyDurationInMin;
        return data;
    }
}

export interface IExpandedResult {
    shippingStreet: string;
    shippingCity: string;
    shippingState: string;
    shippingPostalCd: string;
    shippingCountry: string;
    accountName: string;
    accountNumber: string;
    unitNumber: string;
    workOrderId: string;
    observationName: string;
    callReason?: string | undefined;
    status: string;
    startDate?: string | undefined;
    endDate: string;
    callSummaryNotes: string;
    trainingCallComments?: string | undefined;
    trainingManager?: string | undefined;
    trainingTopic?: string | undefined;
    workOrderLineItemId?: string | undefined;
    installationCallComments?: string | undefined;
    quickCallComments?: string | undefined;
    esrCallComments?: string | undefined;
    walkthrough: boolean;
    participants: number;
    participantNames?: string | undefined;
    trainingPerformed: boolean;
    ecolabRep: string;
    equipmentLocation?: string | undefined;
    equipmentType?: string | undefined;
    recurringIssues: number;
    frontOfHouse: string;
    backOfHouse: string;
    /** Represents total observations or issues for a row in Expanded table 
(depending on selected tab. issues for By Issues, obs for others) */
    totalRowCount: number;
    specificObs: string[];
    photoInfo: PhotoInfoDTO[];
    measurement?: string | undefined;
    observationComments?: string | undefined;
    obsId?: string | undefined;
    virtualVisit: boolean;
    pdfBaseUrl: string;
    sourceSystemCode?: string | undefined;
    surveyName?: string | undefined;
    surveyDurationInMin?: string | undefined;
}

export class PhotoInfoDTO implements IPhotoInfoDTO {
    url?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPhotoInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PhotoInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["description"] = this.description;
        return data;
    }
}

export interface IPhotoInfoDTO {
    url?: string | undefined;
    description?: string | undefined;
}

export class Next implements INext {
    available!: boolean;
    uri?: string | undefined;

    constructor(data?: INext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.available = _data["available"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): Next {
        data = typeof data === 'object' ? data : {};
        let result = new Next();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["available"] = this.available;
        data["uri"] = this.uri;
        return data;
    }
}

export interface INext {
    available: boolean;
    uri?: string | undefined;
}

export class GetServiceCallDetailsByTypeRequest implements IGetServiceCallDetailsByTypeRequest {
    callType!: SICallTypes;
    filters!: FilterSet;
    sortColumn!: ServiceCallDetailsSortColumn;
    pageRequest!: PageRequest;
    graphDetailFilter?: string | undefined;
    serviceCustomerFilters?: ServiceCustomerFilters | undefined;

    constructor(data?: IGetServiceCallDetailsByTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
            this.pageRequest = new PageRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callType = _data["callType"];
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
            this.sortColumn = _data["sortColumn"];
            this.pageRequest = _data["pageRequest"] ? PageRequest.fromJS(_data["pageRequest"]) : new PageRequest();
            this.graphDetailFilter = _data["graphDetailFilter"];
            this.serviceCustomerFilters = _data["serviceCustomerFilters"] ? ServiceCustomerFilters.fromJS(_data["serviceCustomerFilters"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceCallDetailsByTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceCallDetailsByTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callType"] = this.callType;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        data["sortColumn"] = this.sortColumn;
        data["pageRequest"] = this.pageRequest ? this.pageRequest.toJSON() : undefined as any;
        data["graphDetailFilter"] = this.graphDetailFilter;
        data["serviceCustomerFilters"] = this.serviceCustomerFilters ? this.serviceCustomerFilters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceCallDetailsByTypeRequest {
    callType: SICallTypes;
    filters: FilterSet;
    sortColumn: ServiceCallDetailsSortColumn;
    pageRequest: PageRequest;
    graphDetailFilter?: string | undefined;
    serviceCustomerFilters?: ServiceCustomerFilters | undefined;
}

export class GetLocationInsightsResponse implements IGetLocationInsightsResponse {
    data?: LocationInsightModel[] | undefined;

    constructor(data?: IGetLocationInsightsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocationInsightModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLocationInsightsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationInsightsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLocationInsightsResponse {
    data?: LocationInsightModel[] | undefined;
}

export class LocationInsightModel implements ILocationInsightModel {
    address?: string | undefined;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    extraServiceCalls!: number;
    vsAvg!: number;
    issues!: number;
    recurringIssues!: number;
    highPrevIssue?: string | undefined;
    highPrevRecurringIssue?: string | undefined;
    avgESR!: number;

    constructor(data?: ILocationInsightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.extraServiceCalls = _data["extraServiceCalls"];
            this.vsAvg = _data["vsAvg"];
            this.issues = _data["issues"];
            this.recurringIssues = _data["recurringIssues"];
            this.highPrevIssue = _data["highPrevIssue"];
            this.highPrevRecurringIssue = _data["highPrevRecurringIssue"];
            this.avgESR = _data["avgESR"];
        }
    }

    static fromJS(data: any): LocationInsightModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationInsightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["extraServiceCalls"] = this.extraServiceCalls;
        data["vsAvg"] = this.vsAvg;
        data["issues"] = this.issues;
        data["recurringIssues"] = this.recurringIssues;
        data["highPrevIssue"] = this.highPrevIssue;
        data["highPrevRecurringIssue"] = this.highPrevRecurringIssue;
        data["avgESR"] = this.avgESR;
        return data;
    }
}

export interface ILocationInsightModel {
    address?: string | undefined;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    extraServiceCalls: number;
    vsAvg: number;
    issues: number;
    recurringIssues: number;
    highPrevIssue?: string | undefined;
    highPrevRecurringIssue?: string | undefined;
    avgESR: number;
}

export class GetLocationInsightsRequest implements IGetLocationInsightsRequest {
    filters!: FilterSet;

    constructor(data?: IGetLocationInsightsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetLocationInsightsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationInsightsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLocationInsightsRequest {
    filters: FilterSet;
}

export class GetServiceMetricCountsSummaryResponse implements IGetServiceMetricCountsSummaryResponse {
    data?: ServiceInsightsMetricCountsSummary | undefined;

    constructor(data?: IGetServiceMetricCountsSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ServiceInsightsMetricCountsSummary.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceMetricCountsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricCountsSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricCountsSummaryResponse {
    data?: ServiceInsightsMetricCountsSummary | undefined;
}

export class ServiceInsightsMetricCountsSummary implements IServiceInsightsMetricCountsSummary {
    callTypeCounts?: { [key in keyof typeof SICallTypes]?: ServiceInsightsMetricCountDetails; } | undefined;
    trainingBreakdown?: ServiceInsightsTrainingBreakdown | undefined;

    constructor(data?: IServiceInsightsMetricCountsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["callTypeCounts"]) {
                this.callTypeCounts = {} as any;
                for (let key in _data["callTypeCounts"]) {
                    if (_data["callTypeCounts"].hasOwnProperty(key))
                        (this.callTypeCounts as any)![key] = _data["callTypeCounts"][key] ? ServiceInsightsMetricCountDetails.fromJS(_data["callTypeCounts"][key]) : new ServiceInsightsMetricCountDetails();
                }
            }
            this.trainingBreakdown = _data["trainingBreakdown"] ? ServiceInsightsTrainingBreakdown.fromJS(_data["trainingBreakdown"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceInsightsMetricCountsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsMetricCountsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.callTypeCounts) {
            data["callTypeCounts"] = {};
            for (let key in this.callTypeCounts) {
                if (this.callTypeCounts.hasOwnProperty(key))
                    (data["callTypeCounts"] as any)[key] = this.callTypeCounts[key as keyof typeof SICallTypes] ? this.callTypeCounts[key as keyof typeof SICallTypes]!.toJSON() : undefined as any;
            }
        }
        data["trainingBreakdown"] = this.trainingBreakdown ? this.trainingBreakdown.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceInsightsMetricCountsSummary {
    callTypeCounts?: { [key in keyof typeof SICallTypes]?: ServiceInsightsMetricCountDetails; } | undefined;
    trainingBreakdown?: ServiceInsightsTrainingBreakdown | undefined;
}

export class ServiceInsightsMetricCountDetails implements IServiceInsightsMetricCountDetails {
    total!: number;
    percentageChange?: number | undefined;
    avgPerLocation?: number | undefined;
    locations?: number | undefined;

    constructor(data?: IServiceInsightsMetricCountDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.percentageChange = _data["percentageChange"];
            this.avgPerLocation = _data["avgPerLocation"];
            this.locations = _data["locations"];
        }
    }

    static fromJS(data: any): ServiceInsightsMetricCountDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsMetricCountDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["percentageChange"] = this.percentageChange;
        data["avgPerLocation"] = this.avgPerLocation;
        data["locations"] = this.locations;
        return data;
    }
}

export interface IServiceInsightsMetricCountDetails {
    total: number;
    percentageChange?: number | undefined;
    avgPerLocation?: number | undefined;
    locations?: number | undefined;
}

export class ServiceInsightsTrainingBreakdown implements IServiceInsightsTrainingBreakdown {
    trainingSessions?: ServiceInsightsMetricCountDetails | undefined;
    dedicatedTrainingCalls?: ServiceInsightsMetricCountDetails | undefined;
    trainingTopics?: ServiceInsightsMetricCountDetails | undefined;
    inServiceTraining?: ServiceInsightsMetricCountDetails | undefined;

    constructor(data?: IServiceInsightsTrainingBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingSessions = _data["trainingSessions"] ? ServiceInsightsMetricCountDetails.fromJS(_data["trainingSessions"]) : undefined as any;
            this.dedicatedTrainingCalls = _data["dedicatedTrainingCalls"] ? ServiceInsightsMetricCountDetails.fromJS(_data["dedicatedTrainingCalls"]) : undefined as any;
            this.trainingTopics = _data["trainingTopics"] ? ServiceInsightsMetricCountDetails.fromJS(_data["trainingTopics"]) : undefined as any;
            this.inServiceTraining = _data["inServiceTraining"] ? ServiceInsightsMetricCountDetails.fromJS(_data["inServiceTraining"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceInsightsTrainingBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInsightsTrainingBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingSessions"] = this.trainingSessions ? this.trainingSessions.toJSON() : undefined as any;
        data["dedicatedTrainingCalls"] = this.dedicatedTrainingCalls ? this.dedicatedTrainingCalls.toJSON() : undefined as any;
        data["trainingTopics"] = this.trainingTopics ? this.trainingTopics.toJSON() : undefined as any;
        data["inServiceTraining"] = this.inServiceTraining ? this.inServiceTraining.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceInsightsTrainingBreakdown {
    trainingSessions?: ServiceInsightsMetricCountDetails | undefined;
    dedicatedTrainingCalls?: ServiceInsightsMetricCountDetails | undefined;
    trainingTopics?: ServiceInsightsMetricCountDetails | undefined;
    inServiceTraining?: ServiceInsightsMetricCountDetails | undefined;
}

export class GetServiceMetricCountsSummaryRequest implements IGetServiceMetricCountsSummaryRequest {
    filters!: FilterSet;

    constructor(data?: IGetServiceMetricCountsSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.filters = new FilterSet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? FilterSet.fromJS(_data["filters"]) : new FilterSet();
        }
    }

    static fromJS(data: any): GetServiceMetricCountsSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceMetricCountsSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceMetricCountsSummaryRequest {
    filters: FilterSet;
}

export class HealthCheckResult implements IHealthCheckResult {
    data!: { [key: string]: any; };
    description?: string | undefined;
    exception?: Exception | undefined;
    status!: HealthStatus;

    constructor(data?: IHealthCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.exception = _data["exception"] ? Exception.fromJS(_data["exception"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HealthCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        data["description"] = this.description;
        data["exception"] = this.exception ? this.exception.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResult {
    data: { [key: string]: any; };
    description?: string | undefined;
    exception?: Exception | undefined;
    status: HealthStatus;
}

export class Exception implements IException {
    message!: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : undefined as any;
            this.source = _data["Source"];
            this.stackTrace = _data["StackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : undefined as any;
        data["Source"] = this.source;
        data["StackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IException {
    message: string;
    innerException?: Exception | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;
}

export enum HealthStatus {
    Unhealthy = "Unhealthy",
    Degraded = "Degraded",
    Healthy = "Healthy",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}